// Master Roster of 745 Verified Registered Candidates
// Generated from MASTER_PHASE2_REGISTRATIONS_BACKUP.xlsx
export interface MasterCandidate {
  registrationNumber: string;
  docId: string;
  name: string;
  mobile: string;
  dob: string;
  district: string;
  regNoSuffix: string;
}

export const MASTER_REGISTERED_CANDIDATES: MasterCandidate[] = [
  {
    "registrationNumber": "KOP/2026/09/0001",
    "docId": "KOP-2026-09-0001",
    "name": "MANOJ KUMAR NAMULIPARI",
    "mobile": "7008299028",
    "dob": "2000-01-01",
    "district": "Rayagada",
    "regNoSuffix": "0001"
  },
  {
    "registrationNumber": "KOP/2026/09/0002",
    "docId": "KOP-2026-09-0002",
    "name": "LALIT SAHU",
    "mobile": "8658453031",
    "dob": "2000-01-01",
    "district": "Kalahandi",
    "regNoSuffix": "0002"
  },
  {
    "registrationNumber": "KOP/2026/09/0003",
    "docId": "KOP-2026-09-0003",
    "name": "HITESH KUMAR CHOUDHURY",
    "mobile": "8093616716",
    "dob": "2000-01-01",
    "district": "Rayagada",
    "regNoSuffix": "0003"
  },
  {
    "registrationNumber": "KOP/2026/09/0004",
    "docId": "KOP-2026-09-0004",
    "name": "AMIT RATNALU",
    "mobile": "6371730065",
    "dob": "1000-01-01",
    "district": "Rayagada",
    "regNoSuffix": "0004"
  },
  {
    "registrationNumber": "KOP/2026/09/0005",
    "docId": "KOP-2026-09-0005",
    "name": "SUBARAO KUNDIKA",
    "mobile": "8895885464",
    "dob": "2000-01-01",
    "district": "Rayagada",
    "regNoSuffix": "0005"
  },
  {
    "registrationNumber": "KOP/2026/09/0006",
    "docId": "KOP-2026-09-0006",
    "name": "AMIT KUMAR PANDA",
    "mobile": "8018606882",
    "dob": "2000-01-01",
    "district": "Nuapada",
    "regNoSuffix": "0006"
  },
  {
    "registrationNumber": "KOP/2026/09/0007",
    "docId": "KOP-2026-09-0007",
    "name": "PRANAMIKA BEHERA",
    "mobile": "7682888904",
    "dob": "2000-01-01",
    "district": "Nuapada",
    "regNoSuffix": "0007"
  },
  {
    "registrationNumber": "KOP/2026/09/0008",
    "docId": "KOP-2026-09-0008",
    "name": "MANOJ GOND",
    "mobile": "7077692718",
    "dob": "2000-01-01",
    "district": "Nabarangpur",
    "regNoSuffix": "0008"
  },
  {
    "registrationNumber": "KOP/2026/09/0009",
    "docId": "KOP-2026-09-0009",
    "name": "SWARNA PRAVA BISWAL",
    "mobile": "8093068814",
    "dob": "2000-01-01",
    "district": "Balasore",
    "regNoSuffix": "0009"
  },
  {
    "registrationNumber": "KOP/2026/09/0010",
    "docId": "KOP-2026-09-0010",
    "name": "KISHOR KUMAR HAWALDAR",
    "mobile": "9777140708",
    "dob": "2000-01-01",
    "district": "Nabarangpur",
    "regNoSuffix": "0010"
  },
  {
    "registrationNumber": "KOP/2026/09/0011",
    "docId": "KOP-2026-09-0011",
    "name": "ASHIKANTA SAHOO",
    "mobile": "7205146842",
    "dob": "2000-01-01",
    "district": "Cuttack",
    "regNoSuffix": "0011"
  },
  {
    "registrationNumber": "KOP/2026/09/0012",
    "docId": "KOP-2026-09-0012",
    "name": "GOBINDA CHANDRA SAI",
    "mobile": "8908629551",
    "dob": "2000-01-01",
    "district": "Balangir",
    "regNoSuffix": "0012"
  },
  {
    "registrationNumber": "KOP/2026/09/0013",
    "docId": "KOP-2026-09-0013",
    "name": "BISWANATH PANDE",
    "mobile": "6371079275",
    "dob": "2000-02-02",
    "district": "Sonepur",
    "regNoSuffix": "0013"
  },
  {
    "registrationNumber": "KOP/2026/09/0014",
    "docId": "KOP-2026-09-0014",
    "name": "SRITAM PADHAN",
    "mobile": "9777650995",
    "dob": "2000-12-01",
    "district": "Sonepur",
    "regNoSuffix": "0014"
  },
  {
    "registrationNumber": "KOP/2026/09/0015",
    "docId": "KOP-2026-09-0015",
    "name": "RUPESHWAR MALLICK",
    "mobile": "6370014887",
    "dob": "2000-01-01",
    "district": "Sonepur",
    "regNoSuffix": "0015"
  },
  {
    "registrationNumber": "KOP/2026/09/0016",
    "docId": "KOP-2026-09-0016",
    "name": "SIDHARTHA RANJAN NAYAK",
    "mobile": "9348024142",
    "dob": "2000-01-01",
    "district": "Dhenkanal",
    "regNoSuffix": "0016"
  },
  {
    "registrationNumber": "KOP/2026/09/0017",
    "docId": "KOP-2026-09-0017",
    "name": "LAXMIPRIYA BEHERA",
    "mobile": "7008116619",
    "dob": "2000-01-01",
    "district": "Dhenkanal",
    "regNoSuffix": "0017"
  },
  {
    "registrationNumber": "KOP/2026/09/0018",
    "docId": "KOP-2026-09-0018",
    "name": "SHRABANI NAYAK",
    "mobile": "7894949010",
    "dob": "2000-01-01",
    "district": "Dhenkanal",
    "regNoSuffix": "0018"
  },
  {
    "registrationNumber": "KOP/2026/09/0019",
    "docId": "KOP-2026-09-0019",
    "name": "RAJENDRA KUMBHAR",
    "mobile": "8917279156",
    "dob": "2000-01-01",
    "district": "Sonepur",
    "regNoSuffix": "0019"
  },
  {
    "registrationNumber": "KOP/2026/09/0021",
    "docId": "KOP-2026-09-0021",
    "name": "ANANYA SIKDAR",
    "mobile": "7897434490",
    "dob": "2000-01-01",
    "district": "Malkangiri",
    "regNoSuffix": "0021"
  },
  {
    "registrationNumber": "KOP/2026/09/0022",
    "docId": "KOP-2026-09-0022",
    "name": "MANAS KUMAR MAHARANA",
    "mobile": "7328044039",
    "dob": "2000-01-01",
    "district": "Sonepur",
    "regNoSuffix": "0022"
  },
  {
    "registrationNumber": "KOP/2026/09/0023",
    "docId": "KOP-2026-09-0023",
    "name": "SANDHYARANI MAHAPATRA",
    "mobile": "9078990233",
    "dob": "2000-01-01",
    "district": "Sonepur",
    "regNoSuffix": "0023"
  },
  {
    "registrationNumber": "KOP/2026/09/0024",
    "docId": "KOP-2026-09-0024",
    "name": "SUSMITA BAGHAR",
    "mobile": "9777702850",
    "dob": "2000-01-01",
    "district": "Sonepur",
    "regNoSuffix": "0024"
  },
  {
    "registrationNumber": "KOP/2026/09/0025",
    "docId": "KOP-2026-09-0025",
    "name": "MANAS PADHAN",
    "mobile": "9861496350",
    "dob": "2000-01-01",
    "district": "Sonepur",
    "regNoSuffix": "0025"
  },
  {
    "registrationNumber": "KOP/2026/09/0026",
    "docId": "KOP-2026-09-0026",
    "name": "PRATIBHAMAYEE PANDA",
    "mobile": "8117031794",
    "dob": "2000-01-01",
    "district": "Sonepur",
    "regNoSuffix": "0026"
  },
  {
    "registrationNumber": "KOP/2026/09/0027",
    "docId": "KOP-2026-09-0027",
    "name": "PAPUN NAYAK",
    "mobile": "9178761201",
    "dob": "2000-02-02",
    "district": "Sonepur",
    "regNoSuffix": "0027"
  },
  {
    "registrationNumber": "KOP/2026/09/0028",
    "docId": "KOP-2026-09-0028",
    "name": "SASMITA NAIK",
    "mobile": "9609878532",
    "dob": "2000-02-02",
    "district": "Sambalpur",
    "regNoSuffix": "0028"
  },
  {
    "registrationNumber": "KOP/2026/09/0029",
    "docId": "KOP-2026-09-0029",
    "name": "PREETIRANI MEHER",
    "mobile": "7077247692",
    "dob": "2000-02-01",
    "district": "Kandhamal",
    "regNoSuffix": "0029"
  },
  {
    "registrationNumber": "KOP/2026/09/0030",
    "docId": "KOP-2026-09-0030",
    "name": "PRADIP SAHU",
    "mobile": "7735106646",
    "dob": "2004-06-01",
    "district": "Sonepur",
    "regNoSuffix": "0030"
  },
  {
    "registrationNumber": "KOP/2026/09/0031",
    "docId": "KOP-2026-09-0031",
    "name": "HEMANTA KUMAR NEMALAPURI",
    "mobile": "9861119791",
    "dob": "2000-02-02",
    "district": "Rayagada",
    "regNoSuffix": "0031"
  },
  {
    "registrationNumber": "KOP/2026/09/0032",
    "docId": "KOP-2026-09-0032",
    "name": "AJIT KUMAR PANDA",
    "mobile": "9778485832",
    "dob": "2000-02-02",
    "district": "Sonepur",
    "regNoSuffix": "0032"
  },
  {
    "registrationNumber": "KOP/2026/09/0033",
    "docId": "KOP-2026-09-0033",
    "name": "PARESH KUMAR SAHU",
    "mobile": "9348803265",
    "dob": "2000-02-02",
    "district": "Sonepur",
    "regNoSuffix": "0033"
  },
  {
    "registrationNumber": "KOP/2026/09/0034",
    "docId": "KOP-2026-09-0034",
    "name": "ANJALI PANDA",
    "mobile": "9937774333",
    "dob": "2000-01-02",
    "district": "Nuapada",
    "regNoSuffix": "0034"
  },
  {
    "registrationNumber": "KOP/2026/09/0035",
    "docId": "KOP-2026-09-0035",
    "name": "RAMESWAR KUDAI",
    "mobile": "7327964836",
    "dob": "2000-02-02",
    "district": "Sonepur",
    "regNoSuffix": "0035"
  },
  {
    "registrationNumber": "KOP/2026/09/0036",
    "docId": "KOP-2026-09-0036",
    "name": "SHIBANI BISHI",
    "mobile": "7008016150",
    "dob": "2000-03-03",
    "district": "Sonepur",
    "regNoSuffix": "0036"
  },
  {
    "registrationNumber": "KOP/2026/09/0037",
    "docId": "KOP-2026-09-0037",
    "name": "PRAGNYA PRAKASH",
    "mobile": "7609977737",
    "dob": "2000-02-02",
    "district": "Malkangiri",
    "regNoSuffix": "0037"
  },
  {
    "registrationNumber": "KOP/2026/09/0038",
    "docId": "KOP-2026-09-0038",
    "name": "SANJAYA KAND",
    "mobile": "6371817500",
    "dob": "2000-02-02",
    "district": "Kalahandi",
    "regNoSuffix": "0038"
  },
  {
    "registrationNumber": "KOP/2026/09/0039",
    "docId": "KOP-2026-09-0039",
    "name": "LIZA BARIK",
    "mobile": "7853837116",
    "dob": "2000-02-02",
    "district": "Sonepur",
    "regNoSuffix": "0039"
  },
  {
    "registrationNumber": "KOP/2026/09/0040",
    "docId": "KOP-2026-09-0040",
    "name": "PRADEEP KUMAR PRADHAN",
    "mobile": "7077402484",
    "dob": "2000-02-02",
    "district": "Sonepur",
    "regNoSuffix": "0040"
  },
  {
    "registrationNumber": "KOP/2026/09/0041",
    "docId": "KOP-2026-09-0041",
    "name": "BABLI PADHAN",
    "mobile": "8984616358",
    "dob": "2000-02-09",
    "district": "Sonepur",
    "regNoSuffix": "0041"
  },
  {
    "registrationNumber": "KOP/2026/09/0042",
    "docId": "KOP-2026-09-0042",
    "name": "DIPANJALI MEHER",
    "mobile": "9348629228",
    "dob": "2000-03-03",
    "district": "Balangir",
    "regNoSuffix": "0042"
  },
  {
    "registrationNumber": "KOP/2026/09/0043",
    "docId": "KOP-2026-09-0043",
    "name": "ASWINI KUMARI NAGABANSO",
    "mobile": "7735598533",
    "dob": "2000-02-02",
    "district": "Gajapati",
    "regNoSuffix": "0043"
  },
  {
    "registrationNumber": "KOP/2026/09/0044",
    "docId": "KOP-2026-09-0044",
    "name": "MUDIYALU MEENA",
    "mobile": "8249233668",
    "dob": "2000-02-02",
    "district": "Gajapati",
    "regNoSuffix": "0044"
  },
  {
    "registrationNumber": "KOP/2026/09/0045",
    "docId": "KOP-2026-09-0045",
    "name": "PADMINI NAIK",
    "mobile": "7735667604",
    "dob": "2000-02-02",
    "district": "Balangir",
    "regNoSuffix": "0045"
  },
  {
    "registrationNumber": "KOP/2026/09/0046",
    "docId": "KOP-2026-09-0046",
    "name": "PURUSOTTAM MAHALING",
    "mobile": "7854980813",
    "dob": "2000-02-01",
    "district": "Balangir",
    "regNoSuffix": "0046"
  },
  {
    "registrationNumber": "KOP/2026/09/0047",
    "docId": "KOP-2026-09-0047",
    "name": "ABINASH MEHER",
    "mobile": "6371673823",
    "dob": "2000-03-03",
    "district": "Nuapada",
    "regNoSuffix": "0047"
  },
  {
    "registrationNumber": "KOP/2026/09/0048",
    "docId": "KOP-2026-09-0048",
    "name": "RAKESH GAHIR",
    "mobile": "8114774094",
    "dob": "2000-02-02",
    "district": "Nuapada",
    "regNoSuffix": "0048"
  },
  {
    "registrationNumber": "KOP/2026/09/0049",
    "docId": "KOP-2026-09-0049",
    "name": "RASMITA PADHAN",
    "mobile": "7894412684",
    "dob": "2000-02-02",
    "district": "Balangir",
    "regNoSuffix": "0049"
  },
  {
    "registrationNumber": "KOP/2026/09/0050",
    "docId": "KOP-2026-09-0050",
    "name": "ITISHREE PADHAN",
    "mobile": "6371835278",
    "dob": "2000-02-02",
    "district": "Sonepur",
    "regNoSuffix": "0050"
  },
  {
    "registrationNumber": "KOP/2026/09/0051",
    "docId": "KOP-2026-09-0051",
    "name": "HARISCHANDRA PADHAN",
    "mobile": "6371121721",
    "dob": "2000-02-02",
    "district": "Sonepur",
    "regNoSuffix": "0051"
  },
  {
    "registrationNumber": "KOP/2026/09/0052",
    "docId": "KOP-2026-09-0052",
    "name": "ADYASHA NAYAK",
    "mobile": "9348432022",
    "dob": "2000-02-02",
    "district": "Sonepur",
    "regNoSuffix": "0052"
  },
  {
    "registrationNumber": "KOP/2026/09/0053",
    "docId": "KOP-2026-09-0053",
    "name": "NAROTTAM BISWAL",
    "mobile": "9776524337",
    "dob": "2000-02-02",
    "district": "Balasore",
    "regNoSuffix": "0053"
  },
  {
    "registrationNumber": "KOP/2026/09/0054",
    "docId": "KOP-2026-09-0054",
    "name": "SHIBASHANKAR BISWAS",
    "mobile": "9827696648",
    "dob": "2000-02-02",
    "district": "Nabarangpur",
    "regNoSuffix": "0054"
  },
  {
    "registrationNumber": "KOP/2026/09/0055",
    "docId": "KOP-2026-09-0055",
    "name": "RUPESH KUMAR PUNJI",
    "mobile": "9938534558",
    "dob": "2000-02-02",
    "district": "Kalahandi",
    "regNoSuffix": "0055"
  },
  {
    "registrationNumber": "KOP/2026/09/0056",
    "docId": "KOP-2026-09-0056",
    "name": "INIT PRABIN KUMAR",
    "mobile": "8249384417",
    "dob": "2000-02-03",
    "district": "Rayagada",
    "regNoSuffix": "0056"
  },
  {
    "registrationNumber": "KOP/2026/09/0057",
    "docId": "KOP-2026-09-0057",
    "name": "KALIA CHOUDHURY",
    "mobile": "7855044044",
    "dob": "2000-02-02",
    "district": "Rayagada",
    "regNoSuffix": "0057"
  },
  {
    "registrationNumber": "KOP/2026/09/0058",
    "docId": "KOP-2026-09-0058",
    "name": "DIVYASREE BEHERA",
    "mobile": "9337641603",
    "dob": "2000-02-02",
    "district": "Rayagada",
    "regNoSuffix": "0058"
  },
  {
    "registrationNumber": "KOP/2026/09/0059",
    "docId": "KOP-2026-09-0059",
    "name": "PADMA LOCHAN SWAIN",
    "mobile": "9439823151",
    "dob": "2000-02-02",
    "district": "Rayagada",
    "regNoSuffix": "0059"
  },
  {
    "registrationNumber": "KOP/2026/09/0060",
    "docId": "KOP-2026-09-0060",
    "name": "JANARDAN SENAPATI",
    "mobile": "9861881861",
    "dob": "2005-02-01",
    "district": "Rayagada",
    "regNoSuffix": "0060"
  },
  {
    "registrationNumber": "KOP/2026/09/0061",
    "docId": "KOP-2026-09-0061",
    "name": "HEMANTA TEJI",
    "mobile": "7855852084",
    "dob": "2000-02-09",
    "district": "Kalahandi",
    "regNoSuffix": "0061"
  },
  {
    "registrationNumber": "KOP/2026/09/0062",
    "docId": "KOP-2026-09-0062",
    "name": "BARSHARANI SAHU",
    "mobile": "8984022934",
    "dob": "2000-02-02",
    "district": "Sonepur",
    "regNoSuffix": "0062"
  },
  {
    "registrationNumber": "KOP/2026/09/0063",
    "docId": "KOP-2026-09-0063",
    "name": "SANJAY KUMAR NAIK",
    "mobile": "8917619817",
    "dob": "2000-02-02",
    "district": "Balangir",
    "regNoSuffix": "0063"
  },
  {
    "registrationNumber": "KOP/2026/09/0065",
    "docId": "KOP-2026-09-0065",
    "name": "NIRUPAMA DASH",
    "mobile": "7847942085",
    "dob": "2000-02-02",
    "district": "Balangir",
    "regNoSuffix": "0065"
  },
  {
    "registrationNumber": "KOP/2026/09/0066",
    "docId": "KOP-2026-09-0066",
    "name": "CHINMAYA DIBYA JIBAN SAHOO",
    "mobile": "9937368655",
    "dob": "2000-02-02",
    "district": "Dhenkanal",
    "regNoSuffix": "0066"
  },
  {
    "registrationNumber": "KOP/2026/09/0067",
    "docId": "KOP-2026-09-0067",
    "name": "ALOK NAIK",
    "mobile": "7735968209",
    "dob": "1111-11-11",
    "district": "Sonepur",
    "regNoSuffix": "0067"
  },
  {
    "registrationNumber": "KOP/2026/09/0068",
    "docId": "KOP-2026-09-0068",
    "name": "MANOJ MEHER",
    "mobile": "9777973942",
    "dob": "2000-02-02",
    "district": "Sonepur",
    "regNoSuffix": "0068"
  },
  {
    "registrationNumber": "KOP/2026/09/0069",
    "docId": "KOP-2026-09-0069",
    "name": "RANJITA MAHAPATRO",
    "mobile": "7735120070",
    "dob": "2000-02-02",
    "district": "Rayagada",
    "regNoSuffix": "0069"
  },
  {
    "registrationNumber": "KOP/2026/09/0070",
    "docId": "KOP-2026-09-0070",
    "name": "ANANT MAJHI",
    "mobile": "9348980184",
    "dob": "2000-02-02",
    "district": "Rayagada",
    "regNoSuffix": "0070"
  },
  {
    "registrationNumber": "KOP/2026/09/0071",
    "docId": "KOP-2026-09-0071",
    "name": "MANAS RANJAN BARIK",
    "mobile": "9778274500",
    "dob": "2000-02-02",
    "district": "Balangir",
    "regNoSuffix": "0071"
  },
  {
    "registrationNumber": "KOP/2026/09/0072",
    "docId": "KOP-2026-09-0072",
    "name": "YUBRAJ SWAIN",
    "mobile": "7735683798",
    "dob": "2000-02-02",
    "district": "Dhenkanal",
    "regNoSuffix": "0072"
  },
  {
    "registrationNumber": "KOP/2026/09/0073",
    "docId": "KOP-2026-09-0073",
    "name": "BINAYA SAHOO",
    "mobile": "8114921116",
    "dob": "2000-02-02",
    "district": "Dhenkanal",
    "regNoSuffix": "0073"
  },
  {
    "registrationNumber": "KOP/2026/09/0074",
    "docId": "KOP-2026-09-0074",
    "name": "SUJIT SAMAL",
    "mobile": "9078702879",
    "dob": "2000-02-02",
    "district": "Dhenkanal",
    "regNoSuffix": "0074"
  },
  {
    "registrationNumber": "KOP/2026/09/0075",
    "docId": "KOP-2026-09-0075",
    "name": "ASWINI KUMAR NAYAK",
    "mobile": "7205087469",
    "dob": "2000-02-02",
    "district": "Dhenkanal",
    "regNoSuffix": "0075"
  },
  {
    "registrationNumber": "KOP/2026/09/0076",
    "docId": "KOP-2026-09-0076",
    "name": "SAIGOPAL MALLIK",
    "mobile": "9556687338",
    "dob": "2000-02-02",
    "district": "Dhenkanal",
    "regNoSuffix": "0076"
  },
  {
    "registrationNumber": "KOP/2026/09/0077",
    "docId": "KOP-2026-09-0077",
    "name": "PRITAM MEHER",
    "mobile": "6371828208",
    "dob": "2000-02-02",
    "district": "Sonepur",
    "regNoSuffix": "0077"
  },
  {
    "registrationNumber": "KOP/2026/09/0078",
    "docId": "KOP-2026-09-0078",
    "name": "PRIYABRATA BISWAL",
    "mobile": "6371588358",
    "dob": "2000-02-02",
    "district": "Dhenkanal",
    "regNoSuffix": "0078"
  },
  {
    "registrationNumber": "KOP/2026/09/0079",
    "docId": "KOP-2026-09-0079",
    "name": "SAUMYARANJAN NAYAK",
    "mobile": "9776987850",
    "dob": "2000-02-02",
    "district": "Dhenkanal",
    "regNoSuffix": "0079"
  },
  {
    "registrationNumber": "KOP/2026/09/0080",
    "docId": "KOP-2026-09-0080",
    "name": "DHANANJAY SAHU",
    "mobile": "9556156420",
    "dob": "2000-02-02",
    "district": "Balangir",
    "regNoSuffix": "0080"
  },
  {
    "registrationNumber": "KOP/2026/09/0081",
    "docId": "KOP-2026-09-0081",
    "name": "Gunabati Sahu",
    "mobile": "9937437877",
    "dob": "1997-01-01",
    "district": "Balangir",
    "regNoSuffix": "0081"
  },
  {
    "registrationNumber": "KOP/2026/09/0082",
    "docId": "KOP-2026-09-0082",
    "name": "Umesh Prasad Sahu",
    "mobile": "8658796902",
    "dob": "2026-09-01",
    "district": "Bargarh",
    "regNoSuffix": "0082"
  },
  {
    "registrationNumber": "KOP/2026/09/0083",
    "docId": "KOP-2026-09-0083",
    "name": "ARABINDA DANGA",
    "mobile": "8114941180",
    "dob": "2000-02-02",
    "district": "Sonepur",
    "regNoSuffix": "0083"
  },
  {
    "registrationNumber": "KOP/2026/09/0084",
    "docId": "KOP-2026-09-0084",
    "name": "PRADYUMNA NAIK",
    "mobile": "9777415015",
    "dob": "2000-02-02",
    "district": "Sonepur",
    "regNoSuffix": "0084"
  },
  {
    "registrationNumber": "KOP/2026/09/0085",
    "docId": "KOP-2026-09-0085",
    "name": "TAPASWINI MEHER",
    "mobile": "9668693092",
    "dob": "2000-02-02",
    "district": "Boudh",
    "regNoSuffix": "0085"
  },
  {
    "registrationNumber": "KOP/2026/09/0086",
    "docId": "KOP-2026-09-0086",
    "name": "PRATAP KUMAR MEHER",
    "mobile": "9439793035",
    "dob": "2000-02-02",
    "district": "Sonepur",
    "regNoSuffix": "0086"
  },
  {
    "registrationNumber": "KOP/2026/09/0087",
    "docId": "KOP-2026-09-0087",
    "name": "SAROJ KUMAR PARDIA",
    "mobile": "9937446030",
    "dob": "2000-02-02",
    "district": "Sonepur",
    "regNoSuffix": "0087"
  },
  {
    "registrationNumber": "KOP/2026/09/0088",
    "docId": "KOP-2026-09-0088",
    "name": "CHHAYAKANTA BISHI",
    "mobile": "9658755068",
    "dob": "2000-02-02",
    "district": "Sonepur",
    "regNoSuffix": "0088"
  },
  {
    "registrationNumber": "KOP/2026/09/0089",
    "docId": "KOP-2026-09-0089",
    "name": "PRASHANTA KUMAR SETH",
    "mobile": "7606916747",
    "dob": "2000-02-02",
    "district": "Sonepur",
    "regNoSuffix": "0089"
  },
  {
    "registrationNumber": "KOP/2026/09/0090",
    "docId": "KOP-2026-09-0090",
    "name": "RATIMAYEE BISWAL",
    "mobile": "9668105033",
    "dob": "2000-01-03",
    "district": "Dhenkanal",
    "regNoSuffix": "0090"
  },
  {
    "registrationNumber": "KOP/2026/09/0091",
    "docId": "KOP-2026-09-0091",
    "name": "BALIA MEHER",
    "mobile": "7327888331",
    "dob": "2000-02-02",
    "district": "Boudh",
    "regNoSuffix": "0091"
  },
  {
    "registrationNumber": "KOP/2026/09/0092",
    "docId": "KOP-2026-09-0092",
    "name": "SRIRAM MEHER",
    "mobile": "9668663845",
    "dob": "2000-02-02",
    "district": "Boudh",
    "regNoSuffix": "0092"
  },
  {
    "registrationNumber": "KOP/2026/09/0093",
    "docId": "KOP-2026-09-0093",
    "name": "LALITA KAMPA",
    "mobile": "7735074246",
    "dob": "2000-02-02",
    "district": "Sonepur",
    "regNoSuffix": "0093"
  },
  {
    "registrationNumber": "KOP/2026/09/0094",
    "docId": "KOP-2026-09-0094",
    "name": "MOTIRANJAN SAHU",
    "mobile": "7749046339",
    "dob": "2000-02-02",
    "district": "Sonepur",
    "regNoSuffix": "0094"
  },
  {
    "registrationNumber": "KOP/2026/09/0095",
    "docId": "KOP-2026-09-0095",
    "name": "SUCHITRA BHOI",
    "mobile": "9993202316",
    "dob": "1988-04-15",
    "district": "KALAHANDI",
    "regNoSuffix": "0095"
  },
  {
    "registrationNumber": "KOP/2026/09/0096",
    "docId": "KOP-2026-09-0096",
    "name": "KHIROD KUMAR BHOI",
    "mobile": "9337227436",
    "dob": "1990-03-13",
    "district": "Balangir",
    "regNoSuffix": "0096"
  },
  {
    "registrationNumber": "KOP/2026/09/0097",
    "docId": "KOP-2026-09-0097",
    "name": "JIBANYAS PUJHARI",
    "mobile": "9583706356",
    "dob": "1999-07-12",
    "district": "Balangir",
    "regNoSuffix": "0097"
  },
  {
    "registrationNumber": "KOP/2026/09/0098",
    "docId": "KOP-2026-09-0098",
    "name": "KARESH RANA",
    "mobile": "9178584075",
    "dob": "1994-02-22",
    "district": "Balangir",
    "regNoSuffix": "0098"
  },
  {
    "registrationNumber": "KOP/2026/09/0099",
    "docId": "KOP-2026-09-0099",
    "name": "TULASI NAIK",
    "mobile": "9937150232",
    "dob": "2007-04-05",
    "district": "Kalahandi",
    "regNoSuffix": "0099"
  },
  {
    "registrationNumber": "KOP/2026/09/0100",
    "docId": "KOP-2026-09-0100",
    "name": "PUSPANJALI BEHERA",
    "mobile": "8249233990",
    "dob": "2004-04-17",
    "district": "BALANGIR",
    "regNoSuffix": "0100"
  },
  {
    "registrationNumber": "KOP/2026/05/0101",
    "docId": "KOP-2026-05-0101",
    "name": "HIMANSU SEKHAR  PATRO",
    "mobile": "7847098134",
    "dob": "2002-02-24",
    "district": "RAYAGADA",
    "regNoSuffix": "0101"
  },
  {
    "registrationNumber": "KOP/2026/05/0102",
    "docId": "KOP-2026-05-0102",
    "name": "PRAJNYA PARAMITA JENA",
    "mobile": "8093664145",
    "dob": "1998-04-13",
    "district": "Balasore",
    "regNoSuffix": "0102"
  },
  {
    "registrationNumber": "KOP/2026/05/0103",
    "docId": "KOP-2026-05-0103",
    "name": "Sanjib Kumar Dehuri",
    "mobile": "9938271100",
    "dob": "1983-05-23",
    "district": "Sonepur",
    "regNoSuffix": "0103"
  },
  {
    "registrationNumber": "KOP/2026/05/0104",
    "docId": "KOP-2026-05-0104",
    "name": "Sambeet Rout",
    "mobile": "7008809851",
    "dob": "2005-06-29",
    "district": "Dhenkanal",
    "regNoSuffix": "0104"
  },
  {
    "registrationNumber": "KOP/2026/05/0105",
    "docId": "KOP-2026-05-0105",
    "name": "Sanoj Kumar Mishra",
    "mobile": "7008930267",
    "dob": "1991-07-16",
    "district": "Sonepur",
    "regNoSuffix": "0105"
  },
  {
    "registrationNumber": "KOP/2026/05/0106",
    "docId": "KOP-2026-05-0106",
    "name": "Rudranarayan Mishra",
    "mobile": "8917644276",
    "dob": "1992-07-07",
    "district": "Sonepur",
    "regNoSuffix": "0106"
  },
  {
    "registrationNumber": "KOP/2026/05/0107",
    "docId": "KOP-2026-05-0107",
    "name": "Biplab Behera",
    "mobile": "9040224045",
    "dob": "2003-01-29",
    "district": "Balasore",
    "regNoSuffix": "0107"
  },
  {
    "registrationNumber": "KOP/2026/05/0108",
    "docId": "KOP-2026-05-0108",
    "name": "Prakash Danga",
    "mobile": "7681093770",
    "dob": "2001-11-21",
    "district": "Sonepur",
    "regNoSuffix": "0108"
  },
  {
    "registrationNumber": "KOP/2026/05/0109",
    "docId": "KOP-2026-05-0109",
    "name": "Reenki  Bagha",
    "mobile": "7205364497",
    "dob": "2001-02-12",
    "district": "Subarnapur",
    "regNoSuffix": "0109"
  },
  {
    "registrationNumber": "KOP/2026/05/0110",
    "docId": "KOP-2026-05-0110",
    "name": "Sasmita Kar",
    "mobile": "6371247838",
    "dob": "1987-03-29",
    "district": "Balasore",
    "regNoSuffix": "0110"
  },
  {
    "registrationNumber": "KOP/2026/05/0111",
    "docId": "KOP-2026-05-0111",
    "name": "Ajit Swain",
    "mobile": "9692943514",
    "dob": "1997-06-13",
    "district": "Dhenkanal",
    "regNoSuffix": "0111"
  },
  {
    "registrationNumber": "KOP/2026/05/0112",
    "docId": "KOP-2026-05-0112",
    "name": "Monalisa Das",
    "mobile": "9337425209",
    "dob": "2002-09-08",
    "district": "Balasore",
    "regNoSuffix": "0112"
  },
  {
    "registrationNumber": "KOP/2026/05/0113",
    "docId": "KOP-2026-05-0113",
    "name": "JITENDRIYA AMAT",
    "mobile": "7606834050",
    "dob": "1997-07-17",
    "district": "SONEPUR",
    "regNoSuffix": "0113"
  },
  {
    "registrationNumber": "KOP/2026/05/0114",
    "docId": "KOP-2026-05-0114",
    "name": "ARATI SAMAD",
    "mobile": "9692381085",
    "dob": "2004-05-22",
    "district": "Sundargarh",
    "regNoSuffix": "0114"
  },
  {
    "registrationNumber": "KOP/2026/05/0115",
    "docId": "KOP-2026-05-0115",
    "name": "PRIYANKA  CHOUDHURY",
    "mobile": "8658422050",
    "dob": "1997-01-16",
    "district": "Sundargarh",
    "regNoSuffix": "0115"
  },
  {
    "registrationNumber": "KOP/2026/05/0116",
    "docId": "KOP-2026-05-0116",
    "name": "Ashalata  Pradhan",
    "mobile": "6370163528",
    "dob": "1997-11-01",
    "district": "Sundargarh",
    "regNoSuffix": "0116"
  },
  {
    "registrationNumber": "KOP/2026/06/0117",
    "docId": "KOP-2026-06-0117",
    "name": "Mahima Sahu",
    "mobile": "9937059548",
    "dob": "2000-03-10",
    "district": "Sonepur",
    "regNoSuffix": "0117"
  },
  {
    "registrationNumber": "KOP/2026/06/0118",
    "docId": "KOP-2026-06-0118",
    "name": "Sriya Sahu",
    "mobile": "8327765847",
    "dob": "2002-12-01",
    "district": "Sonepur",
    "regNoSuffix": "0118"
  },
  {
    "registrationNumber": "KOP/2026/06/0119",
    "docId": "KOP-2026-06-0119",
    "name": "Gayatri Gouda",
    "mobile": "8658957611",
    "dob": "2001-09-15",
    "district": "Ganjam",
    "regNoSuffix": "0119"
  },
  {
    "registrationNumber": "KOP/2026/06/0120",
    "docId": "KOP-2026-06-0120",
    "name": "Devi Gouda",
    "mobile": "8093213093",
    "dob": "1997-05-28",
    "district": "Ganjam",
    "regNoSuffix": "0120"
  },
  {
    "registrationNumber": "KOP/2026/06/0121",
    "docId": "KOP-2026-06-0121",
    "name": "Akash Patra",
    "mobile": "6371005734",
    "dob": "2004-08-16",
    "district": "Rayagada",
    "regNoSuffix": "0121"
  },
  {
    "registrationNumber": "KOP/2026/06/0122",
    "docId": "KOP-2026-06-0122",
    "name": "Deepa Senapati",
    "mobile": "9178864824",
    "dob": "2003-08-10",
    "district": "Rayagada",
    "regNoSuffix": "0122"
  },
  {
    "registrationNumber": "KOP/2026/06/0123",
    "docId": "KOP-2026-06-0123",
    "name": "Debashree Pradhan",
    "mobile": "8260548559",
    "dob": "2002-02-15",
    "district": "Balasore",
    "regNoSuffix": "0123"
  },
  {
    "registrationNumber": "KOP/2026/06/0124",
    "docId": "KOP-2026-06-0124",
    "name": "Pragaya Parimita Pati",
    "mobile": "7846801309",
    "dob": "2003-03-15",
    "district": "Malkangiri",
    "regNoSuffix": "0124"
  },
  {
    "registrationNumber": "KOP/2026/06/0125",
    "docId": "KOP-2026-06-0125",
    "name": "Santilata Burudi",
    "mobile": "6372596544",
    "dob": "2001-12-15",
    "district": "Malkangiri",
    "regNoSuffix": "0125"
  },
  {
    "registrationNumber": "KOP/2026/06/0126",
    "docId": "KOP-2026-06-0126",
    "name": "Jitendra Pujari",
    "mobile": "8144600145",
    "dob": "2005-08-02",
    "district": "Malkangiri",
    "regNoSuffix": "0126"
  },
  {
    "registrationNumber": "KOP/2026/06/0127",
    "docId": "KOP-2026-06-0127",
    "name": "Prakash Jena",
    "mobile": "9078843637",
    "dob": "1990-06-25",
    "district": "Balasore",
    "regNoSuffix": "0127"
  },
  {
    "registrationNumber": "KOP/2026/06/0128",
    "docId": "KOP-2026-06-0128",
    "name": "Pratap Kumar Jena",
    "mobile": "9182438105",
    "dob": "1999-03-20",
    "district": "Balasore",
    "regNoSuffix": "0128"
  },
  {
    "registrationNumber": "KOP/2026/06/0129",
    "docId": "KOP-2026-06-0129",
    "name": "Rajat Mahalik",
    "mobile": "9124881357",
    "dob": "1994-03-08",
    "district": "Balasore",
    "regNoSuffix": "0129"
  },
  {
    "registrationNumber": "KOP/2026/06/0130",
    "docId": "KOP-2026-06-0130",
    "name": "Balaram Mahakur",
    "mobile": "9556200308",
    "dob": "2003-03-25",
    "district": "Sonepur",
    "regNoSuffix": "0130"
  },
  {
    "registrationNumber": "KOP/2026/05/0131",
    "docId": "KOP-2026-05-0131",
    "name": "HEMALATA MOHANTA",
    "mobile": "9827616876",
    "dob": "1995-01-08",
    "district": "Mayurbhanj",
    "regNoSuffix": "0131"
  },
  {
    "registrationNumber": "KOP/2026/06/0132",
    "docId": "KOP-2026-06-0132",
    "name": "Antaryami Guru",
    "mobile": "6370326860",
    "dob": "2003-03-13",
    "district": "Sonepur",
    "regNoSuffix": "0132"
  },
  {
    "registrationNumber": "KOP/2026/05/0133",
    "docId": "KOP-2026-05-0133",
    "name": "ANITA  DEY",
    "mobile": "6370135982",
    "dob": "1990-02-03",
    "district": "Balasore",
    "regNoSuffix": "0133"
  },
  {
    "registrationNumber": "KOP/2026/06/0134",
    "docId": "KOP-2026-06-0134",
    "name": "MAMA SAHU",
    "mobile": "6371589493",
    "dob": "2006-03-07",
    "district": "Sonepur",
    "regNoSuffix": "0134"
  },
  {
    "registrationNumber": "KOP/2026/06/0136",
    "docId": "KOP-2026-06-0136",
    "name": "SUDHIR  HARIPAL",
    "mobile": "7751070026",
    "dob": "1998-03-30",
    "district": "Boudh",
    "regNoSuffix": "0136"
  },
  {
    "registrationNumber": "KOP/2026/06/0140",
    "docId": "KOP-2026-06-0140",
    "name": "GAYATRI SUNANI",
    "mobile": "9337214087",
    "dob": "1994-06-27",
    "district": "Kalahandi",
    "regNoSuffix": "0140"
  },
  {
    "registrationNumber": "KOP/2026/06/0141",
    "docId": "KOP-2026-06-0141",
    "name": "ASIT MAHAKUR",
    "mobile": "9668203825",
    "dob": "2001-03-18",
    "district": "Sonepur",
    "regNoSuffix": "0141"
  },
  {
    "registrationNumber": "KOP/2026/06/0142",
    "docId": "KOP-2026-06-0142",
    "name": "PRIYARANJAN DASH",
    "mobile": "8018040275",
    "dob": "1994-06-10",
    "district": "Sonepur",
    "regNoSuffix": "0142"
  },
  {
    "registrationNumber": "KOP/2026/06/0143",
    "docId": "KOP-2026-06-0143",
    "name": "BASANT KUMAR SAHU",
    "mobile": "9777277388",
    "dob": "1996-05-14",
    "district": "Ganjam",
    "regNoSuffix": "0143"
  },
  {
    "registrationNumber": "KOP/2026/06/0144",
    "docId": "KOP-2026-06-0144",
    "name": "SANJUKTA SUNA",
    "mobile": "7849078348",
    "dob": "1988-06-12",
    "district": "Sonepur",
    "regNoSuffix": "0144"
  },
  {
    "registrationNumber": "KOP/2026/06/0145",
    "docId": "KOP-2026-06-0145",
    "name": "Sujata Khety",
    "mobile": "7008768912",
    "dob": "1998-06-16",
    "district": "Sonepur",
    "regNoSuffix": "0145"
  },
  {
    "registrationNumber": "KOP/2026/06/0146",
    "docId": "KOP-2026-06-0146",
    "name": "KISANLAL DIGAL",
    "mobile": "9470642102",
    "dob": "1988-04-03",
    "district": "Kandhamal",
    "regNoSuffix": "0146"
  },
  {
    "registrationNumber": "KOP/2026/06/0147",
    "docId": "KOP-2026-06-0147",
    "name": "RASMITA BEHERA",
    "mobile": "9373545980",
    "dob": "1997-05-02",
    "district": "Balasore",
    "regNoSuffix": "0147"
  },
  {
    "registrationNumber": "KOP/2026/06/0148",
    "docId": "KOP-2026-06-0148",
    "name": "JAGANNATH  GIRI",
    "mobile": "9178971429",
    "dob": "1990-02-25",
    "district": "Balasore",
    "regNoSuffix": "0148"
  },
  {
    "registrationNumber": "KOP/2026/06/0149",
    "docId": "KOP-2026-06-0149",
    "name": "BAISHAKHI  DALAI",
    "mobile": "9556841873",
    "dob": "2005-08-24",
    "district": "Balasore",
    "regNoSuffix": "0149"
  },
  {
    "registrationNumber": "KOP/2026/06/0150",
    "docId": "KOP-2026-06-0150",
    "name": "PARIMITA  SAHOO",
    "mobile": "8480569800",
    "dob": "1997-04-07",
    "district": "Balasore",
    "regNoSuffix": "0150"
  },
  {
    "registrationNumber": "KOP/2026/06/0151",
    "docId": "KOP-2026-06-0151",
    "name": "SITARANI  MAHANA",
    "mobile": "9078687641",
    "dob": "1997-03-16",
    "district": "Balasore",
    "regNoSuffix": "0151"
  },
  {
    "registrationNumber": "KOP/2026/06/0152",
    "docId": "KOP-2026-06-0152",
    "name": "SANDHYA RANI NATH",
    "mobile": "8093950108",
    "dob": "2004-01-16",
    "district": "Balasore",
    "regNoSuffix": "0152"
  },
  {
    "registrationNumber": "KOP/2026/06/0153",
    "docId": "KOP-2026-06-0153",
    "name": "SHIBANI  MEHER",
    "mobile": "8249036230",
    "dob": "1996-06-20",
    "district": "Sonepur",
    "regNoSuffix": "0153"
  },
  {
    "registrationNumber": "KOP/2026/06/0154",
    "docId": "KOP-2026-06-0154",
    "name": "NIRAJA RANI PRADHAN",
    "mobile": "7735259118",
    "dob": "2000-03-26",
    "district": "Ganjam",
    "regNoSuffix": "0154"
  },
  {
    "registrationNumber": "KOP/2026/06/0155",
    "docId": "KOP-2026-06-0155",
    "name": "SIBANI  GOUDA",
    "mobile": "8260642080",
    "dob": "2003-08-01",
    "district": "Ganjam",
    "regNoSuffix": "0155"
  },
  {
    "registrationNumber": "KOP/2026/06/0156",
    "docId": "KOP-2026-06-0156",
    "name": "RAJESH GOUDA",
    "mobile": "7735695077",
    "dob": "12007-02-24",
    "district": "Rayagada",
    "regNoSuffix": "0156"
  },
  {
    "registrationNumber": "KOP/2026/06/0157",
    "docId": "KOP-2026-06-0157",
    "name": "GOURI  GOUDA",
    "mobile": "9124456677",
    "dob": "2001-05-25",
    "district": "Rayagada",
    "regNoSuffix": "0157"
  },
  {
    "registrationNumber": "KOP/2026/06/0158",
    "docId": "KOP-2026-06-0158",
    "name": "SANKAR  GOUDA",
    "mobile": "9861868755",
    "dob": "2002-01-09",
    "district": "Gajapati",
    "regNoSuffix": "0158"
  },
  {
    "registrationNumber": "KOP/2026/06/0159",
    "docId": "KOP-2026-06-0159",
    "name": "LILLY SUJATA  TIGGA",
    "mobile": "8249079460",
    "dob": "1989-05-28",
    "district": "Sundargarh",
    "regNoSuffix": "0159"
  },
  {
    "registrationNumber": "KOP/2026/06/0160",
    "docId": "KOP-2026-06-0160",
    "name": "MANISHA  SAHU",
    "mobile": "9178563673",
    "dob": "2004-01-05",
    "district": "Sonepur",
    "regNoSuffix": "0160"
  },
  {
    "registrationNumber": "KOP/2026/06/0161",
    "docId": "KOP-2026-06-0161",
    "name": "RANESWAR  BISHI",
    "mobile": "8144484245",
    "dob": "2004-01-01",
    "district": "Sonepur",
    "regNoSuffix": "0161"
  },
  {
    "registrationNumber": "KOP/2026/06/0162",
    "docId": "KOP-2026-06-0162",
    "name": "SRIKANTA KUMAR NAG",
    "mobile": "9777373534",
    "dob": "1996-04-15",
    "district": "Balangir",
    "regNoSuffix": "0162"
  },
  {
    "registrationNumber": "KOP/2026/06/0163",
    "docId": "KOP-2026-06-0163",
    "name": "SHRINIBAS  MAHAKUR",
    "mobile": "9556197911",
    "dob": "2003-11-14",
    "district": "Sonepur",
    "regNoSuffix": "0163"
  },
  {
    "registrationNumber": "KOP/2026/06/0164",
    "docId": "KOP-2026-06-0164",
    "name": "BABITA  DEHERI",
    "mobile": "9348531457",
    "dob": "1992-04-07",
    "district": "Sonepur",
    "regNoSuffix": "0164"
  },
  {
    "registrationNumber": "KOP/2026/06/0165",
    "docId": "KOP-2026-06-0165",
    "name": "SHANTINIKETAN  NATH",
    "mobile": "8658839089",
    "dob": "2004-06-04",
    "district": "Balasore",
    "regNoSuffix": "0165"
  },
  {
    "registrationNumber": "KOP/2026/06/0166",
    "docId": "KOP-2026-06-0166",
    "name": "PRATIMA  MANDAL",
    "mobile": "9777186718",
    "dob": "2003-10-12",
    "district": "Balasore",
    "regNoSuffix": "0166"
  },
  {
    "registrationNumber": "KOP/2026/06/0167",
    "docId": "KOP-2026-06-0167",
    "name": "SUBRAT  SAHU",
    "mobile": "9078868635",
    "dob": "2002-02-04",
    "district": "Dhenkanal",
    "regNoSuffix": "0167"
  },
  {
    "registrationNumber": "KOP/2026/06/0168",
    "docId": "KOP-2026-06-0168",
    "name": "SUNIT KUMAR  BARIK",
    "mobile": "9938775970",
    "dob": "1998-04-16",
    "district": "Sonepur",
    "regNoSuffix": "0168"
  },
  {
    "registrationNumber": "KOP/2026/06/0169",
    "docId": "KOP-2026-06-0169",
    "name": "SUDESHNA BARIK",
    "mobile": "7735291327",
    "dob": "1993-05-06",
    "district": "Balangir",
    "regNoSuffix": "0169"
  },
  {
    "registrationNumber": "KOP/2026/06/0170",
    "docId": "KOP-2026-06-0170",
    "name": "SACHIDANANDA PADHAN",
    "mobile": "9777415441",
    "dob": "1999-08-10",
    "district": "Sonepur",
    "regNoSuffix": "0170"
  },
  {
    "registrationNumber": "KOP/2026/06/0171",
    "docId": "KOP-2026-06-0171",
    "name": "PRANGYA PARAMITA  PANIGRAHI",
    "mobile": "8658419197",
    "dob": "1988-07-20",
    "district": "Nuapada",
    "regNoSuffix": "0171"
  },
  {
    "registrationNumber": "KOP/2026/06/0172",
    "docId": "KOP-2026-06-0172",
    "name": "BULU NAIK",
    "mobile": "9348363473",
    "dob": "1995-08-21",
    "district": "Kalahandi",
    "regNoSuffix": "0172"
  },
  {
    "registrationNumber": "KOP/2026/06/0173",
    "docId": "KOP-2026-06-0173",
    "name": "KUSHA  TOLTIA",
    "mobile": "9348883189",
    "dob": "1998-02-12",
    "district": "Kalahandi",
    "regNoSuffix": "0173"
  },
  {
    "registrationNumber": "KOP/2026/06/0174",
    "docId": "KOP-2026-06-0174",
    "name": "SWAGAT RANJAN JOSHI",
    "mobile": "9556500529",
    "dob": "1996-04-06",
    "district": "Nuapada",
    "regNoSuffix": "0174"
  },
  {
    "registrationNumber": "KOP/2026/06/0175",
    "docId": "KOP-2026-06-0175",
    "name": "ANKITA  PANDA",
    "mobile": "9337554523",
    "dob": "2002-02-05",
    "district": "Nuapada",
    "regNoSuffix": "0175"
  },
  {
    "registrationNumber": "KOP/2026/06/0176",
    "docId": "KOP-2026-06-0176",
    "name": "DEBASIS  NAIK",
    "mobile": "9861490432",
    "dob": "1994-06-21",
    "district": "Sonepur",
    "regNoSuffix": "0176"
  },
  {
    "registrationNumber": "KOP/2026/06/0177",
    "docId": "KOP-2026-06-0177",
    "name": "SUBASH  DANDASENA",
    "mobile": "8763634755",
    "dob": "2004-03-06",
    "district": "Sonepur",
    "regNoSuffix": "0177"
  },
  {
    "registrationNumber": "KOP/2026/06/0178",
    "docId": "KOP-2026-06-0178",
    "name": "BABITA  BAGH",
    "mobile": "8117866964",
    "dob": "1997-06-01",
    "district": "Sonepur",
    "regNoSuffix": "0178"
  },
  {
    "registrationNumber": "KOP/2026/06/0179",
    "docId": "KOP-2026-06-0179",
    "name": "DEB KUMAR NAYAK",
    "mobile": "7489620012",
    "dob": "2002-02-26",
    "district": "Nabarangpur",
    "regNoSuffix": "0179"
  },
  {
    "registrationNumber": "KOP/2026/06/0180",
    "docId": "KOP-2026-06-0180",
    "name": "BUDDHADEV DANDASENA",
    "mobile": "9178062521",
    "dob": "1995-07-05",
    "district": "Nuapada",
    "regNoSuffix": "0180"
  },
  {
    "registrationNumber": "KOP/2026/06/0181",
    "docId": "KOP-2026-06-0181",
    "name": "KARUNA  MEHER",
    "mobile": "9777517019",
    "dob": "1997-05-13",
    "district": "Sonepur",
    "regNoSuffix": "0181"
  },
  {
    "registrationNumber": "KOP/2026/06/0182",
    "docId": "KOP-2026-06-0182",
    "name": "ACHYUTA NANDA SAHU",
    "mobile": "8658042701",
    "dob": "1998-05-15",
    "district": "Sonepur",
    "regNoSuffix": "0182"
  },
  {
    "registrationNumber": "KOP/2026/06/0183",
    "docId": "KOP-2026-06-0183",
    "name": "BHARATI  SAMAL",
    "mobile": "6370839501",
    "dob": "1998-11-24",
    "district": "Balasore",
    "regNoSuffix": "0183"
  },
  {
    "registrationNumber": "KOP/2026/06/0184",
    "docId": "KOP-2026-06-0184",
    "name": "UTTAM  KHAMARI",
    "mobile": "7077398638",
    "dob": "2005-02-12",
    "district": "Sonepur",
    "regNoSuffix": "0184"
  },
  {
    "registrationNumber": "KOP/2026/06/0185",
    "docId": "KOP-2026-06-0185",
    "name": "TRUPTI MAYEE MISHRA",
    "mobile": "8658666569",
    "dob": "1998-03-26",
    "district": "Sonepur",
    "regNoSuffix": "0185"
  },
  {
    "registrationNumber": "KOP/2026/06/0186",
    "docId": "KOP-2026-06-0186",
    "name": "SAIRAM  GOUDA",
    "mobile": "8144380892",
    "dob": "1999-04-18",
    "district": "Ganjam",
    "regNoSuffix": "0186"
  },
  {
    "registrationNumber": "KOP/2026/06/0187",
    "docId": "KOP-2026-06-0187",
    "name": "GANESH  NAIK",
    "mobile": "7077408622",
    "dob": "1999-05-05",
    "district": "Mayurbhanj",
    "regNoSuffix": "0187"
  },
  {
    "registrationNumber": "KOP/2026/06/0188",
    "docId": "KOP-2026-06-0188",
    "name": "HEMANTA  NIAL",
    "mobile": "7077953317",
    "dob": "1998-04-05",
    "district": "Balangir",
    "regNoSuffix": "0188"
  },
  {
    "registrationNumber": "KOP/2026/06/0189",
    "docId": "KOP-2026-06-0189",
    "name": "ABHISEK  MEHER",
    "mobile": "8456023295",
    "dob": "1997-09-02",
    "district": "Balangir",
    "regNoSuffix": "0189"
  },
  {
    "registrationNumber": "KOP/2026/06/0190",
    "docId": "KOP-2026-06-0190",
    "name": "ALOK KUMAR  GHIBILA",
    "mobile": "7605940156",
    "dob": "1999-10-20",
    "district": "Sonepur",
    "regNoSuffix": "0190"
  },
  {
    "registrationNumber": "KOP/2026/06/0191",
    "docId": "KOP-2026-06-0191",
    "name": "KUMARI ROJALIN  SAHOO",
    "mobile": "7978591309",
    "dob": "2003-08-17",
    "district": "Dhenkanal",
    "regNoSuffix": "0191"
  },
  {
    "registrationNumber": "KOP/2026/06/0192",
    "docId": "KOP-2026-06-0192",
    "name": "SABITRI  BEHERA",
    "mobile": "9937191792",
    "dob": "2001-05-12",
    "district": "Balasore",
    "regNoSuffix": "0192"
  },
  {
    "registrationNumber": "KOP/2026/06/0193",
    "docId": "KOP-2026-06-0193",
    "name": "TILATTAMA SUNANI",
    "mobile": "9178631270",
    "dob": "1995-08-19",
    "district": "Nuapada",
    "regNoSuffix": "0193"
  },
  {
    "registrationNumber": "KOP/2026/06/0194",
    "docId": "KOP-2026-06-0194",
    "name": "RAJESWARI SAHU",
    "mobile": "8984506406",
    "dob": "2007-04-10",
    "district": "Nuapada",
    "regNoSuffix": "0194"
  },
  {
    "registrationNumber": "KOP/2026/06/0195",
    "docId": "KOP-2026-06-0195",
    "name": "JHANSI  MOHANTY",
    "mobile": "7855882281",
    "dob": "2004-02-01",
    "district": "Balasore",
    "regNoSuffix": "0195"
  },
  {
    "registrationNumber": "KOP/2026/06/0196",
    "docId": "KOP-2026-06-0196",
    "name": "SUBHASISH  JENA",
    "mobile": "9556896123",
    "dob": "1999-09-04",
    "district": "Balasore",
    "regNoSuffix": "0196"
  },
  {
    "registrationNumber": "KOP/2026/06/0197",
    "docId": "KOP-2026-06-0197",
    "name": "SANJUKTA  SING",
    "mobile": "9861052783",
    "dob": "2001-08-19",
    "district": "Balasore",
    "regNoSuffix": "0197"
  },
  {
    "registrationNumber": "KOP/2026/06/0198",
    "docId": "KOP-2026-06-0198",
    "name": "BISWAJIT  PRADHAN",
    "mobile": "8338975302",
    "dob": "1999-03-13",
    "district": "Balasore",
    "regNoSuffix": "0198"
  },
  {
    "registrationNumber": "KOP/2026/06/0199",
    "docId": "KOP-2026-06-0199",
    "name": "DEBASMITA  DALAI",
    "mobile": "9124934538",
    "dob": "2002-02-20",
    "district": "Balasore",
    "regNoSuffix": "0199"
  },
  {
    "registrationNumber": "KOP/2026/06/0200",
    "docId": "KOP-2026-06-0200",
    "name": "SUMAN  SAHU",
    "mobile": "8018087476",
    "dob": "2003-02-23",
    "district": "Balangir",
    "regNoSuffix": "0200"
  },
  {
    "registrationNumber": "KOP/2026/06/0201",
    "docId": "KOP-2026-06-0201",
    "name": "DEEPAK  BHUYAN",
    "mobile": "7008528461",
    "dob": "2000-05-10",
    "district": "Ganjam",
    "regNoSuffix": "0201"
  },
  {
    "registrationNumber": "KOP/2026/06/0202",
    "docId": "KOP-2026-06-0202",
    "name": "Lalita Kampa",
    "mobile": "7735074246",
    "dob": "2001-11-25",
    "district": "Sonepur",
    "regNoSuffix": "0202"
  },
  {
    "registrationNumber": "KOP/2026/06/0203",
    "docId": "KOP-2026-06-0203",
    "name": "Moti Ranjan Sahu",
    "mobile": "7749046339",
    "dob": "1997-05-23",
    "district": "Sonepur",
    "regNoSuffix": "0203"
  },
  {
    "registrationNumber": "KOP/2026/06/0204",
    "docId": "KOP-2026-06-0204",
    "name": "BIHARILAL PATEL",
    "mobile": "8908119981",
    "dob": "2006-11-01",
    "district": "Balangir",
    "regNoSuffix": "0204"
  },
  {
    "registrationNumber": "KOP/2026/06/0205",
    "docId": "KOP-2026-06-0205",
    "name": "SOURAV RANJAN  MUND",
    "mobile": "7735366818",
    "dob": "1994-07-07",
    "district": "Kalahandi",
    "regNoSuffix": "0205"
  },
  {
    "registrationNumber": "KOP/2026/06/0206",
    "docId": "KOP-2026-06-0206",
    "name": "RITA RANI MAJHI",
    "mobile": "8018060970",
    "dob": "2001-07-15",
    "district": "Balasore",
    "regNoSuffix": "0206"
  },
  {
    "registrationNumber": "KOP/2026/06/0207",
    "docId": "KOP-2026-06-0207",
    "name": "DINESH  BISWAL",
    "mobile": "8117058433",
    "dob": "1997-06-04",
    "district": "Sonepur",
    "regNoSuffix": "0207"
  },
  {
    "registrationNumber": "KOP/2026/06/0208",
    "docId": "KOP-2026-06-0208",
    "name": "TUSHARKANT  SAHU",
    "mobile": "9556596932",
    "dob": "1995-12-11",
    "district": "Sonepur",
    "regNoSuffix": "0208"
  },
  {
    "registrationNumber": "KOP/2026/06/0209",
    "docId": "KOP-2026-06-0209",
    "name": "ARUN  SAHU",
    "mobile": "8260540132",
    "dob": "2007-09-02",
    "district": "Sonepur",
    "regNoSuffix": "0209"
  },
  {
    "registrationNumber": "KOP/2026/06/0210",
    "docId": "KOP-2026-06-0210",
    "name": "BIBHUTI BHOOSAN PADHAN",
    "mobile": "9692861909",
    "dob": "2007-03-19",
    "district": "Sonepur",
    "regNoSuffix": "0210"
  },
  {
    "registrationNumber": "KOP/2026/06/0211",
    "docId": "KOP-2026-06-0211",
    "name": "ASHIRBAD PANDA",
    "mobile": "6371349875",
    "dob": "2006-03-23",
    "district": "Sonepur",
    "regNoSuffix": "0211"
  },
  {
    "registrationNumber": "KOP/2026/06/0212",
    "docId": "KOP-2026-06-0212",
    "name": "MINA  MAJHI",
    "mobile": "7008495183",
    "dob": "1993-04-07",
    "district": "Sundargarh",
    "regNoSuffix": "0212"
  },
  {
    "registrationNumber": "KOP/2026/06/0213",
    "docId": "KOP-2026-06-0213",
    "name": "SUSANTA  KARMEE",
    "mobile": "7749864082",
    "dob": "1998-05-16",
    "district": "Sonepur",
    "regNoSuffix": "0213"
  },
  {
    "registrationNumber": "KOP/2026/06/0214",
    "docId": "KOP-2026-06-0214",
    "name": "SAMEER KUMAR SAHOO",
    "mobile": "9178703752",
    "dob": "1989-05-22",
    "district": "Sonepur",
    "regNoSuffix": "0214"
  },
  {
    "registrationNumber": "KOP/2026/06/0215",
    "docId": "KOP-2026-06-0215",
    "name": "SUKANTI  JENA",
    "mobile": "9337010359",
    "dob": "1993-02-28",
    "district": "Balasore",
    "regNoSuffix": "0215"
  },
  {
    "registrationNumber": "KOP/2026/06/0216",
    "docId": "KOP-2026-06-0216",
    "name": "JAMBUBATI  PRADHANI",
    "mobile": "8984645695",
    "dob": "1997-06-10",
    "district": "Kalahandi",
    "regNoSuffix": "0216"
  },
  {
    "registrationNumber": "KOP/2026/06/0217",
    "docId": "KOP-2026-06-0217",
    "name": "JUGAL KISHOR  SA",
    "mobile": "9078698139",
    "dob": "1999-06-11",
    "district": "Sundargarh",
    "regNoSuffix": "0217"
  },
  {
    "registrationNumber": "KOP/2026/06/0218",
    "docId": "KOP-2026-06-0218",
    "name": "TARUN  BAG",
    "mobile": "9668046128",
    "dob": "1982-06-20",
    "district": "Sonepur",
    "regNoSuffix": "0218"
  },
  {
    "registrationNumber": "KOP/2026/06/0219",
    "docId": "KOP-2026-06-0219",
    "name": "BHAGABATI  NAIK",
    "mobile": "7008476836",
    "dob": "1999-11-08",
    "district": "Sonepur",
    "regNoSuffix": "0219"
  },
  {
    "registrationNumber": "KOP/2026/06/0220",
    "docId": "KOP-2026-06-0220",
    "name": "RENU MADHAB  SA",
    "mobile": "6372584692",
    "dob": "1999-06-24",
    "district": "Sundargarh",
    "regNoSuffix": "0220"
  },
  {
    "registrationNumber": "KOP/2026/06/0221",
    "docId": "KOP-2026-06-0221",
    "name": "GIRIJA SANKAR JENA",
    "mobile": "8847876426",
    "dob": "1995-03-22",
    "district": "Balasore",
    "regNoSuffix": "0221"
  },
  {
    "registrationNumber": "KOP/2026/06/0222",
    "docId": "KOP-2026-06-0222",
    "name": "SUMAN KUMAR  MEHER",
    "mobile": "8260451947",
    "dob": "2003-08-26",
    "district": "Balangir",
    "regNoSuffix": "0222"
  },
  {
    "registrationNumber": "KOP/2026/06/0223",
    "docId": "KOP-2026-06-0223",
    "name": "ARCHITA  KAR",
    "mobile": "9337839109",
    "dob": "2003-12-25",
    "district": "Mayurbhanj",
    "regNoSuffix": "0223"
  },
  {
    "registrationNumber": "KOP/2026/06/0224",
    "docId": "KOP-2026-06-0224",
    "name": "ANUPAMA PADHAN",
    "mobile": "7853014787",
    "dob": "2004-01-26",
    "district": "Sonepur",
    "regNoSuffix": "0224"
  },
  {
    "registrationNumber": "KOP/2026/06/0225",
    "docId": "KOP-2026-06-0225",
    "name": "NAMITA  BARIK",
    "mobile": "7008203029",
    "dob": "1993-06-05",
    "district": "Sonepur",
    "regNoSuffix": "0225"
  },
  {
    "registrationNumber": "KOP/2026/06/0226",
    "docId": "KOP-2026-06-0226",
    "name": "LAXMI  SAHU",
    "mobile": "9938616697",
    "dob": "1990-04-13",
    "district": "Nuapada",
    "regNoSuffix": "0226"
  },
  {
    "registrationNumber": "KOP/2026/06/0227",
    "docId": "KOP-2026-06-0227",
    "name": "SUVAM SAHOO",
    "mobile": "7854904120",
    "dob": "2006-11-07",
    "district": "Dhenkanal",
    "regNoSuffix": "0227"
  },
  {
    "registrationNumber": "KOP/2026/06/0228",
    "docId": "KOP-2026-06-0228",
    "name": "SWADHIN KUMAR JANI",
    "mobile": "9668290306",
    "dob": "1986-05-15",
    "district": "Boudh",
    "regNoSuffix": "0228"
  },
  {
    "registrationNumber": "KOP/2026/06/0229",
    "docId": "KOP-2026-06-0229",
    "name": "SACHHIKANTA  TRIPATHY",
    "mobile": "9337524035",
    "dob": "2006-03-04",
    "district": "Sonepur",
    "regNoSuffix": "0229"
  },
  {
    "registrationNumber": "KOP/2026/06/0230",
    "docId": "KOP-2026-06-0230",
    "name": "LIPSITA PUROHIT",
    "mobile": "9178124301",
    "dob": "2001-02-05",
    "district": "Sonepur",
    "regNoSuffix": "0230"
  },
  {
    "registrationNumber": "KOP/2026/06/0231",
    "docId": "KOP-2026-06-0231",
    "name": "SWASTIKA  MISHRA",
    "mobile": "9178298119",
    "dob": "1993-05-20",
    "district": "Boudh",
    "regNoSuffix": "0231"
  },
  {
    "registrationNumber": "KOP/2026/06/0232",
    "docId": "KOP-2026-06-0232",
    "name": "RABINDRA  MISHRA",
    "mobile": "8249144916",
    "dob": "1994-06-15",
    "district": "Boudh",
    "regNoSuffix": "0232"
  },
  {
    "registrationNumber": "KOP/2026/06/0233",
    "docId": "KOP-2026-06-0233",
    "name": "MALAYAKANT  NAYAK",
    "mobile": "9861135916",
    "dob": "2001-09-29",
    "district": "Rayagada",
    "regNoSuffix": "0233"
  },
  {
    "registrationNumber": "KOP/2026/06/0234",
    "docId": "KOP-2026-06-0234",
    "name": "AMARNATH MISHRA",
    "mobile": "9929019252",
    "dob": "2001-03-24",
    "district": "Sonepur",
    "regNoSuffix": "0234"
  },
  {
    "registrationNumber": "KOP/2026/06/0235",
    "docId": "KOP-2026-06-0235",
    "name": "BIKRAM SAHU",
    "mobile": "9668777737",
    "dob": "1998-05-05",
    "district": "Sonepur",
    "regNoSuffix": "0235"
  },
  {
    "registrationNumber": "KOP/2026/06/0236",
    "docId": "KOP-2026-06-0236",
    "name": "ADITYA KUMAR SAHOO",
    "mobile": "9937892232",
    "dob": "1991-06-02",
    "district": "Cuttack",
    "regNoSuffix": "0236"
  },
  {
    "registrationNumber": "KOP/2026/06/0237",
    "docId": "KOP-2026-06-0237",
    "name": "BIJAYA KUMAR  JENA",
    "mobile": "8917421757",
    "dob": "1992-02-07",
    "district": "Balasore",
    "regNoSuffix": "0237"
  },
  {
    "registrationNumber": "KOP/2026/06/0238",
    "docId": "KOP-2026-06-0238",
    "name": "RESHMA  GOUDA",
    "mobile": "7848088506",
    "dob": "2001-12-14",
    "district": "Ganjam",
    "regNoSuffix": "0238"
  },
  {
    "registrationNumber": "KOP/2026/06/0239",
    "docId": "KOP-2026-06-0239",
    "name": "SASMITA  RANA",
    "mobile": "9078806321",
    "dob": "1999-09-17",
    "district": "Kalahandi",
    "regNoSuffix": "0239"
  },
  {
    "registrationNumber": "KOP/2026/06/0240",
    "docId": "KOP-2026-06-0240",
    "name": "BHAKTARAM  BAGARTTI",
    "mobile": "8114357540",
    "dob": "2001-06-22",
    "district": "Sonepur",
    "regNoSuffix": "0240"
  },
  {
    "registrationNumber": "KOP/2026/06/0241",
    "docId": "KOP-2026-06-0241",
    "name": "SAGAR  MAHANKUDA",
    "mobile": "7735286162",
    "dob": "2002-03-14",
    "district": "Rayagada",
    "regNoSuffix": "0241"
  },
  {
    "registrationNumber": "KOP/2026/06/0242",
    "docId": "KOP-2026-06-0242",
    "name": "JITENDRA  DAS",
    "mobile": "7326984002",
    "dob": "2001-12-05",
    "district": "Dhenkanal",
    "regNoSuffix": "0242"
  },
  {
    "registrationNumber": "KOP/2026/06/0243",
    "docId": "KOP-2026-06-0243",
    "name": "DEEPANJALI  MISHRA",
    "mobile": "9777828337",
    "dob": "1996-01-01",
    "district": "Sonepur",
    "regNoSuffix": "0243"
  },
  {
    "registrationNumber": "KOP/2026/06/0244",
    "docId": "KOP-2026-06-0244",
    "name": "NARMADA KUMARI PATRA",
    "mobile": "9078571089",
    "dob": "1988-09-24",
    "district": "Rayagada",
    "regNoSuffix": "0244"
  },
  {
    "registrationNumber": "KOP/2026/06/0245",
    "docId": "KOP-2026-06-0245",
    "name": "SEKH  ISHAK",
    "mobile": "9438693929",
    "dob": "1988-04-22",
    "district": "Rayagada",
    "regNoSuffix": "0245"
  },
  {
    "registrationNumber": "KOP/2026/06/0246",
    "docId": "KOP-2026-06-0246",
    "name": "PRAKASH  BHOI",
    "mobile": "8455070324",
    "dob": "1994-07-05",
    "district": "Sonepur",
    "regNoSuffix": "0246"
  },
  {
    "registrationNumber": "KOP/2026/06/0247",
    "docId": "KOP-2026-06-0247",
    "name": "SILI  MAHANKUDA",
    "mobile": "8018252737",
    "dob": "1995-01-22",
    "district": "Rayagada",
    "regNoSuffix": "0247"
  },
  {
    "registrationNumber": "KOP/2026/06/0248",
    "docId": "KOP-2026-06-0248",
    "name": "AJIT  JHANKAR",
    "mobile": "9861049114",
    "dob": "2005-01-28",
    "district": "Sonepur",
    "regNoSuffix": "0248"
  },
  {
    "registrationNumber": "KOP/2026/06/0249",
    "docId": "KOP-2026-06-0249",
    "name": "PAPUN PADHAN",
    "mobile": "7683949025",
    "dob": "1999-02-10",
    "district": "Sonepur",
    "regNoSuffix": "0249"
  },
  {
    "registrationNumber": "KOP/2026/06/0250",
    "docId": "KOP-2026-06-0250",
    "name": "BISHNUPRASAD DAS",
    "mobile": "7326845898",
    "dob": "2001-12-21",
    "district": "Sonepur",
    "regNoSuffix": "0250"
  },
  {
    "registrationNumber": "KOP/2026/06/0251",
    "docId": "KOP-2026-06-0251",
    "name": "TUNGAVIDYA BHOI",
    "mobile": "9777177281",
    "dob": "1987-07-19",
    "district": "Balangir",
    "regNoSuffix": "0251"
  },
  {
    "registrationNumber": "KOP/2026/06/0252",
    "docId": "KOP-2026-06-0252",
    "name": "SUMANTA  HARIPAL",
    "mobile": "9668683557",
    "dob": "2002-12-29",
    "district": "Boudh",
    "regNoSuffix": "0252"
  },
  {
    "registrationNumber": "KOP/2026/06/0253",
    "docId": "KOP-2026-06-0253",
    "name": "BASANTI KUMARI DAS",
    "mobile": "8847828865",
    "dob": "1992-05-01",
    "district": "Ganjam",
    "regNoSuffix": "0253"
  },
  {
    "registrationNumber": "KOP/2026/06/0254",
    "docId": "KOP-2026-06-0254",
    "name": "ROHIT KUMAR NAG",
    "mobile": "9348183317",
    "dob": "1999-09-23",
    "district": "Nuapada",
    "regNoSuffix": "0254"
  },
  {
    "registrationNumber": "KOP/2026/06/0255",
    "docId": "KOP-2026-06-0255",
    "name": "ROSHAN  PANDA",
    "mobile": "9078600686",
    "dob": "1999-11-10",
    "district": "Nuapada",
    "regNoSuffix": "0255"
  },
  {
    "registrationNumber": "KOP/2026/06/0256",
    "docId": "KOP-2026-06-0256",
    "name": "PANKAJ  MUND",
    "mobile": "9692310215",
    "dob": "1998-06-20",
    "district": "Nuapada",
    "regNoSuffix": "0256"
  },
  {
    "registrationNumber": "KOP/2026/06/0257",
    "docId": "KOP-2026-06-0257",
    "name": "GUPTESWAR  GOUDA",
    "mobile": "7008238773",
    "dob": "2002-02-25",
    "district": "Rayagada",
    "regNoSuffix": "0257"
  },
  {
    "registrationNumber": "KOP/2026/07/0258",
    "docId": "KOP-2026-07-0258",
    "name": "SUBASH CHANDRA DEHURY",
    "mobile": "8249295608",
    "dob": "1997-06-06",
    "district": "Dhenkanal",
    "regNoSuffix": "0258"
  },
  {
    "registrationNumber": "KOP/2026/07/0259",
    "docId": "KOP-2026-07-0259",
    "name": "SARASWATI  BHOI",
    "mobile": "7853831321",
    "dob": "1995-05-20",
    "district": "Nuapada",
    "regNoSuffix": "0259"
  },
  {
    "registrationNumber": "KOP/2026/07/0260",
    "docId": "KOP-2026-07-0260",
    "name": "ABINASH  JOSHI",
    "mobile": "7847819758",
    "dob": "1995-09-06",
    "district": "Nuapada",
    "regNoSuffix": "0260"
  },
  {
    "registrationNumber": "KOP/2026/07/0261",
    "docId": "KOP-2026-07-0261",
    "name": "BHAGYASRI  MOHAPATRA",
    "mobile": "7847809428",
    "dob": "2004-10-27",
    "district": "Nabarangpur",
    "regNoSuffix": "0261"
  },
  {
    "registrationNumber": "KOP/2026/07/0262",
    "docId": "KOP-2026-07-0262",
    "name": "SANGEETA  TRIPATHY",
    "mobile": "9556670870",
    "dob": "1985-07-17",
    "district": "Nabarangpur",
    "regNoSuffix": "0262"
  },
  {
    "registrationNumber": "KOP/2026/07/0263",
    "docId": "KOP-2026-07-0263",
    "name": "MANISHA  NAIK",
    "mobile": "7681870968",
    "dob": "1999-12-27",
    "district": "Nuapada",
    "regNoSuffix": "0263"
  },
  {
    "registrationNumber": "KOP/2026/07/0264",
    "docId": "KOP-2026-07-0264",
    "name": "SWASTIK  AGASTI",
    "mobile": "7749011334",
    "dob": "2003-11-05",
    "district": "Nuapada",
    "regNoSuffix": "0264"
  },
  {
    "registrationNumber": "KOP/2026/07/0265",
    "docId": "KOP-2026-07-0265",
    "name": "PRASANNA KUMAR SA",
    "mobile": "7681058938",
    "dob": "2004-09-03",
    "district": "Nuapada",
    "regNoSuffix": "0265"
  },
  {
    "registrationNumber": "KOP/2026/07/0266",
    "docId": "KOP-2026-07-0266",
    "name": "HEMAPRASAD NAG",
    "mobile": "8658308578",
    "dob": "1994-10-28",
    "district": "Nuapada",
    "regNoSuffix": "0266"
  },
  {
    "registrationNumber": "KOP/2026/09/0267",
    "docId": "KOP-2026-09-0267",
    "name": "PRITIRANJAN PARIDA",
    "mobile": "7978956139",
    "dob": "2000-02-02",
    "district": "Dhenkanal",
    "regNoSuffix": "0267"
  },
  {
    "registrationNumber": "KOP/2026/09/0268",
    "docId": "KOP-2026-09-0268",
    "name": "PABITRA OJHA",
    "mobile": "7077040166",
    "dob": "2000-02-02",
    "district": "Dhenkanal",
    "regNoSuffix": "0268"
  },
  {
    "registrationNumber": "KOP/2026/09/0269",
    "docId": "KOP-2026-09-0269",
    "name": "RASHMI RANJAN NAYAK",
    "mobile": "8093378966",
    "dob": "2000-02-02",
    "district": "Dhenkanal",
    "regNoSuffix": "0269"
  },
  {
    "registrationNumber": "KOP/2026/09/0270",
    "docId": "KOP-2026-09-0270",
    "name": "OMM PRAKASH PADHAN",
    "mobile": "8984829219",
    "dob": "2000-02-01",
    "district": "Dhenkanal",
    "regNoSuffix": "0270"
  },
  {
    "registrationNumber": "KOP/2026/09/0271",
    "docId": "KOP-2026-09-0271",
    "name": "SATYAJIT NAYAK",
    "mobile": "8144282517",
    "dob": "2000-02-02",
    "district": "Dhenkanal",
    "regNoSuffix": "0271"
  },
  {
    "registrationNumber": "KOP/2026/09/0272",
    "docId": "KOP-2026-09-0272",
    "name": "SAMBID GOCHHAYAT",
    "mobile": "9337811612",
    "dob": "2000-02-02",
    "district": "Dhenkanal",
    "regNoSuffix": "0272"
  },
  {
    "registrationNumber": "KOP/2026/09/0273",
    "docId": "KOP-2026-09-0273",
    "name": "AJAYA KUMAR DASH",
    "mobile": "8658832401",
    "dob": "2000-06-08",
    "district": "Dhenkanal",
    "regNoSuffix": "0273"
  },
  {
    "registrationNumber": "KOP/2026/09/0274",
    "docId": "KOP-2026-09-0274",
    "name": "ABINASH NAYAK",
    "mobile": "7381265736",
    "dob": "2000-02-02",
    "district": "Dhenkanal",
    "regNoSuffix": "0274"
  },
  {
    "registrationNumber": "KOP/2026/09/0275",
    "docId": "KOP-2026-09-0275",
    "name": "TUSHAR KUMAR HIAL",
    "mobile": "8144131083",
    "dob": "2000-02-02",
    "district": "Nuapada",
    "regNoSuffix": "0275"
  },
  {
    "registrationNumber": "KOP/2026/09/0276",
    "docId": "KOP-2026-09-0276",
    "name": "SUSHAMA MEHER",
    "mobile": "9438064106",
    "dob": "2000-02-02",
    "district": "Balangir",
    "regNoSuffix": "0276"
  },
  {
    "registrationNumber": "KOP/2026/09/0277",
    "docId": "KOP-2026-09-0277",
    "name": "SUPRIYA RAMAN HANS",
    "mobile": "8018764196",
    "dob": "2000-02-02",
    "district": "Nuapada",
    "regNoSuffix": "0277"
  },
  {
    "registrationNumber": "KOP/2026/09/0278",
    "docId": "KOP-2026-09-0278",
    "name": "SUNIL AHIR",
    "mobile": "6372282261",
    "dob": "2000-02-02",
    "district": "Nuapada",
    "regNoSuffix": "0278"
  },
  {
    "registrationNumber": "KOP/2026/09/0279",
    "docId": "KOP-2026-09-0279",
    "name": "SIDDHESWARI PATEL",
    "mobile": "7608014913",
    "dob": "2000-02-02",
    "district": "Nuapada",
    "regNoSuffix": "0279"
  },
  {
    "registrationNumber": "KOP/2026/09/0280",
    "docId": "KOP-2026-09-0280",
    "name": "SATYAMANJARI BISHI",
    "mobile": "6372346727",
    "dob": "2000-02-02",
    "district": "Nuapada",
    "regNoSuffix": "0280"
  },
  {
    "registrationNumber": "KOP/2026/09/0281",
    "docId": "KOP-2026-09-0281",
    "name": "SASMITA MEHER",
    "mobile": "7750073020",
    "dob": "2000-02-02",
    "district": "Nuapada",
    "regNoSuffix": "0281"
  },
  {
    "registrationNumber": "KOP/2026/09/0282",
    "docId": "KOP-2026-09-0282",
    "name": "RENU PRABHA BHITRIA",
    "mobile": "7853029760",
    "dob": "2000-02-02",
    "district": "Nuapada",
    "regNoSuffix": "0282"
  },
  {
    "registrationNumber": "KOP/2026/09/0283",
    "docId": "KOP-2026-09-0283",
    "name": "RAGHUNATH MEHER",
    "mobile": "9777382868",
    "dob": "2000-02-02",
    "district": "Nuapada",
    "regNoSuffix": "0283"
  },
  {
    "registrationNumber": "KOP/2026/09/0284",
    "docId": "KOP-2026-09-0284",
    "name": "PRANAB BAG",
    "mobile": "7978634383",
    "dob": "2000-02-02",
    "district": "Nuapada",
    "regNoSuffix": "0284"
  },
  {
    "registrationNumber": "KOP/2026/09/0285",
    "docId": "KOP-2026-09-0285",
    "name": "PATIRAM BHOI",
    "mobile": "8114766796",
    "dob": "2000-02-02",
    "district": "Nuapada",
    "regNoSuffix": "0285"
  },
  {
    "registrationNumber": "KOP/2026/09/0286",
    "docId": "KOP-2026-09-0286",
    "name": "KSHYAMA SAGAR PATEL",
    "mobile": "9938697738",
    "dob": "2000-02-02",
    "district": "Nuapada",
    "regNoSuffix": "0286"
  },
  {
    "registrationNumber": "KOP/2026/09/0287",
    "docId": "KOP-2026-09-0287",
    "name": "JYOTSNAMAEE NAG",
    "mobile": "8457802493",
    "dob": "2000-02-02",
    "district": "Nuapada",
    "regNoSuffix": "0287"
  },
  {
    "registrationNumber": "KOP/2026/09/0288",
    "docId": "KOP-2026-09-0288",
    "name": "JASASWINI PANDA",
    "mobile": "9937557986",
    "dob": "2000-02-02",
    "district": "Nuapada",
    "regNoSuffix": "0288"
  },
  {
    "registrationNumber": "KOP/2026/09/0289",
    "docId": "KOP-2026-09-0289",
    "name": "HIMANSU JAGAT",
    "mobile": "7008561647",
    "dob": "2000-02-02",
    "district": "Nuapada",
    "regNoSuffix": "0289"
  },
  {
    "registrationNumber": "KOP/2026/09/0290",
    "docId": "KOP-2026-09-0290",
    "name": "HEMSAGAR BHITRIA",
    "mobile": "9692008916",
    "dob": "2000-02-02",
    "district": "Nuapada",
    "regNoSuffix": "0290"
  },
  {
    "registrationNumber": "KOP/2026/09/0291",
    "docId": "KOP-2026-09-0291",
    "name": "HARISH HANS",
    "mobile": "7205785085",
    "dob": "2000-02-02",
    "district": "Nuapada",
    "regNoSuffix": "0291"
  },
  {
    "registrationNumber": "KOP/2026/09/0292",
    "docId": "KOP-2026-09-0292",
    "name": "GYANENDRA SWAIN",
    "mobile": "7735546961",
    "dob": "2000-02-02",
    "district": "Nuapada",
    "regNoSuffix": "0292"
  },
  {
    "registrationNumber": "KOP/2026/09/0293",
    "docId": "KOP-2026-09-0293",
    "name": "GANGOTREE MEHER",
    "mobile": "9668002756",
    "dob": "2000-02-02",
    "district": "Nuapada",
    "regNoSuffix": "0293"
  },
  {
    "registrationNumber": "KOP/2026/09/0294",
    "docId": "KOP-2026-09-0294",
    "name": "DEBAKUMAR SAGARIA",
    "mobile": "9348251863",
    "dob": "2000-02-02",
    "district": "Balangir",
    "regNoSuffix": "0294"
  },
  {
    "registrationNumber": "KOP/2026/09/0295",
    "docId": "KOP-2026-09-0295",
    "name": "CHULAMANI MEHER",
    "mobile": "8455970892",
    "dob": "2000-02-02",
    "district": "Nuapada",
    "regNoSuffix": "0295"
  },
  {
    "registrationNumber": "KOP/2026/09/0296",
    "docId": "KOP-2026-09-0296",
    "name": "BHAGYASHRI MEHER",
    "mobile": "9937142560",
    "dob": "2000-02-02",
    "district": "Nuapada",
    "regNoSuffix": "0296"
  },
  {
    "registrationNumber": "KOP/2026/09/0297",
    "docId": "KOP-2026-09-0297",
    "name": "ARAKHITA PATEL",
    "mobile": "7853861655",
    "dob": "2000-02-02",
    "district": "Nuapada",
    "regNoSuffix": "0297"
  },
  {
    "registrationNumber": "KOP/2026/09/0298",
    "docId": "KOP-2026-09-0298",
    "name": "ANKIT RANJAN MUND",
    "mobile": "8457078707",
    "dob": "2000-02-02",
    "district": "Nuapada",
    "regNoSuffix": "0298"
  },
  {
    "registrationNumber": "KOP/2026/09/0299",
    "docId": "KOP-2026-09-0299",
    "name": "MAMATA PANDIT",
    "mobile": "7735144735",
    "dob": "2000-02-02",
    "district": "Rayagada",
    "regNoSuffix": "0299"
  },
  {
    "registrationNumber": "KOP/2026/09/0300",
    "docId": "KOP-2026-09-0300",
    "name": "AJIT SENAPATI",
    "mobile": "6371786743",
    "dob": "2000-02-02",
    "district": "Rayagada",
    "regNoSuffix": "0300"
  },
  {
    "registrationNumber": "KOP/2026/09/0301",
    "docId": "KOP-2026-09-0301",
    "name": "GRIDHAR SABAR",
    "mobile": "7849049156",
    "dob": "2000-02-02",
    "district": "Rayagada",
    "regNoSuffix": "0301"
  },
  {
    "registrationNumber": "KOP/2026/09/0302",
    "docId": "KOP-2026-09-0302",
    "name": "DEBASISH SAHUKAR",
    "mobile": "9861856160",
    "dob": "2000-02-02",
    "district": "Rayagada",
    "regNoSuffix": "0302"
  },
  {
    "registrationNumber": "KOP/2026/09/0303",
    "docId": "KOP-2026-09-0303",
    "name": "DAMA SABAR",
    "mobile": "9337848664",
    "dob": "2000-02-02",
    "district": "Rayagada",
    "regNoSuffix": "0303"
  },
  {
    "registrationNumber": "KOP/2026/09/0304",
    "docId": "KOP-2026-09-0304",
    "name": "GOURAMANI DASH",
    "mobile": "7735827957",
    "dob": "2000-02-02",
    "district": "Rayagada",
    "regNoSuffix": "0304"
  },
  {
    "registrationNumber": "KOP/2026/09/0305",
    "docId": "KOP-2026-09-0305",
    "name": "SUMANTA KUMAR NAIK",
    "mobile": "9861362085",
    "dob": "2000-02-02",
    "district": "Balangir",
    "regNoSuffix": "0305"
  },
  {
    "registrationNumber": "KOP/2026/09/0306",
    "docId": "KOP-2026-09-0306",
    "name": "NIKHIL SAHU",
    "mobile": "7847016635",
    "dob": "2000-02-02",
    "district": "Sonepur",
    "regNoSuffix": "0306"
  },
  {
    "registrationNumber": "KOP/2026/09/0307",
    "docId": "KOP-2026-09-0307",
    "name": "BINATI PATEL",
    "mobile": "6371577398",
    "dob": "2000-02-02",
    "district": "Balangir",
    "regNoSuffix": "0307"
  },
  {
    "registrationNumber": "KOP/2026/09/0308",
    "docId": "KOP-2026-09-0308",
    "name": "SASMITA NAIK",
    "mobile": "7205634415",
    "dob": "1996-04-25",
    "district": "Balangir",
    "regNoSuffix": "0308"
  },
  {
    "registrationNumber": "KOP/2026/09/0309",
    "docId": "KOP-2026-09-0309",
    "name": "JYOTIPRAVA SAHU",
    "mobile": "8763529070",
    "dob": "2002-09-07",
    "district": "Balangir",
    "regNoSuffix": "0309"
  },
  {
    "registrationNumber": "KOP/2026/09/0310",
    "docId": "KOP-2026-09-0310",
    "name": "NARAYAN BUDEK",
    "mobile": "7735005413",
    "dob": "2005-03-26",
    "district": "Balangir",
    "regNoSuffix": "0310"
  },
  {
    "registrationNumber": "KOP/2026/09/0311",
    "docId": "KOP-2026-09-0311",
    "name": "SEEMA BAG",
    "mobile": "6372151386",
    "dob": "2002-03-14",
    "district": "Balangir",
    "regNoSuffix": "0311"
  },
  {
    "registrationNumber": "KOP/2026/09/0312",
    "docId": "KOP-2026-09-0312",
    "name": "PAPUN KHARSEL",
    "mobile": "6371303279",
    "dob": "2006-04-23",
    "district": "Balangir",
    "regNoSuffix": "0312"
  },
  {
    "registrationNumber": "KOP/2026/09/0313",
    "docId": "KOP-2026-09-0313",
    "name": "RAHUL RANA",
    "mobile": "7735737304",
    "dob": "2005-12-13",
    "district": "Balangir",
    "regNoSuffix": "0313"
  },
  {
    "registrationNumber": "KOP/2026/09/0314",
    "docId": "KOP-2026-09-0314",
    "name": "SAROJ KUMAR MALLIK",
    "mobile": "9658664173",
    "dob": "1985-12-04",
    "district": "Balangir",
    "regNoSuffix": "0314"
  },
  {
    "registrationNumber": "KOP/2026/09/0315",
    "docId": "KOP-2026-09-0315",
    "name": "NARENDRA SAHU",
    "mobile": "7684049235",
    "dob": "2001-11-26",
    "district": "Balangir",
    "regNoSuffix": "0315"
  },
  {
    "registrationNumber": "KOP/2026/07/0321",
    "docId": "KOP-2026-07-0321",
    "name": "RAJKISHOR SETHI",
    "mobile": "9937775201",
    "dob": "1986-06-15",
    "district": "Nuapada",
    "regNoSuffix": "0321"
  },
  {
    "registrationNumber": "KOP/2026/07/0322",
    "docId": "KOP-2026-07-0322",
    "name": "KUNTALA  MAJHI",
    "mobile": "8658300711",
    "dob": "1999-03-10",
    "district": "Nuapada",
    "regNoSuffix": "0322"
  },
  {
    "registrationNumber": "KOP/2026/07/0323",
    "docId": "KOP-2026-07-0323",
    "name": "POOJA RANI MAHARANA",
    "mobile": "8658973120",
    "dob": "2000-03-19",
    "district": "Sonepur",
    "regNoSuffix": "0323"
  },
  {
    "registrationNumber": "KOP/2026/07/0324",
    "docId": "KOP-2026-07-0324",
    "name": "AJIT KUMAR DAS",
    "mobile": "8658073871",
    "dob": "2003-02-03",
    "district": "Kendrapara",
    "regNoSuffix": "0324"
  },
  {
    "registrationNumber": "KOP/2026/07/0325",
    "docId": "KOP-2026-07-0325",
    "name": "PRIYA  YADAV",
    "mobile": "7605986014",
    "dob": "1995-08-28",
    "district": "Balangir",
    "regNoSuffix": "0325"
  },
  {
    "registrationNumber": "KOP/2026/07/0326",
    "docId": "KOP-2026-07-0326",
    "name": "ASIT KUMAR DUTTA",
    "mobile": "8984255267",
    "dob": "1993-10-06",
    "district": "Balasore",
    "regNoSuffix": "0326"
  },
  {
    "registrationNumber": "KOP/2026/07/0327",
    "docId": "KOP-2026-07-0327",
    "name": "ANIMA  PATRA",
    "mobile": "9078510781",
    "dob": "1998-04-06",
    "district": "Balasore",
    "regNoSuffix": "0327"
  },
  {
    "registrationNumber": "KOP/2026/07/0328",
    "docId": "KOP-2026-07-0328",
    "name": "ANADI DEHURY",
    "mobile": "9956033155",
    "dob": "1996-07-19",
    "district": "Angul",
    "regNoSuffix": "0328"
  },
  {
    "registrationNumber": "KOP/2026/07/0329",
    "docId": "KOP-2026-07-0329",
    "name": "DHANSING  BAG",
    "mobile": "8658922119",
    "dob": "2001-10-22",
    "district": "Nuapada",
    "regNoSuffix": "0329"
  },
  {
    "registrationNumber": "KOP/2026/07/0330",
    "docId": "KOP-2026-07-0330",
    "name": "GATISH KUMAR SAHU",
    "mobile": "9937147763",
    "dob": "1998-04-20",
    "district": "Angul",
    "regNoSuffix": "0330"
  },
  {
    "registrationNumber": "KOP/2026/07/0331",
    "docId": "KOP-2026-07-0331",
    "name": "ALPANA  SAMAL",
    "mobile": "6370806671",
    "dob": "1984-02-15",
    "district": "Balasore",
    "regNoSuffix": "0331"
  },
  {
    "registrationNumber": "KOP/2026/07/0332",
    "docId": "KOP-2026-07-0332",
    "name": "NIBEDITA  PATRA",
    "mobile": "7894968957",
    "dob": "1992-04-28",
    "district": "Balasore",
    "regNoSuffix": "0332"
  },
  {
    "registrationNumber": "KOP/2026/07/0333",
    "docId": "KOP-2026-07-0333",
    "name": "PRASANNA KUMAR BARAL",
    "mobile": "7788832772",
    "dob": "2002-12-21",
    "district": "Khordha",
    "regNoSuffix": "0333"
  },
  {
    "registrationNumber": "KOP/2026/07/0334",
    "docId": "KOP-2026-07-0334",
    "name": "JAYA PRAKASH  PARIDA",
    "mobile": "8338899816",
    "dob": "2003-09-10",
    "district": "Bhadrak",
    "regNoSuffix": "0334"
  },
  {
    "registrationNumber": "KOP/2026/07/0335",
    "docId": "KOP-2026-07-0335",
    "name": "GANESH KUMAR MOHAPATRA",
    "mobile": "9776135160",
    "dob": "1997-12-30",
    "district": "Mayurbhanj",
    "regNoSuffix": "0335"
  },
  {
    "registrationNumber": "KOP/2026/07/0336",
    "docId": "KOP-2026-07-0336",
    "name": "NAMITA  DAS",
    "mobile": "9777834796",
    "dob": "1992-04-24",
    "district": "Balasore",
    "regNoSuffix": "0336"
  },
  {
    "registrationNumber": "KOP/2026/07/0337",
    "docId": "KOP-2026-07-0337",
    "name": "SAUMYARANJAN  BAGH",
    "mobile": "7684908465",
    "dob": "2006-04-12",
    "district": "Sonepur",
    "regNoSuffix": "0337"
  },
  {
    "registrationNumber": "KOP/2026/07/0338",
    "docId": "KOP-2026-07-0338",
    "name": "UMASANKAR  PATEL",
    "mobile": "6371923023",
    "dob": "2004-10-05",
    "district": "Balangir",
    "regNoSuffix": "0338"
  },
  {
    "registrationNumber": "KOP/2026/07/0339",
    "docId": "KOP-2026-07-0339",
    "name": "SURAJ KUMAR PATEL",
    "mobile": "9348325270",
    "dob": "1999-07-14",
    "district": "Balangir",
    "regNoSuffix": "0339"
  },
  {
    "registrationNumber": "KOP/2026/07/0340",
    "docId": "KOP-2026-07-0340",
    "name": "KISHORE  DALEI",
    "mobile": "9078643871",
    "dob": "1999-04-03",
    "district": "Malkangiri",
    "regNoSuffix": "0340"
  },
  {
    "registrationNumber": "KOP/2026/07/0341",
    "docId": "KOP-2026-07-0341",
    "name": "NILAMADHAB  CHOUDHURY",
    "mobile": "9692339747",
    "dob": "2005-10-28",
    "district": "Malkangiri",
    "regNoSuffix": "0341"
  },
  {
    "registrationNumber": "KOP/2026/07/0342",
    "docId": "KOP-2026-07-0342",
    "name": "SANTOSH  KANSARI",
    "mobile": "8144353328",
    "dob": "2000-05-03",
    "district": "Koraput",
    "regNoSuffix": "0342"
  },
  {
    "registrationNumber": "KOP/2026/07/0343",
    "docId": "KOP-2026-07-0343",
    "name": "RABINDRA  GATAN",
    "mobile": "8260576289",
    "dob": "2004-01-01",
    "district": "Malkangiri",
    "regNoSuffix": "0343"
  },
  {
    "registrationNumber": "KOP/2026/07/0344",
    "docId": "KOP-2026-07-0344",
    "name": "JYOTIMAYEE  HANS",
    "mobile": "7991013062",
    "dob": "2001-11-20",
    "district": "Nuapada",
    "regNoSuffix": "0344"
  },
  {
    "registrationNumber": "KOP/2026/07/0345",
    "docId": "KOP-2026-07-0345",
    "name": "GAYATRI  KATA",
    "mobile": "6372794284",
    "dob": "1996-12-12",
    "district": "Nuapada",
    "regNoSuffix": "0345"
  },
  {
    "registrationNumber": "KOP/2026/07/0346",
    "docId": "KOP-2026-07-0346",
    "name": "BHAKTA CHARAN  SAHU",
    "mobile": "8926218006",
    "dob": "2007-05-06",
    "district": "Nuapada",
    "regNoSuffix": "0346"
  },
  {
    "registrationNumber": "KOP/2026/07/0347",
    "docId": "KOP-2026-07-0347",
    "name": "LOKESH  BEHERA",
    "mobile": "7327863984",
    "dob": "2005-10-05",
    "district": "Nuapada",
    "regNoSuffix": "0347"
  },
  {
    "registrationNumber": "KOP/2026/07/0348",
    "docId": "KOP-2026-07-0348",
    "name": "MANISHA  PATTJOSHI",
    "mobile": "9348874536",
    "dob": "2005-04-12",
    "district": "Kalahandi",
    "regNoSuffix": "0348"
  },
  {
    "registrationNumber": "KOP/2026/07/0349",
    "docId": "KOP-2026-07-0349",
    "name": "JYOTSNA  MAJHI",
    "mobile": "9827738103",
    "dob": "1998-02-15",
    "district": "Nuapada",
    "regNoSuffix": "0349"
  },
  {
    "registrationNumber": "KOP/2026/07/0350",
    "docId": "KOP-2026-07-0350",
    "name": "AMAN  MAHANAND",
    "mobile": "8658507686",
    "dob": "2001-03-18",
    "district": "Nuapada",
    "regNoSuffix": "0350"
  },
  {
    "registrationNumber": "KOP/2026/07/0351",
    "docId": "KOP-2026-07-0351",
    "name": "AMARESH RANJAN THAKUR",
    "mobile": "8457048262",
    "dob": "1994-12-22",
    "district": "Nuapada",
    "regNoSuffix": "0351"
  },
  {
    "registrationNumber": "KOP/2026/07/0352",
    "docId": "KOP-2026-07-0352",
    "name": "NIRUPAMA  BAG",
    "mobile": "7978845463",
    "dob": "2006-08-04",
    "district": "Nuapada",
    "regNoSuffix": "0352"
  },
  {
    "registrationNumber": "KOP/2026/07/0353",
    "docId": "KOP-2026-07-0353",
    "name": "JANMEJAYA  SAHU",
    "mobile": "9337916563",
    "dob": "1992-02-01",
    "district": "Balangir",
    "regNoSuffix": "0353"
  },
  {
    "registrationNumber": "KOP/2026/07/0354",
    "docId": "KOP-2026-07-0354",
    "name": "SUBASINI  BISWAL",
    "mobile": "9178359069",
    "dob": "1989-07-09",
    "district": "Sonepur",
    "regNoSuffix": "0354"
  },
  {
    "registrationNumber": "KOP/2026/07/0355",
    "docId": "KOP-2026-07-0355",
    "name": "LIPIKA  PADHAN",
    "mobile": "8144390947",
    "dob": "2002-12-11",
    "district": "Sonepur",
    "regNoSuffix": "0355"
  },
  {
    "registrationNumber": "KOP/2026/07/0356",
    "docId": "KOP-2026-07-0356",
    "name": "SUJIT KUMAR  PRADHAN",
    "mobile": "9937570530",
    "dob": "1990-05-01",
    "district": "Balasore",
    "regNoSuffix": "0356"
  },
  {
    "registrationNumber": "KOP/2026/07/0357",
    "docId": "KOP-2026-07-0357",
    "name": "PUSHPANJALI  MAJHI",
    "mobile": "8249233990",
    "dob": "2002-03-13",
    "district": "Nuapada",
    "regNoSuffix": "0357"
  },
  {
    "registrationNumber": "KOP/2026/07/0358",
    "docId": "KOP-2026-07-0358",
    "name": "ARCHANA  BAITHARU",
    "mobile": "7682979856",
    "dob": "1993-06-05",
    "district": "Nuapada",
    "regNoSuffix": "0358"
  },
  {
    "registrationNumber": "KOP/2026/07/0359",
    "docId": "KOP-2026-07-0359",
    "name": "SARITA  PANIGRAHI",
    "mobile": "9668434165",
    "dob": "1992-05-01",
    "district": "Nuapada",
    "regNoSuffix": "0359"
  },
  {
    "registrationNumber": "KOP/2026/07/0360",
    "docId": "KOP-2026-07-0360",
    "name": "JYOTIRMAYEE DHAL",
    "mobile": "8018945561",
    "dob": "1992-07-11",
    "district": "Nuapada",
    "regNoSuffix": "0360"
  },
  {
    "registrationNumber": "KOP/2026/07/0361",
    "docId": "KOP-2026-07-0361",
    "name": "DIPTIMAYEE  SAHOO",
    "mobile": "8018584699",
    "dob": "1995-03-08",
    "district": "Dhenkanal",
    "regNoSuffix": "0361"
  },
  {
    "registrationNumber": "KOP/2026/07/0362",
    "docId": "KOP-2026-07-0362",
    "name": "RAKESH  PATRA",
    "mobile": "9337829728",
    "dob": "1999-06-17",
    "district": "Ganjam",
    "regNoSuffix": "0362"
  },
  {
    "registrationNumber": "KOP/2026/07/0363",
    "docId": "KOP-2026-07-0363",
    "name": "TULSEERAM MAJHI",
    "mobile": "9178832617",
    "dob": "1989-07-10",
    "district": "Nuapada",
    "regNoSuffix": "0363"
  },
  {
    "registrationNumber": "KOP/2026/07/0364",
    "docId": "KOP-2026-07-0364",
    "name": "TIKESWAR  URMA",
    "mobile": "8018778589",
    "dob": "2007-02-05",
    "district": "Boudh",
    "regNoSuffix": "0364"
  },
  {
    "registrationNumber": "KOP/2026/07/0365",
    "docId": "KOP-2026-07-0365",
    "name": "RAJAT KUMAR PANIGRAHI",
    "mobile": "8455929628",
    "dob": "1996-09-18",
    "district": "Nuapada",
    "regNoSuffix": "0365"
  },
  {
    "registrationNumber": "KOP/2026/07/0366",
    "docId": "KOP-2026-07-0366",
    "name": "TAMRADHWAJ  PANDA",
    "mobile": "6372980235",
    "dob": "2000-03-01",
    "district": "Nabarangpur",
    "regNoSuffix": "0366"
  },
  {
    "registrationNumber": "KOP/2026/07/0367",
    "docId": "KOP-2026-07-0367",
    "name": "GIRISH  BAG",
    "mobile": "9692288745",
    "dob": "2001-05-15",
    "district": "Nuapada",
    "regNoSuffix": "0367"
  },
  {
    "registrationNumber": "KOP/2026/07/0368",
    "docId": "KOP-2026-07-0368",
    "name": "NIKTA  JAGAT",
    "mobile": "7854967237",
    "dob": "2004-06-15",
    "district": "Nuapada",
    "regNoSuffix": "0368"
  },
  {
    "registrationNumber": "KOP/2026/07/0369",
    "docId": "KOP-2026-07-0369",
    "name": "RENUKA PATRA",
    "mobile": "8926241131",
    "dob": "1999-06-08",
    "district": "Nuapada",
    "regNoSuffix": "0369"
  },
  {
    "registrationNumber": "KOP/2026/07/0370",
    "docId": "KOP-2026-07-0370",
    "name": "SMRUTISIKHA HANS",
    "mobile": "9938320915",
    "dob": "2006-06-20",
    "district": "Nuapada",
    "regNoSuffix": "0370"
  },
  {
    "registrationNumber": "KOP/2026/07/0371",
    "docId": "KOP-2026-07-0371",
    "name": "SANJIT BAG",
    "mobile": "9692228910",
    "dob": "2008-06-12",
    "district": "Nuapada",
    "regNoSuffix": "0371"
  },
  {
    "registrationNumber": "KOP/2026/07/0372",
    "docId": "KOP-2026-07-0372",
    "name": "SONALIKA  PUROHIT",
    "mobile": "7077415289",
    "dob": "2003-08-17",
    "district": "Nuapada",
    "regNoSuffix": "0372"
  },
  {
    "registrationNumber": "KOP/2026/07/0373",
    "docId": "KOP-2026-07-0373",
    "name": "KHIRADRI TANAYA  HANS",
    "mobile": "6370557598",
    "dob": "2007-03-16",
    "district": "Nuapada",
    "regNoSuffix": "0373"
  },
  {
    "registrationNumber": "KOP/2026/07/0374",
    "docId": "KOP-2026-07-0374",
    "name": "BHAKTA CHARAN  GAHIR",
    "mobile": "8658300516",
    "dob": "1992-12-15",
    "district": "Nuapada",
    "regNoSuffix": "0374"
  },
  {
    "registrationNumber": "KOP/2026/07/0375",
    "docId": "KOP-2026-07-0375",
    "name": "LAXMAN  SATNAMI",
    "mobile": "9937127484",
    "dob": "1993-07-08",
    "district": "Nuapada",
    "regNoSuffix": "0375"
  },
  {
    "registrationNumber": "KOP/2026/07/0376",
    "docId": "KOP-2026-07-0376",
    "name": "NIHAR RANJAN KUMAR MAJHI",
    "mobile": "8658145264",
    "dob": "2000-12-23",
    "district": "Balangir",
    "regNoSuffix": "0376"
  },
  {
    "registrationNumber": "KOP/2026/07/0377",
    "docId": "KOP-2026-07-0377",
    "name": "MITRABHANU SABAR",
    "mobile": "7978318199",
    "dob": "2002-03-03",
    "district": "Nuapada",
    "regNoSuffix": "0377"
  },
  {
    "registrationNumber": "KOP/2026/07/0378",
    "docId": "KOP-2026-07-0378",
    "name": "PRIYANKA  RAY",
    "mobile": "9938091929",
    "dob": "1992-07-05",
    "district": "Balangir",
    "regNoSuffix": "0378"
  },
  {
    "registrationNumber": "KOP/2026/07/0379",
    "docId": "KOP-2026-07-0379",
    "name": "PREMANANDA  SUNANEE",
    "mobile": "9777899552",
    "dob": "2004-02-15",
    "district": "Nuapada",
    "regNoSuffix": "0379"
  },
  {
    "registrationNumber": "KOP/2026/07/0380",
    "docId": "KOP-2026-07-0380",
    "name": "MANISH  PUTEL",
    "mobile": "8018178123",
    "dob": "2004-10-22",
    "district": "Balangir",
    "regNoSuffix": "0380"
  },
  {
    "registrationNumber": "KOP/2026/07/0381",
    "docId": "KOP-2026-07-0381",
    "name": "PRASANT SUNA",
    "mobile": "7847895537",
    "dob": "2006-01-25",
    "district": "Nuapada",
    "regNoSuffix": "0381"
  },
  {
    "registrationNumber": "KOP/2026/07/0382",
    "docId": "KOP-2026-07-0382",
    "name": "BISHAL  KHAMARI",
    "mobile": "8144655345",
    "dob": "1996-06-27",
    "district": "Nuapada",
    "regNoSuffix": "0382"
  },
  {
    "registrationNumber": "KOP/2026/07/0383",
    "docId": "KOP-2026-07-0383",
    "name": "DAINU DILAN  BEHERA",
    "mobile": "7326992224",
    "dob": "2003-06-05",
    "district": "Nuapada",
    "regNoSuffix": "0383"
  },
  {
    "registrationNumber": "KOP/2026/07/0384",
    "docId": "KOP-2026-07-0384",
    "name": "MOUSUMI  NAIK",
    "mobile": "7205022498",
    "dob": "2001-12-07",
    "district": "Nuapada",
    "regNoSuffix": "0384"
  },
  {
    "registrationNumber": "KOP/2026/07/0385",
    "docId": "KOP-2026-07-0385",
    "name": "SARITA  BEHERA",
    "mobile": "8018702747",
    "dob": "1993-02-06",
    "district": "Sambalpur",
    "regNoSuffix": "0385"
  },
  {
    "registrationNumber": "KOP/2026/07/0386",
    "docId": "KOP-2026-07-0386",
    "name": "RATIKANTA  SWAIN",
    "mobile": "7894556545",
    "dob": "1994-03-02",
    "district": "Kendrapara",
    "regNoSuffix": "0386"
  },
  {
    "registrationNumber": "KOP/2026/07/0387",
    "docId": "KOP-2026-07-0387",
    "name": "GOPABANDHU  PAL",
    "mobile": "7873487248",
    "dob": "1996-04-15",
    "district": "Balasore",
    "regNoSuffix": "0387"
  },
  {
    "registrationNumber": "KOP/2026/07/0388",
    "docId": "KOP-2026-07-0388",
    "name": "SUBHAM  PATEL",
    "mobile": "7735472183",
    "dob": "2001-05-28",
    "district": "Balangir",
    "regNoSuffix": "0388"
  },
  {
    "registrationNumber": "KOP/2026/07/0390",
    "docId": "KOP-2026-07-0390",
    "name": "BIMAL  PATEL",
    "mobile": "9178849707",
    "dob": "1998-11-09",
    "district": "Balangir",
    "regNoSuffix": "0390"
  },
  {
    "registrationNumber": "KOP/2026/07/0391",
    "docId": "KOP-2026-07-0391",
    "name": "MAHESH KUMAR MISHRA",
    "mobile": "8658953158",
    "dob": "1994-05-06",
    "district": "Sonepur",
    "regNoSuffix": "0391"
  },
  {
    "registrationNumber": "KOP/2026/07/0392",
    "docId": "KOP-2026-07-0392",
    "name": "RAGHUNANDAN NANDA",
    "mobile": "7978374070",
    "dob": "1991-06-15",
    "district": "Balasore",
    "regNoSuffix": "0392"
  },
  {
    "registrationNumber": "KOP/2026/07/0393",
    "docId": "KOP-2026-07-0393",
    "name": "SUNITI SAHU",
    "mobile": "7853911612",
    "dob": "1998-03-05",
    "district": "Boudh",
    "regNoSuffix": "0393"
  },
  {
    "registrationNumber": "KOP/2026/07/0394",
    "docId": "KOP-2026-07-0394",
    "name": "BENUDHAR  SAHOO",
    "mobile": "9178522254",
    "dob": "1997-02-28",
    "district": "Balasore",
    "regNoSuffix": "0394"
  },
  {
    "registrationNumber": "KOP/2026/07/0395",
    "docId": "KOP-2026-07-0395",
    "name": "SAMBIT KUMAR  JENA",
    "mobile": "8249752529",
    "dob": "1995-05-02",
    "district": "Balasore",
    "regNoSuffix": "0395"
  },
  {
    "registrationNumber": "KOP/2026/07/0396",
    "docId": "KOP-2026-07-0396",
    "name": "TRUPTIRANI MEHER",
    "mobile": "8144170469",
    "dob": "1996-06-11",
    "district": "Boudh",
    "regNoSuffix": "0396"
  },
  {
    "registrationNumber": "KOP/2026/07/0397",
    "docId": "KOP-2026-07-0397",
    "name": "ROCKY RAJ ROUT",
    "mobile": "7978634994",
    "dob": "2002-11-28",
    "district": "Balangir",
    "regNoSuffix": "0397"
  },
  {
    "registrationNumber": "KOP/2026/07/0398",
    "docId": "KOP-2026-07-0398",
    "name": "HRUSHIKESH  MEHER",
    "mobile": "9938834825",
    "dob": "2003-06-04",
    "district": "Nuapada",
    "regNoSuffix": "0398"
  },
  {
    "registrationNumber": "KOP/2026/07/0399",
    "docId": "KOP-2026-07-0399",
    "name": "DURYODHAN  MEHER",
    "mobile": "9937750478",
    "dob": "2000-03-07",
    "district": "Nuapada",
    "regNoSuffix": "0399"
  },
  {
    "registrationNumber": "KOP/2026/07/0400",
    "docId": "KOP-2026-07-0400",
    "name": "MAHESH KUMAR HANS",
    "mobile": "6370784640",
    "dob": "1996-06-23",
    "district": "Nuapada",
    "regNoSuffix": "0400"
  },
  {
    "registrationNumber": "KOP/2026/07/0401",
    "docId": "KOP-2026-07-0401",
    "name": "BHAGYABAN RANA",
    "mobile": "8456003727",
    "dob": "2000-02-25",
    "district": "Nuapada",
    "regNoSuffix": "0401"
  },
  {
    "registrationNumber": "KOP/2026/07/0402",
    "docId": "KOP-2026-07-0402",
    "name": "SAKUNTALA  BHOI",
    "mobile": "9337728606",
    "dob": "1993-05-11",
    "district": "Balangir",
    "regNoSuffix": "0402"
  },
  {
    "registrationNumber": "KOP/2026/07/0403",
    "docId": "KOP-2026-07-0403",
    "name": "BINAYA RANJAN PANDA",
    "mobile": "9668855442",
    "dob": "1990-11-13",
    "district": "Nuapada",
    "regNoSuffix": "0403"
  },
  {
    "registrationNumber": "KOP/2026/07/0404",
    "docId": "KOP-2026-07-0404",
    "name": "NAMITA  PANDA",
    "mobile": "8658712717",
    "dob": "1987-12-31",
    "district": "Nuapada",
    "regNoSuffix": "0404"
  },
  {
    "registrationNumber": "KOP/2026/07/0405",
    "docId": "KOP-2026-07-0405",
    "name": "DROPADI  SABAR",
    "mobile": "7854949939",
    "dob": "1993-02-01",
    "district": "Nuapada",
    "regNoSuffix": "0405"
  },
  {
    "registrationNumber": "KOP/2026/07/0406",
    "docId": "KOP-2026-07-0406",
    "name": "TIKELAL  MEHER",
    "mobile": "9668852804",
    "dob": "2003-09-25",
    "district": "Nuapada",
    "regNoSuffix": "0406"
  },
  {
    "registrationNumber": "KOP/2026/07/0407",
    "docId": "KOP-2026-07-0407",
    "name": "ABINASH  NAIK",
    "mobile": "9348562442",
    "dob": "2004-03-22",
    "district": "Nuapada",
    "regNoSuffix": "0407"
  },
  {
    "registrationNumber": "KOP/2026/07/0408",
    "docId": "KOP-2026-07-0408",
    "name": "MADAN MOHAN SAGAR",
    "mobile": "8249403908",
    "dob": "1991-05-08",
    "district": "Nuapada",
    "regNoSuffix": "0408"
  },
  {
    "registrationNumber": "KOP/2026/07/0409",
    "docId": "KOP-2026-07-0409",
    "name": "ABINASH KUMAR NAG",
    "mobile": "9556261253",
    "dob": "1993-12-06",
    "district": "Nuapada",
    "regNoSuffix": "0409"
  },
  {
    "registrationNumber": "KOP/2026/07/0410",
    "docId": "KOP-2026-07-0410",
    "name": "JASOBANTA  CHHATRIA",
    "mobile": "8457922982",
    "dob": "2002-02-03",
    "district": "Nuapada",
    "regNoSuffix": "0410"
  },
  {
    "registrationNumber": "KOP/2026/07/0411",
    "docId": "KOP-2026-07-0411",
    "name": "PIYUSH  KUMAR",
    "mobile": "7750015011",
    "dob": "0002-12-01",
    "district": "Nuapada",
    "regNoSuffix": "0411"
  },
  {
    "registrationNumber": "KOP/2026/07/0412",
    "docId": "KOP-2026-07-0412",
    "name": "HEMANAND  PATEL",
    "mobile": "7609889493",
    "dob": "2001-02-07",
    "district": "Nuapada",
    "regNoSuffix": "0412"
  },
  {
    "registrationNumber": "KOP/2026/07/0413",
    "docId": "KOP-2026-07-0413",
    "name": "BISWAMBAR  MAJHI",
    "mobile": "8917505913",
    "dob": "1991-04-18",
    "district": "Nuapada",
    "regNoSuffix": "0413"
  },
  {
    "registrationNumber": "KOP/2026/07/0414",
    "docId": "KOP-2026-07-0414",
    "name": "DHARMENDRA  SAHU",
    "mobile": "7894372711",
    "dob": "1991-06-20",
    "district": "Kalahandi",
    "regNoSuffix": "0414"
  },
  {
    "registrationNumber": "KOP/2026/07/0415",
    "docId": "KOP-2026-07-0415",
    "name": "MUKESH  BIBHAR",
    "mobile": "7815016276",
    "dob": "2001-04-09",
    "district": "Nuapada",
    "regNoSuffix": "0415"
  },
  {
    "registrationNumber": "KOP/2026/07/0416",
    "docId": "KOP-2026-07-0416",
    "name": "RITESH RANJAN NAIK",
    "mobile": "7077373766",
    "dob": "2002-05-25",
    "district": "Nuapada",
    "regNoSuffix": "0416"
  },
  {
    "registrationNumber": "KOP/2026/07/0417",
    "docId": "KOP-2026-07-0417",
    "name": "BINAYA KUMAR  BARIK",
    "mobile": "7008203054",
    "dob": "1996-04-11",
    "district": "Nuapada",
    "regNoSuffix": "0417"
  },
  {
    "registrationNumber": "KOP/2026/07/0418",
    "docId": "KOP-2026-07-0418",
    "name": "SUKESH KUMAR TANDI",
    "mobile": "9178768615",
    "dob": "1989-01-22",
    "district": "BALANGIR",
    "regNoSuffix": "0418"
  },
  {
    "registrationNumber": "KOP/2026/07/0419",
    "docId": "KOP-2026-07-0419",
    "name": "MOHIT  BHOI",
    "mobile": "8839241025",
    "dob": "1998-10-17",
    "district": "Nuapada",
    "regNoSuffix": "0419"
  },
  {
    "registrationNumber": "KOP/2026/07/0420",
    "docId": "KOP-2026-07-0420",
    "name": "BHISHMA  BHITRIA",
    "mobile": "8144885451",
    "dob": "1997-11-20",
    "district": "Nuapada",
    "regNoSuffix": "0420"
  },
  {
    "registrationNumber": "KOP/2026/07/0421",
    "docId": "KOP-2026-07-0421",
    "name": "GHANASHYAM  SUNA",
    "mobile": "6372875834",
    "dob": "2002-08-02",
    "district": "Nuapada",
    "regNoSuffix": "0421"
  },
  {
    "registrationNumber": "KOP/2026/07/0422",
    "docId": "KOP-2026-07-0422",
    "name": "TARENI  BAG",
    "mobile": "8917565686",
    "dob": "1988-06-21",
    "district": "Nuapada",
    "regNoSuffix": "0422"
  },
  {
    "registrationNumber": "KOP/2026/07/0423",
    "docId": "KOP-2026-07-0423",
    "name": "DEEPAK KUMAR  TENDKARI",
    "mobile": "9178723553",
    "dob": "1993-01-15",
    "district": "Nuapada",
    "regNoSuffix": "0423"
  },
  {
    "registrationNumber": "KOP/2026/07/0424",
    "docId": "KOP-2026-07-0424",
    "name": "SUMANTA  NAIK",
    "mobile": "7751935432",
    "dob": "2000-03-23",
    "district": "Nuapada",
    "regNoSuffix": "0424"
  },
  {
    "registrationNumber": "KOP/2026/07/0425",
    "docId": "KOP-2026-07-0425",
    "name": "RAGHABENDRA PRATAP SINGH BARIK",
    "mobile": "9777499719",
    "dob": "2003-11-22",
    "district": "Nuapada",
    "regNoSuffix": "0425"
  },
  {
    "registrationNumber": "KOP/2026/07/0426",
    "docId": "KOP-2026-07-0426",
    "name": "JYOTI  BAG",
    "mobile": "9692531970",
    "dob": "2006-01-28",
    "district": "Nuapada",
    "regNoSuffix": "0426"
  },
  {
    "registrationNumber": "KOP/2026/07/0427",
    "docId": "KOP-2026-07-0427",
    "name": "PRATIMA  SUNA",
    "mobile": "8144141149",
    "dob": "2001-03-06",
    "district": "Nuapada",
    "regNoSuffix": "0427"
  },
  {
    "registrationNumber": "KOP/2026/07/0428",
    "docId": "KOP-2026-07-0428",
    "name": "RUPESH KUMAR  KHAMARI",
    "mobile": "8455986315",
    "dob": "1994-04-30",
    "district": "Nuapada",
    "regNoSuffix": "0428"
  },
  {
    "registrationNumber": "KOP/2026/07/0429",
    "docId": "KOP-2026-07-0429",
    "name": "RAJESWARI  NAIK",
    "mobile": "9938460606",
    "dob": "1996-10-14",
    "district": "Nuapada",
    "regNoSuffix": "0429"
  },
  {
    "registrationNumber": "KOP/2026/07/0430",
    "docId": "KOP-2026-07-0430",
    "name": "BHAKTARAJ PATEL",
    "mobile": "7609929614",
    "dob": "2006-11-23",
    "district": "Nuapada",
    "regNoSuffix": "0430"
  },
  {
    "registrationNumber": "KOP/2026/07/0431",
    "docId": "KOP-2026-07-0431",
    "name": "BIKASH  PATEL",
    "mobile": "9078924124",
    "dob": "2003-12-08",
    "district": "Nuapada",
    "regNoSuffix": "0431"
  },
  {
    "registrationNumber": "KOP/2026/07/0432",
    "docId": "KOP-2026-07-0432",
    "name": "HEMANDINI  SAGAR",
    "mobile": "7894098098",
    "dob": "1999-03-07",
    "district": "Nuapada",
    "regNoSuffix": "0432"
  },
  {
    "registrationNumber": "KOP/2026/07/0433",
    "docId": "KOP-2026-07-0433",
    "name": "HEMAKANTA  DARJI",
    "mobile": "9777384036",
    "dob": "1995-03-11",
    "district": "Balangir",
    "regNoSuffix": "0433"
  },
  {
    "registrationNumber": "KOP/2026/07/0434",
    "docId": "KOP-2026-07-0434",
    "name": "ARATI  JAGAT",
    "mobile": "8917516676",
    "dob": "1995-07-29",
    "district": "Nuapada",
    "regNoSuffix": "0434"
  },
  {
    "registrationNumber": "KOP/2026/07/0435",
    "docId": "KOP-2026-07-0435",
    "name": "MUKESH KUMAR  DUBE",
    "mobile": "8658999210",
    "dob": "2026-05-28",
    "district": "Nuapada",
    "regNoSuffix": "0435"
  },
  {
    "registrationNumber": "KOP/2026/07/0436",
    "docId": "KOP-2026-07-0436",
    "name": "TOSHALI  DEEP",
    "mobile": "8328891293",
    "dob": "2005-05-22",
    "district": "Nuapada",
    "regNoSuffix": "0436"
  },
  {
    "registrationNumber": "KOP/2026/07/0437",
    "docId": "KOP-2026-07-0437",
    "name": "SIBASIS DEEP",
    "mobile": "8328891293",
    "dob": "2004-05-06",
    "district": "Nuapada",
    "regNoSuffix": "0437"
  },
  {
    "registrationNumber": "KOP/2026/07/0438",
    "docId": "KOP-2026-07-0438",
    "name": "SASHIKANT  PRADHAN",
    "mobile": "9178178077",
    "dob": "1993-01-05",
    "district": "Kendrapara",
    "regNoSuffix": "0438"
  },
  {
    "registrationNumber": "KOP/2026/07/0439",
    "docId": "KOP-2026-07-0439",
    "name": "RONALISHA PRADHAN",
    "mobile": "8260452711",
    "dob": "1995-08-02",
    "district": "Kendrapara",
    "regNoSuffix": "0439"
  },
  {
    "registrationNumber": "KOP/2026/07/0440",
    "docId": "KOP-2026-07-0440",
    "name": "SONALI  BEHERA",
    "mobile": "9337083621",
    "dob": "2004-02-02",
    "district": "Kendrapara",
    "regNoSuffix": "0440"
  },
  {
    "registrationNumber": "KOP/2026/07/0441",
    "docId": "KOP-2026-07-0441",
    "name": "HAREKRUSHNA  BEHERA",
    "mobile": "7608952488",
    "dob": "2002-02-20",
    "district": "Angul",
    "regNoSuffix": "0441"
  },
  {
    "registrationNumber": "KOP/2026/07/0442",
    "docId": "KOP-2026-07-0442",
    "name": "BIKASH KUMAR  SAHU",
    "mobile": "7853866240",
    "dob": "2001-11-09",
    "district": "Nuapada",
    "regNoSuffix": "0442"
  },
  {
    "registrationNumber": "KOP/2026/07/0443",
    "docId": "KOP-2026-07-0443",
    "name": "RAM MOHAN SHIV SUNDAR KARNA",
    "mobile": "7684884640",
    "dob": "2003-01-15",
    "district": "Sonepur",
    "regNoSuffix": "0443"
  },
  {
    "registrationNumber": "KOP/2026/07/0444",
    "docId": "KOP-2026-07-0444",
    "name": "BISWAJIT  NAYAK",
    "mobile": "8260635903",
    "dob": "2005-01-20",
    "district": "Rayagada",
    "regNoSuffix": "0444"
  },
  {
    "registrationNumber": "KOP/2026/07/0445",
    "docId": "KOP-2026-07-0445",
    "name": "DEEPAK  NAIK",
    "mobile": "8456907030",
    "dob": "1994-06-08",
    "district": "Kalahandi",
    "regNoSuffix": "0445"
  },
  {
    "registrationNumber": "KOP/2026/07/0446",
    "docId": "KOP-2026-07-0446",
    "name": "MOHIT LAL NIAL",
    "mobile": "7846983366",
    "dob": "2001-01-10",
    "district": "Nuapada",
    "regNoSuffix": "0446"
  },
  {
    "registrationNumber": "KOP/2026/07/0447",
    "docId": "KOP-2026-07-0447",
    "name": "KARMA  SAHU",
    "mobile": "9348525392",
    "dob": "1999-06-22",
    "district": "Bargarh",
    "regNoSuffix": "0447"
  },
  {
    "registrationNumber": "KOP/2026/07/0448",
    "docId": "KOP-2026-07-0448",
    "name": "SAGAR PRASAD  GOUDA",
    "mobile": "7077834158",
    "dob": "1999-05-22",
    "district": "Rayagada",
    "regNoSuffix": "0448"
  },
  {
    "registrationNumber": "KOP/2026/07/0449",
    "docId": "KOP-2026-07-0449",
    "name": "KUNAL  BEHERA",
    "mobile": "9668530872",
    "dob": "2002-11-23",
    "district": "Rayagada",
    "regNoSuffix": "0449"
  },
  {
    "registrationNumber": "KOP/2026/08/0450",
    "docId": "KOP-2026-08-0450",
    "name": "DASARATH  MAJHI",
    "mobile": "6371923936",
    "dob": "2000-04-06",
    "district": "Kalahandi",
    "regNoSuffix": "0450"
  },
  {
    "registrationNumber": "KOP/2026/08/0451",
    "docId": "KOP-2026-08-0451",
    "name": "BAJULAL  NIAL",
    "mobile": "9692049162",
    "dob": "1996-06-24",
    "district": "Nuapada",
    "regNoSuffix": "0451"
  },
  {
    "registrationNumber": "KOP/2026/08/0452",
    "docId": "KOP-2026-08-0452",
    "name": "SEIKH BILAL",
    "mobile": "8144823801",
    "dob": "1998-06-21",
    "district": "Nuapada",
    "regNoSuffix": "0452"
  },
  {
    "registrationNumber": "KOP/2026/08/0453",
    "docId": "KOP-2026-08-0453",
    "name": "SUNIL KUMAR  HOTA",
    "mobile": "8917434725",
    "dob": "2000-06-09",
    "district": "Nuapada",
    "regNoSuffix": "0453"
  },
  {
    "registrationNumber": "KOP/2026/08/0454",
    "docId": "KOP-2026-08-0454",
    "name": "SAURI SAHU",
    "mobile": "6370513161",
    "dob": "1995-06-01",
    "district": "Nuapada",
    "regNoSuffix": "0454"
  },
  {
    "registrationNumber": "KOP/2026/08/0455",
    "docId": "KOP-2026-08-0455",
    "name": "NIRAJ KUMAR MEHER",
    "mobile": "8658088002",
    "dob": "2006-06-11",
    "district": "Nuapada",
    "regNoSuffix": "0455"
  },
  {
    "registrationNumber": "KOP/2026/08/0456",
    "docId": "KOP-2026-08-0456",
    "name": "ASHISH KUMAR DUBE",
    "mobile": "7749932111",
    "dob": "1997-06-10",
    "district": "Nuapada",
    "regNoSuffix": "0456"
  },
  {
    "registrationNumber": "KOP/2026/08/0457",
    "docId": "KOP-2026-08-0457",
    "name": "ABHISHEK  PANDA",
    "mobile": "8658230760",
    "dob": "1999-07-05",
    "district": "Nuapada",
    "regNoSuffix": "0457"
  },
  {
    "registrationNumber": "KOP/2026/08/0458",
    "docId": "KOP-2026-08-0458",
    "name": "SITAL  BAG",
    "mobile": "8926270167",
    "dob": "2007-02-20",
    "district": "Nuapada",
    "regNoSuffix": "0458"
  },
  {
    "registrationNumber": "KOP/2026/08/0459",
    "docId": "KOP-2026-08-0459",
    "name": "PRAKASH  SAGRIA",
    "mobile": "9668435062",
    "dob": "1999-07-04",
    "district": "Balangir",
    "regNoSuffix": "0459"
  },
  {
    "registrationNumber": "KOP/2026/08/0460",
    "docId": "KOP-2026-08-0460",
    "name": "JYOTSHNA BARIK",
    "mobile": "7077938595",
    "dob": "2000-03-04",
    "district": "Balangir",
    "regNoSuffix": "0460"
  },
  {
    "registrationNumber": "KOP/2026/08/0461",
    "docId": "KOP-2026-08-0461",
    "name": "SAHIL  NAG",
    "mobile": "9937094978",
    "dob": "2005-01-10",
    "district": "Nuapada",
    "regNoSuffix": "0461"
  },
  {
    "registrationNumber": "KOP/2026/08/0462",
    "docId": "KOP-2026-08-0462",
    "name": "RANJIT  TANDI",
    "mobile": "9078776789",
    "dob": "2000-05-03",
    "district": "Balangir",
    "regNoSuffix": "0462"
  },
  {
    "registrationNumber": "KOP/2026/08/0463",
    "docId": "KOP-2026-08-0463",
    "name": "RUBINA  PRUSHTI",
    "mobile": "9668175696",
    "dob": "1991-05-26",
    "district": "Nuapada",
    "regNoSuffix": "0463"
  },
  {
    "registrationNumber": "KOP/2026/08/0464",
    "docId": "KOP-2026-08-0464",
    "name": "AHINSHA  PANDA",
    "mobile": "8327705711",
    "dob": "2001-05-22",
    "district": "Nuapada",
    "regNoSuffix": "0464"
  },
  {
    "registrationNumber": "KOP/2026/08/0465",
    "docId": "KOP-2026-08-0465",
    "name": "JYOTSNAMAYI HANS",
    "mobile": "9348967886",
    "dob": "2000-04-26",
    "district": "Nuapada",
    "regNoSuffix": "0465"
  },
  {
    "registrationNumber": "KOP/2026/08/0466",
    "docId": "KOP-2026-08-0466",
    "name": "JAYANTI  SUNANI",
    "mobile": "9078979228",
    "dob": "1982-06-04",
    "district": "Kalahandi",
    "regNoSuffix": "0466"
  },
  {
    "registrationNumber": "KOP/2026/08/0467",
    "docId": "KOP-2026-08-0467",
    "name": "SAGARIKA DASH",
    "mobile": "6370787456",
    "dob": "1997-04-03",
    "district": "Balangir",
    "regNoSuffix": "0467"
  },
  {
    "registrationNumber": "KOP/2026/08/0468",
    "docId": "KOP-2026-08-0468",
    "name": "PRIYANKA PRIYADARSHINI BRAHMA",
    "mobile": "8144296953",
    "dob": "1993-03-14",
    "district": "Cuttack",
    "regNoSuffix": "0468"
  },
  {
    "registrationNumber": "KOP/2026/08/0469",
    "docId": "KOP-2026-08-0469",
    "name": "RAHASH BIHARI MAHANAND",
    "mobile": "8457916886",
    "dob": "1986-08-17",
    "district": "Nuapada",
    "regNoSuffix": "0469"
  },
  {
    "registrationNumber": "KOP/2026/08/0470",
    "docId": "KOP-2026-08-0470",
    "name": "PRATEEK KUMAR  SAHOO",
    "mobile": "7008038677",
    "dob": "1999-02-27",
    "district": "Boudh",
    "regNoSuffix": "0470"
  },
  {
    "registrationNumber": "KOP/2026/08/0471",
    "docId": "KOP-2026-08-0471",
    "name": "MOTILAL  MIRDHA",
    "mobile": "9348987855",
    "dob": "1993-05-11",
    "district": "Balangir",
    "regNoSuffix": "0471"
  },
  {
    "registrationNumber": "KOP/2026/08/0472",
    "docId": "KOP-2026-08-0472",
    "name": "PRIYANKA RASMI RANJEETA KABI",
    "mobile": "7978309893",
    "dob": "1997-05-25",
    "district": "Kalahandi",
    "regNoSuffix": "0472"
  },
  {
    "registrationNumber": "KOP/2026/08/0473",
    "docId": "KOP-2026-08-0473",
    "name": "BIKRAM  CHHATRIA",
    "mobile": "7847836460",
    "dob": "2003-10-03",
    "district": "Balangir",
    "regNoSuffix": "0473"
  },
  {
    "registrationNumber": "KOP/2026/08/0474",
    "docId": "KOP-2026-08-0474",
    "name": "TRINATH  MEHER",
    "mobile": "9668634077",
    "dob": "0094-04-26",
    "district": "Nuapada",
    "regNoSuffix": "0474"
  },
  {
    "registrationNumber": "KOP/2026/08/0475",
    "docId": "KOP-2026-08-0475",
    "name": "ROHINI  MEHER",
    "mobile": "8455958414",
    "dob": "1998-03-17",
    "district": "Nuapada",
    "regNoSuffix": "0475"
  },
  {
    "registrationNumber": "KOP/2026/08/0476",
    "docId": "KOP-2026-08-0476",
    "name": "BHABANI  BHATI",
    "mobile": "9861811775",
    "dob": "2000-03-02",
    "district": "Nuapada",
    "regNoSuffix": "0476"
  },
  {
    "registrationNumber": "KOP/2026/08/0477",
    "docId": "KOP-2026-08-0477",
    "name": "BIMAL  SAHU",
    "mobile": "8658399493",
    "dob": "1999-05-01",
    "district": "Balangir",
    "regNoSuffix": "0477"
  },
  {
    "registrationNumber": "KOP/2026/08/0478",
    "docId": "KOP-2026-08-0478",
    "name": "JYOTI  PODH",
    "mobile": "8457817372",
    "dob": "2000-01-26",
    "district": "Balangir",
    "regNoSuffix": "0478"
  },
  {
    "registrationNumber": "KOP/2026/08/0479",
    "docId": "KOP-2026-08-0479",
    "name": "SHANTI  CHHATRIA",
    "mobile": "9348765018",
    "dob": "2006-02-25",
    "district": "Kalahandi",
    "regNoSuffix": "0479"
  },
  {
    "registrationNumber": "KOP/2026/08/0480",
    "docId": "KOP-2026-08-0480",
    "name": "DUKHURAM SAHANI",
    "mobile": "9668174820",
    "dob": "1990-03-07",
    "district": "Balangir",
    "regNoSuffix": "0480"
  },
  {
    "registrationNumber": "KOP/2026/08/0481",
    "docId": "KOP-2026-08-0481",
    "name": "HEMRAJ PUTEL",
    "mobile": "8260853987",
    "dob": "2004-08-15",
    "district": "Balangir",
    "regNoSuffix": "0481"
  },
  {
    "registrationNumber": "KOP/2026/08/0482",
    "docId": "KOP-2026-08-0482",
    "name": "RANJAN  MIRDHA",
    "mobile": "7077020031",
    "dob": "1991-04-14",
    "district": "Balangir",
    "regNoSuffix": "0482"
  },
  {
    "registrationNumber": "KOP/2026/08/0483",
    "docId": "KOP-2026-08-0483",
    "name": "SIPAN  ROUT",
    "mobile": "9861734134",
    "dob": "2003-06-30",
    "district": "Balangir",
    "regNoSuffix": "0483"
  },
  {
    "registrationNumber": "KOP/2026/08/0484",
    "docId": "KOP-2026-08-0484",
    "name": "HRUSHIKESH  PADHAN",
    "mobile": "6371331249",
    "dob": "2006-01-02",
    "district": "Balangir",
    "regNoSuffix": "0484"
  },
  {
    "registrationNumber": "KOP/2026/08/0485",
    "docId": "KOP-2026-08-0485",
    "name": "BUNDARI  SAHU",
    "mobile": "8637276232",
    "dob": "1992-03-04",
    "district": "Balangir",
    "regNoSuffix": "0485"
  },
  {
    "registrationNumber": "KOP/2026/08/0486",
    "docId": "KOP-2026-08-0486",
    "name": "PRIYADARSINI SAHU",
    "mobile": "9337853224",
    "dob": "1995-05-10",
    "district": "Balangir",
    "regNoSuffix": "0486"
  },
  {
    "registrationNumber": "KOP/2026/08/0487",
    "docId": "KOP-2026-08-0487",
    "name": "RAJIB KUMAR BISWAL",
    "mobile": "9668825901",
    "dob": "1989-07-03",
    "district": "Balangir",
    "regNoSuffix": "0487"
  },
  {
    "registrationNumber": "KOP/2026/08/0488",
    "docId": "KOP-2026-08-0488",
    "name": "ARABINDA  PADHAN",
    "mobile": "8249806694",
    "dob": "2007-09-30",
    "district": "Balangir",
    "regNoSuffix": "0488"
  },
  {
    "registrationNumber": "KOP/2026/08/0489",
    "docId": "KOP-2026-08-0489",
    "name": "NAYANA  DUBE",
    "mobile": "9668633107",
    "dob": "1987-07-14",
    "district": "Nuapada",
    "regNoSuffix": "0489"
  },
  {
    "registrationNumber": "KOP/2026/08/0490",
    "docId": "KOP-2026-08-0490",
    "name": "PABIN KUMAR  MEHER",
    "mobile": "7077806036",
    "dob": "1996-09-13",
    "district": "Nuapada",
    "regNoSuffix": "0490"
  },
  {
    "registrationNumber": "KOP/2026/08/0491",
    "docId": "KOP-2026-08-0491",
    "name": "SANJAYA  SAHU",
    "mobile": "8328980218",
    "dob": "2002-04-16",
    "district": "Sonepur",
    "regNoSuffix": "0491"
  },
  {
    "registrationNumber": "KOP/2026/08/0492",
    "docId": "KOP-2026-08-0492",
    "name": "SWABHIMAN  DALAI",
    "mobile": "7328005325",
    "dob": "2005-12-03",
    "district": "Sonepur",
    "regNoSuffix": "0492"
  },
  {
    "registrationNumber": "KOP/2026/08/0493",
    "docId": "KOP-2026-08-0493",
    "name": "MONALISA  PANDA",
    "mobile": "9348754663",
    "dob": "2006-07-16",
    "district": "Sonepur",
    "regNoSuffix": "0493"
  },
  {
    "registrationNumber": "KOP/2026/08/0494",
    "docId": "KOP-2026-08-0494",
    "name": "MANOJ KUMAR  SAHU",
    "mobile": "7978788142",
    "dob": "1994-06-20",
    "district": "Kalahandi",
    "regNoSuffix": "0494"
  },
  {
    "registrationNumber": "KOP/2026/08/0495",
    "docId": "KOP-2026-08-0495",
    "name": "MAHESH KUMAR SA",
    "mobile": "9556316856",
    "dob": "1994-01-13",
    "district": "Nuapada",
    "regNoSuffix": "0495"
  },
  {
    "registrationNumber": "KOP/2026/08/0496",
    "docId": "KOP-2026-08-0496",
    "name": "MANAS RANJAN  PUROHIT",
    "mobile": "7735087233",
    "dob": "1992-04-24",
    "district": "Nuapada",
    "regNoSuffix": "0496"
  },
  {
    "registrationNumber": "KOP/2026/08/0497",
    "docId": "KOP-2026-08-0497",
    "name": "KAMAKSHYA PRASAD JOSHI",
    "mobile": "8658224508",
    "dob": "1995-11-03",
    "district": "Nuapada",
    "regNoSuffix": "0497"
  },
  {
    "registrationNumber": "KOP/2026/08/0498",
    "docId": "KOP-2026-08-0498",
    "name": "SIBA  HATI",
    "mobile": "9337101506",
    "dob": "1997-06-03",
    "district": "Nuapada",
    "regNoSuffix": "0498"
  },
  {
    "registrationNumber": "KOP/2026/08/0499",
    "docId": "KOP-2026-08-0499",
    "name": "NIHARIKA  GHIWALA",
    "mobile": "9078697589",
    "dob": "2002-03-25",
    "district": "Nuapada",
    "regNoSuffix": "0499"
  },
  {
    "registrationNumber": "KOP/2026/08/0500",
    "docId": "KOP-2026-08-0500",
    "name": "SOURAJ KUMAR DASH",
    "mobile": "7750900925",
    "dob": "2000-03-22",
    "district": "Balangir",
    "regNoSuffix": "0500"
  },
  {
    "registrationNumber": "KOP/2026/08/0501",
    "docId": "KOP-2026-08-0501",
    "name": "SASHIKANTA  PUTEL",
    "mobile": "9556093809",
    "dob": "1998-10-13",
    "district": "Balangir",
    "regNoSuffix": "0501"
  },
  {
    "registrationNumber": "KOP/2026/08/0502",
    "docId": "KOP-2026-08-0502",
    "name": "TULSI RAJ SAGRIA",
    "mobile": "9777842357",
    "dob": "2002-12-30",
    "district": "Balangir",
    "regNoSuffix": "0502"
  },
  {
    "registrationNumber": "KOP/2026/08/0503",
    "docId": "KOP-2026-08-0503",
    "name": "SAMIRA HATI",
    "mobile": "7326042229",
    "dob": "2003-03-29",
    "district": "Bargarh",
    "regNoSuffix": "0503"
  },
  {
    "registrationNumber": "KOP/2026/08/0504",
    "docId": "KOP-2026-08-0504",
    "name": "RENUKA BALLAV KARUAN",
    "mobile": "9556256762",
    "dob": "1992-07-20",
    "district": "Balangir",
    "regNoSuffix": "0504"
  },
  {
    "registrationNumber": "KOP/2026/08/0505",
    "docId": "KOP-2026-08-0505",
    "name": "FAKIRA PATEL",
    "mobile": "9777820845",
    "dob": "1996-05-04",
    "district": "Nuapada",
    "regNoSuffix": "0505"
  },
  {
    "registrationNumber": "KOP/2026/08/0506",
    "docId": "KOP-2026-08-0506",
    "name": "MITA  HATI",
    "mobile": "7750886869",
    "dob": "2000-01-27",
    "district": "Balangir",
    "regNoSuffix": "0506"
  },
  {
    "registrationNumber": "KOP/2026/08/0507",
    "docId": "KOP-2026-08-0507",
    "name": "JITAMITRA  DHARUA",
    "mobile": "9556463931",
    "dob": "1993-12-16",
    "district": "Nuapada",
    "regNoSuffix": "0507"
  },
  {
    "registrationNumber": "KOP/2026/08/0508",
    "docId": "KOP-2026-08-0508",
    "name": "JUBARAJ  SAHU",
    "mobile": "7328845879",
    "dob": "2005-11-05",
    "district": "Kalahandi",
    "regNoSuffix": "0508"
  },
  {
    "registrationNumber": "KOP/2026/08/0509",
    "docId": "KOP-2026-08-0509",
    "name": "JITESH  BANCHHOR",
    "mobile": "7978171798",
    "dob": "1992-08-04",
    "district": "Kalahandi",
    "regNoSuffix": "0509"
  },
  {
    "registrationNumber": "KOP/2026/08/0510",
    "docId": "KOP-2026-08-0510",
    "name": "PRAKASH CHANDRA NAYAK",
    "mobile": "8799362992",
    "dob": "1996-06-07",
    "district": "Ganjam",
    "regNoSuffix": "0510"
  },
  {
    "registrationNumber": "KOP/2026/08/0511",
    "docId": "KOP-2026-08-0511",
    "name": "GANESH  SAHU",
    "mobile": "7008231853",
    "dob": "1996-03-16",
    "district": "Ganjam",
    "regNoSuffix": "0511"
  },
  {
    "registrationNumber": "KOP/2026/08/0512",
    "docId": "KOP-2026-08-0512",
    "name": "SANTANU ALTIA",
    "mobile": "9178729506",
    "dob": "2006-04-06",
    "district": "Nayagarh",
    "regNoSuffix": "0512"
  },
  {
    "registrationNumber": "KOP/2026/08/0513",
    "docId": "KOP-2026-08-0513",
    "name": "SATYAM  TANDI",
    "mobile": "8018188650",
    "dob": "1999-10-18",
    "district": "Nuapada",
    "regNoSuffix": "0513"
  },
  {
    "registrationNumber": "KOP/2026/08/0514",
    "docId": "KOP-2026-08-0514",
    "name": "JITENDRA  BEHERA",
    "mobile": "9668644154",
    "dob": "1991-05-29",
    "district": "Balangir",
    "regNoSuffix": "0514"
  },
  {
    "registrationNumber": "KOP/2026/08/0515",
    "docId": "KOP-2026-08-0515",
    "name": "BEENA  PUTEL",
    "mobile": "9348341467",
    "dob": "2000-10-08",
    "district": "Balangir",
    "regNoSuffix": "0515"
  },
  {
    "registrationNumber": "KOP/2026/08/0516",
    "docId": "KOP-2026-08-0516",
    "name": "GOBINDA  BEHERA",
    "mobile": "6371095696",
    "dob": "1997-06-10",
    "district": "Balangir",
    "regNoSuffix": "0516"
  },
  {
    "registrationNumber": "KOP/2026/08/0517",
    "docId": "KOP-2026-08-0517",
    "name": "RAJESH  SAHU",
    "mobile": "9348648893",
    "dob": "1999-09-25",
    "district": "Balangir",
    "regNoSuffix": "0517"
  },
  {
    "registrationNumber": "KOP/2026/08/0518",
    "docId": "KOP-2026-08-0518",
    "name": "KIRTAN  JANI",
    "mobile": "8658925952",
    "dob": "1996-06-25",
    "district": "Balangir",
    "regNoSuffix": "0518"
  },
  {
    "registrationNumber": "KOP/2026/08/0519",
    "docId": "KOP-2026-08-0519",
    "name": "PRAHALLAD  BHIBHAR",
    "mobile": "7855046223",
    "dob": "2004-08-28",
    "district": "Nuapada",
    "regNoSuffix": "0519"
  },
  {
    "registrationNumber": "KOP/2026/08/0520",
    "docId": "KOP-2026-08-0520",
    "name": "APRAYA KUMAR DURIA",
    "mobile": "8928521959",
    "dob": "1993-12-24",
    "district": "Nuapada",
    "regNoSuffix": "0520"
  },
  {
    "registrationNumber": "KOP/2026/08/0521",
    "docId": "KOP-2026-08-0521",
    "name": "PARESH CHANDRA  SABAR",
    "mobile": "9348535611",
    "dob": "1994-04-22",
    "district": "Nuapada",
    "regNoSuffix": "0521"
  },
  {
    "registrationNumber": "KOP/2026/08/0522",
    "docId": "KOP-2026-08-0522",
    "name": "BRAJESH  BHOI",
    "mobile": "9668224285",
    "dob": "2001-04-14",
    "district": "Balangir",
    "regNoSuffix": "0522"
  },
  {
    "registrationNumber": "KOP/2026/08/0523",
    "docId": "KOP-2026-08-0523",
    "name": "KRISHNA CHANDRA MAHANANDA",
    "mobile": "8658226720",
    "dob": "1988-06-16",
    "district": "Balangir",
    "regNoSuffix": "0523"
  },
  {
    "registrationNumber": "KOP/2026/08/0524",
    "docId": "KOP-2026-08-0524",
    "name": "JITENDRA KUMAR PATRO",
    "mobile": "9437864171",
    "dob": "1989-05-15",
    "district": "Ganjam",
    "regNoSuffix": "0524"
  },
  {
    "registrationNumber": "KOP/2026/08/0525",
    "docId": "KOP-2026-08-0525",
    "name": "SHIKHA  BARIK",
    "mobile": "7848023465",
    "dob": "2003-07-28",
    "district": "Bargarh",
    "regNoSuffix": "0525"
  },
  {
    "registrationNumber": "KOP/2026/08/0526",
    "docId": "KOP-2026-08-0526",
    "name": "KOUTULYA  CHHURA",
    "mobile": "9348506899",
    "dob": "2000-08-02",
    "district": "Balangir",
    "regNoSuffix": "0526"
  },
  {
    "registrationNumber": "KOP/2026/08/0527",
    "docId": "KOP-2026-08-0527",
    "name": "SEEMA  MEHER",
    "mobile": "9658229193",
    "dob": "1995-03-17",
    "district": "Balangir",
    "regNoSuffix": "0527"
  },
  {
    "registrationNumber": "KOP/2026/08/0528",
    "docId": "KOP-2026-08-0528",
    "name": "LIJINAPRIYADARSHANI DAS",
    "mobile": "9827802083",
    "dob": "1988-06-25",
    "district": "Mayurbhanj",
    "regNoSuffix": "0528"
  },
  {
    "registrationNumber": "KOP/2026/08/0529",
    "docId": "KOP-2026-08-0529",
    "name": "UDDHAB KUMAR NAIK",
    "mobile": "7008729226",
    "dob": "1999-02-04",
    "district": "Kalahandi",
    "regNoSuffix": "0529"
  },
  {
    "registrationNumber": "KOP/2026/08/0530",
    "docId": "KOP-2026-08-0530",
    "name": "BHAKTABANDHU  BAGARTI",
    "mobile": "7894385380",
    "dob": "1998-05-15",
    "district": "Balangir",
    "regNoSuffix": "0530"
  },
  {
    "registrationNumber": "KOP/2026/08/0531",
    "docId": "KOP-2026-08-0531",
    "name": "REETA NAG",
    "mobile": "9556680449",
    "dob": "1989-03-12",
    "district": "Balangir",
    "regNoSuffix": "0531"
  },
  {
    "registrationNumber": "KOP/2026/08/0532",
    "docId": "KOP-2026-08-0532",
    "name": "ALOK  KARANA",
    "mobile": "9778138763",
    "dob": "1995-04-08",
    "district": "Balangir",
    "regNoSuffix": "0532"
  },
  {
    "registrationNumber": "KOP/2026/08/0533",
    "docId": "KOP-2026-08-0533",
    "name": "BARSARANI  SARANGI",
    "mobile": "9556496458",
    "dob": "2001-08-24",
    "district": "Balangir",
    "regNoSuffix": "0533"
  },
  {
    "registrationNumber": "KOP/2026/08/0534",
    "docId": "KOP-2026-08-0534",
    "name": "NANDINEE  DANDASENA",
    "mobile": "9556281949",
    "dob": "2001-02-15",
    "district": "Nuapada",
    "regNoSuffix": "0534"
  },
  {
    "registrationNumber": "KOP/2026/08/0535",
    "docId": "KOP-2026-08-0535",
    "name": "SAMEER ROUT",
    "mobile": "9937182560",
    "dob": "2001-08-07",
    "district": "Balangir",
    "regNoSuffix": "0535"
  },
  {
    "registrationNumber": "KOP/2026/08/0536",
    "docId": "KOP-2026-08-0536",
    "name": "ARYAMAN  PANDA",
    "mobile": "8658875487",
    "dob": "2002-09-15",
    "district": "Balangir",
    "regNoSuffix": "0536"
  },
  {
    "registrationNumber": "KOP/2026/08/0537",
    "docId": "KOP-2026-08-0537",
    "name": "ALOK KUMAR SARANGI",
    "mobile": "9040722729",
    "dob": "2006-01-07",
    "district": "Balangir",
    "regNoSuffix": "0537"
  },
  {
    "registrationNumber": "KOP/2026/08/0538",
    "docId": "KOP-2026-08-0538",
    "name": "BHADEV BARIK",
    "mobile": "9556281622",
    "dob": "2007-10-16",
    "district": "Balangir",
    "regNoSuffix": "0538"
  },
  {
    "registrationNumber": "KOP/2026/08/0539",
    "docId": "KOP-2026-08-0539",
    "name": "SUSAMA TANDI",
    "mobile": "9777847945",
    "dob": "2005-11-09",
    "district": "Balangir",
    "regNoSuffix": "0539"
  },
  {
    "registrationNumber": "KOP/2026/08/0540",
    "docId": "KOP-2026-08-0540",
    "name": "SUDAM BARIK",
    "mobile": "9078039797",
    "dob": "1998-05-22",
    "district": "Balangir",
    "regNoSuffix": "0540"
  },
  {
    "registrationNumber": "KOP/2026/08/0541",
    "docId": "KOP-2026-08-0541",
    "name": "PUJA PATEL",
    "mobile": "6372690664",
    "dob": "2006-01-21",
    "district": "Balangir",
    "regNoSuffix": "0541"
  },
  {
    "registrationNumber": "KOP/2026/08/0542",
    "docId": "KOP-2026-08-0542",
    "name": "AMBUJ KARANA",
    "mobile": "8895968130",
    "dob": "1992-07-02",
    "district": "Balangir",
    "regNoSuffix": "0542"
  },
  {
    "registrationNumber": "KOP/2026/08/0543",
    "docId": "KOP-2026-08-0543",
    "name": "BAIJAAYANTI PUTEL",
    "mobile": "7978392667",
    "dob": "1994-07-11",
    "district": "Balangir",
    "regNoSuffix": "0543"
  },
  {
    "registrationNumber": "KOP/2026/08/0544",
    "docId": "KOP-2026-08-0544",
    "name": "DILLIP KUMAR SAHU",
    "mobile": "9937577538",
    "dob": "1992-07-10",
    "district": "Balangir",
    "regNoSuffix": "0544"
  },
  {
    "registrationNumber": "KOP/2026/08/0545",
    "docId": "KOP-2026-08-0545",
    "name": "NILADRI BIHARI PANDA",
    "mobile": "9937388951",
    "dob": "1996-03-11",
    "district": "Nuapada",
    "regNoSuffix": "0545"
  },
  {
    "registrationNumber": "KOP/2026/08/0546",
    "docId": "KOP-2026-08-0546",
    "name": "BIDYUTPRAVA  JOSHI",
    "mobile": "8118087005",
    "dob": "1994-06-02",
    "district": "Balangir",
    "regNoSuffix": "0546"
  },
  {
    "registrationNumber": "KOP/2026/08/0547",
    "docId": "KOP-2026-08-0547",
    "name": "BADAL  PANIGRAHI",
    "mobile": "8908159249",
    "dob": "1991-02-06",
    "district": "Balangir",
    "regNoSuffix": "0547"
  },
  {
    "registrationNumber": "KOP/2026/08/0548",
    "docId": "KOP-2026-08-0548",
    "name": "SUDHANSU SEKHAR  PANDA",
    "mobile": "9556278880",
    "dob": "1995-06-08",
    "district": "Kalahandi",
    "regNoSuffix": "0548"
  },
  {
    "registrationNumber": "KOP/2026/08/0549",
    "docId": "KOP-2026-08-0549",
    "name": "JYOTISMITA  JENA",
    "mobile": "7326871102",
    "dob": "1998-07-05",
    "district": "Nayagarh",
    "regNoSuffix": "0549"
  },
  {
    "registrationNumber": "KOP/2026/08/0550",
    "docId": "KOP-2026-08-0550",
    "name": "HEMANTA KUMAR JENA",
    "mobile": "9337541731",
    "dob": "2001-03-16",
    "district": "Nayagarh",
    "regNoSuffix": "0550"
  },
  {
    "registrationNumber": "KOP/2026/08/0551",
    "docId": "KOP-2026-08-0551",
    "name": "RILI KUMARI SAHU",
    "mobile": "7377860883",
    "dob": "1996-04-10",
    "district": "Ganjam",
    "regNoSuffix": "0551"
  },
  {
    "registrationNumber": "KOP/2026/08/0552",
    "docId": "KOP-2026-08-0552",
    "name": "MANASA RANJAN  SADANGI",
    "mobile": "8249672700",
    "dob": "1987-05-31",
    "district": "Rayagada",
    "regNoSuffix": "0552"
  },
  {
    "registrationNumber": "KOP/2026/08/0553",
    "docId": "KOP-2026-08-0553",
    "name": "JITENDRA  MOHANKUDO",
    "mobile": "8456955110",
    "dob": "1993-02-19",
    "district": "Rayagada",
    "regNoSuffix": "0553"
  },
  {
    "registrationNumber": "KOP/2026/08/0554",
    "docId": "KOP-2026-08-0554",
    "name": "SANAILA  SARITA",
    "mobile": "7077994333",
    "dob": "2004-11-10",
    "district": "Rayagada",
    "regNoSuffix": "0554"
  },
  {
    "registrationNumber": "KOP/2026/08/0555",
    "docId": "KOP-2026-08-0555",
    "name": "IPSITA BARIK",
    "mobile": "9827615607",
    "dob": "2006-04-07",
    "district": "Nuapada",
    "regNoSuffix": "0555"
  },
  {
    "registrationNumber": "KOP/2026/08/0556",
    "docId": "KOP-2026-08-0556",
    "name": "PRADIP KUMAR SAHU",
    "mobile": "8249385997",
    "dob": "2004-02-18",
    "district": "Dhenkanal",
    "regNoSuffix": "0556"
  },
  {
    "registrationNumber": "KOP/2026/08/0557",
    "docId": "KOP-2026-08-0557",
    "name": "SABITRI BEHERA",
    "mobile": "7205324127",
    "dob": "2005-02-16",
    "district": "Dhenkanal",
    "regNoSuffix": "0557"
  },
  {
    "registrationNumber": "KOP/2026/08/0558",
    "docId": "KOP-2026-08-0558",
    "name": "GULSAN KUMAR DAS",
    "mobile": "7769031519",
    "dob": "2004-05-20",
    "district": "Dhenkanal",
    "regNoSuffix": "0558"
  },
  {
    "registrationNumber": "KOP/2026/08/0559",
    "docId": "KOP-2026-08-0559",
    "name": "ASHIS BARIKI",
    "mobile": "7853046004",
    "dob": "2004-02-05",
    "district": "Dhenkanal",
    "regNoSuffix": "0559"
  },
  {
    "registrationNumber": "KOP/2026/08/0560",
    "docId": "KOP-2026-08-0560",
    "name": "DEEPAK RANJAN  HANS",
    "mobile": "9668743617",
    "dob": "2004-04-04",
    "district": "Balangir",
    "regNoSuffix": "0560"
  },
  {
    "registrationNumber": "KOP/2026/08/0561",
    "docId": "KOP-2026-08-0561",
    "name": "RAJASHREE MOHANTY",
    "mobile": "7735063702",
    "dob": "2005-02-12",
    "district": "Dhenkanal",
    "regNoSuffix": "0561"
  },
  {
    "registrationNumber": "KOP/2026/08/0562",
    "docId": "KOP-2026-08-0562",
    "name": "SASMITA MALLICK",
    "mobile": "7328872405",
    "dob": "2000-02-06",
    "district": "Dhenkanal",
    "regNoSuffix": "0562"
  },
  {
    "registrationNumber": "KOP/2026/08/0563",
    "docId": "KOP-2026-08-0563",
    "name": "GHANASHYAM KHAMARI",
    "mobile": "9978655326",
    "dob": "2003-03-02",
    "district": "Sonepur",
    "regNoSuffix": "0563"
  },
  {
    "registrationNumber": "KOP/2026/08/0564",
    "docId": "KOP-2026-08-0564",
    "name": "BINOD  SAHU",
    "mobile": "6371741377",
    "dob": "1989-06-05",
    "district": "Balangir",
    "regNoSuffix": "0564"
  },
  {
    "registrationNumber": "KOP/2026/08/0565",
    "docId": "KOP-2026-08-0565",
    "name": "LAXMIDHAR  BAG",
    "mobile": "7894814675",
    "dob": "1998-07-09",
    "district": "Balangir",
    "regNoSuffix": "0565"
  },
  {
    "registrationNumber": "KOP/2026/08/0566",
    "docId": "KOP-2026-08-0566",
    "name": "PINKU CHARAN  BHATI",
    "mobile": "8658775376",
    "dob": "1994-06-27",
    "district": "Balangir",
    "regNoSuffix": "0566"
  },
  {
    "registrationNumber": "KOP/2026/08/0567",
    "docId": "KOP-2026-08-0567",
    "name": "RAGHUNANDAN PADHAN",
    "mobile": "7681844599",
    "dob": "2005-05-02",
    "district": "Dhenkanal",
    "regNoSuffix": "0567"
  },
  {
    "registrationNumber": "KOP/2026/08/0568",
    "docId": "KOP-2026-08-0568",
    "name": "BISWESWAR BISHI",
    "mobile": "7854983950",
    "dob": "2003-02-02",
    "district": "Dhenkanal",
    "regNoSuffix": "0568"
  },
  {
    "registrationNumber": "KOP/2026/08/0569",
    "docId": "KOP-2026-08-0569",
    "name": "YASOBANT  MEHER",
    "mobile": "7894266330",
    "dob": "1993-04-10",
    "district": "Nuapada",
    "regNoSuffix": "0569"
  },
  {
    "registrationNumber": "KOP/2026/08/0570",
    "docId": "KOP-2026-08-0570",
    "name": "BIKRAM BHOI",
    "mobile": "6372772045",
    "dob": "2005-02-02",
    "district": "Sonepur",
    "regNoSuffix": "0570"
  },
  {
    "registrationNumber": "KOP/2026/08/0571",
    "docId": "KOP-2026-08-0571",
    "name": "PRAKASH PANDA",
    "mobile": "8658114017",
    "dob": "2003-03-02",
    "district": "Sonepur",
    "regNoSuffix": "0571"
  },
  {
    "registrationNumber": "KOP/2026/08/0572",
    "docId": "KOP-2026-08-0572",
    "name": "KHIRA  BHOI",
    "mobile": "9668006291",
    "dob": "1990-06-07",
    "district": "Nuapada",
    "regNoSuffix": "0572"
  },
  {
    "registrationNumber": "KOP/2026/08/0573",
    "docId": "KOP-2026-08-0573",
    "name": "MANASH KUMAR DANGA",
    "mobile": "9178010772",
    "dob": "2003-02-02",
    "district": "Sonepur",
    "regNoSuffix": "0573"
  },
  {
    "registrationNumber": "KOP/2026/08/0574",
    "docId": "KOP-2026-08-0574",
    "name": "PRAKASHA SAHU",
    "mobile": "9556852121",
    "dob": "2005-03-02",
    "district": "Sonepur",
    "regNoSuffix": "0574"
  },
  {
    "registrationNumber": "KOP/2026/08/0575",
    "docId": "KOP-2026-08-0575",
    "name": "KUBERA  SAHU",
    "mobile": "9777960680",
    "dob": "1987-03-10",
    "district": "Kalahandi",
    "regNoSuffix": "0575"
  },
  {
    "registrationNumber": "KOP/2026/08/0576",
    "docId": "KOP-2026-08-0576",
    "name": "PANKAJ  MAJHI",
    "mobile": "9078461778",
    "dob": "2001-10-18",
    "district": "Nuapada",
    "regNoSuffix": "0576"
  },
  {
    "registrationNumber": "KOP/2026/08/0577",
    "docId": "KOP-2026-08-0577",
    "name": "PRASUN KUMAR  PANDA",
    "mobile": "7327071164",
    "dob": "2006-07-16",
    "district": "Nuapada",
    "regNoSuffix": "0577"
  },
  {
    "registrationNumber": "KOP/2026/08/0578",
    "docId": "KOP-2026-08-0578",
    "name": "SNEHAMAYEE  NAYAK",
    "mobile": "8456878586",
    "dob": "2003-07-09",
    "district": "Sonepur",
    "regNoSuffix": "0578"
  },
  {
    "registrationNumber": "KOP/2026/08/0579",
    "docId": "KOP-2026-08-0579",
    "name": "SHIMA  NAYAK",
    "mobile": "9337639704",
    "dob": "1998-05-01",
    "district": "Sonepur",
    "regNoSuffix": "0579"
  },
  {
    "registrationNumber": "KOP/2026/08/0580",
    "docId": "KOP-2026-08-0580",
    "name": "JAYADEV  THAPA",
    "mobile": "8457899423",
    "dob": "1997-07-05",
    "district": "Balangir",
    "regNoSuffix": "0580"
  },
  {
    "registrationNumber": "KOP/2026/08/0581",
    "docId": "KOP-2026-08-0581",
    "name": "PADMINI  BHOI",
    "mobile": "7894733361",
    "dob": "2004-01-13",
    "district": "Balangir",
    "regNoSuffix": "0581"
  },
  {
    "registrationNumber": "KOP/2026/08/0582",
    "docId": "KOP-2026-08-0582",
    "name": "MANAS KUMAR NANDA",
    "mobile": "9861648535",
    "dob": "2003-02-02",
    "district": "Sonepur",
    "regNoSuffix": "0582"
  },
  {
    "registrationNumber": "KOP/2026/08/0583",
    "docId": "KOP-2026-08-0583",
    "name": "ANITA RAY",
    "mobile": "7682936555",
    "dob": "2003-02-02",
    "district": "Sonepur",
    "regNoSuffix": "0583"
  },
  {
    "registrationNumber": "KOP/2026/08/0584",
    "docId": "KOP-2026-08-0584",
    "name": "PRATYUSH RANJAN BHOI",
    "mobile": "8118046847",
    "dob": "2003-02-02",
    "district": "Sonepur",
    "regNoSuffix": "0584"
  },
  {
    "registrationNumber": "KOP/2026/08/0585",
    "docId": "KOP-2026-08-0585",
    "name": "BHARATI  NAIK",
    "mobile": "8260745943",
    "dob": "2003-02-02",
    "district": "Sonepur",
    "regNoSuffix": "0585"
  },
  {
    "registrationNumber": "KOP/2026/08/0586",
    "docId": "KOP-2026-08-0586",
    "name": "SURYAKANTI KAISE",
    "mobile": "7978265313",
    "dob": "2003-02-02",
    "district": "Sonepur",
    "regNoSuffix": "0586"
  },
  {
    "registrationNumber": "KOP/2026/08/0587",
    "docId": "KOP-2026-08-0587",
    "name": "DEBASISH DASH",
    "mobile": "7735342907",
    "dob": "2003-02-20",
    "district": "Sonepur",
    "regNoSuffix": "0587"
  },
  {
    "registrationNumber": "KOP/2026/08/0588",
    "docId": "KOP-2026-08-0588",
    "name": "SIBANI MISHRA",
    "mobile": "9178847973",
    "dob": "2003-02-02",
    "district": "Sonepur",
    "regNoSuffix": "0588"
  },
  {
    "registrationNumber": "KOP/2026/08/0589",
    "docId": "KOP-2026-08-0589",
    "name": "LABA BEHERA",
    "mobile": "8114764764",
    "dob": "2003-02-02",
    "district": "Bargarh",
    "regNoSuffix": "0589"
  },
  {
    "registrationNumber": "KOP/2026/08/0590",
    "docId": "KOP-2026-08-0590",
    "name": "SUPRIYA BEHERA",
    "mobile": "6372213454",
    "dob": "2004-02-02",
    "district": "Sonepur",
    "regNoSuffix": "0590"
  },
  {
    "registrationNumber": "KOP/2026/08/0591",
    "docId": "KOP-2026-08-0591",
    "name": "SUSANTA KUMAR CHAND",
    "mobile": "7978680365",
    "dob": "2005-03-02",
    "district": "Sonepur",
    "regNoSuffix": "0591"
  },
  {
    "registrationNumber": "KOP/2026/08/0592",
    "docId": "KOP-2026-08-0592",
    "name": "NIBASH KUANAR",
    "mobile": "8144076949",
    "dob": "2003-02-02",
    "district": "Sonepur",
    "regNoSuffix": "0592"
  },
  {
    "registrationNumber": "KOP/2026/08/0593",
    "docId": "KOP-2026-08-0593",
    "name": "ANKITA GHIBELA",
    "mobile": "9861007950",
    "dob": "2003-02-02",
    "district": "Sonepur",
    "regNoSuffix": "0593"
  },
  {
    "registrationNumber": "KOP/2026/08/0594",
    "docId": "KOP-2026-08-0594",
    "name": "GOBARDHAN GAHIR",
    "mobile": "8260849551",
    "dob": "2001-02-02",
    "district": "Sonepur",
    "regNoSuffix": "0594"
  },
  {
    "registrationNumber": "KOP/2026/08/0595",
    "docId": "KOP-2026-08-0595",
    "name": "PRAKASH KUMAR  BEHERA",
    "mobile": "7682029065",
    "dob": "1991-03-12",
    "district": "Balangir",
    "regNoSuffix": "0595"
  },
  {
    "registrationNumber": "KOP/2026/08/0596",
    "docId": "KOP-2026-08-0596",
    "name": "NAMITA PADHAN",
    "mobile": "6372030775",
    "dob": "2003-02-02",
    "district": "Sonepur",
    "regNoSuffix": "0596"
  },
  {
    "registrationNumber": "KOP/2026/08/0598",
    "docId": "KOP-2026-08-0598",
    "name": "DAMODAR MEHER",
    "mobile": "8260933215",
    "dob": "2003-02-02",
    "district": "Sonepur",
    "regNoSuffix": "0598"
  },
  {
    "registrationNumber": "KOP/2026/08/0599",
    "docId": "KOP-2026-08-0599",
    "name": "MALAYARANJAN DASH",
    "mobile": "8637265185",
    "dob": "2003-02-02",
    "district": "Bargarh",
    "regNoSuffix": "0599"
  },
  {
    "registrationNumber": "KOP/2026/08/0600",
    "docId": "KOP-2026-08-0600",
    "name": "POULASTI BHOI",
    "mobile": "7606906655",
    "dob": "2003-02-02",
    "district": "Sambalpur",
    "regNoSuffix": "0600"
  },
  {
    "registrationNumber": "KOP/2026/08/0601",
    "docId": "KOP-2026-08-0601",
    "name": "SWAGATIKA MESUA",
    "mobile": "8114338205",
    "dob": "2003-02-02",
    "district": "Sonepur",
    "regNoSuffix": "0601"
  },
  {
    "registrationNumber": "KOP/2026/08/0602",
    "docId": "KOP-2026-08-0602",
    "name": "BALARAM  RANA",
    "mobile": "6372806297",
    "dob": "2004-03-17",
    "district": "Sonepur",
    "regNoSuffix": "0602"
  },
  {
    "registrationNumber": "KOP/2026/08/0603",
    "docId": "KOP-2026-08-0603",
    "name": "SUDHIR KUMAR BHUKTA",
    "mobile": "9668039293",
    "dob": "2003-02-20",
    "district": "Sonepur",
    "regNoSuffix": "0603"
  },
  {
    "registrationNumber": "KOP/2026/08/0604",
    "docId": "KOP-2026-08-0604",
    "name": "SAIPRASAD JHANKAR",
    "mobile": "8144077051",
    "dob": "2003-02-02",
    "district": "Sonepur",
    "regNoSuffix": "0604"
  },
  {
    "registrationNumber": "KOP/2026/08/0605",
    "docId": "KOP-2026-08-0605",
    "name": "SUGYAN NAIK",
    "mobile": "7895688456",
    "dob": "1999-02-02",
    "district": "Sonepur",
    "regNoSuffix": "0605"
  },
  {
    "registrationNumber": "KOP/2026/08/0606",
    "docId": "KOP-2026-08-0606",
    "name": "KIRAN  SUNANI",
    "mobile": "9337153254",
    "dob": "2002-12-20",
    "district": "Kalahandi",
    "regNoSuffix": "0606"
  },
  {
    "registrationNumber": "KOP/2026/08/0607",
    "docId": "KOP-2026-08-0607",
    "name": "SUDAM TRIPATHY",
    "mobile": "7978171554",
    "dob": "2003-02-02",
    "district": "Sonepur",
    "regNoSuffix": "0607"
  },
  {
    "registrationNumber": "KOP/2026/08/0608",
    "docId": "KOP-2026-08-0608",
    "name": "ASHUTOSH PADHAN",
    "mobile": "7735825081",
    "dob": "2003-02-02",
    "district": "Sonepur",
    "regNoSuffix": "0608"
  },
  {
    "registrationNumber": "KOP/2026/08/0609",
    "docId": "KOP-2026-08-0609",
    "name": "ASHARANI MAHAKUR",
    "mobile": "8144685723",
    "dob": "2000-03-02",
    "district": "Sonepur",
    "regNoSuffix": "0609"
  },
  {
    "registrationNumber": "KOP/2026/08/0610",
    "docId": "KOP-2026-08-0610",
    "name": "JYOTI RANJAN MELLI",
    "mobile": "8917560582",
    "dob": "2001-02-01",
    "district": "Sonepur",
    "regNoSuffix": "0610"
  },
  {
    "registrationNumber": "KOP/2026/08/0611",
    "docId": "KOP-2026-08-0611",
    "name": "TAPASWINI  PUTEL",
    "mobile": "7855980816",
    "dob": "2000-04-20",
    "district": "Balangir",
    "regNoSuffix": "0611"
  },
  {
    "registrationNumber": "KOP/2026/08/0612",
    "docId": "KOP-2026-08-0612",
    "name": "MANINEE  BEHERA",
    "mobile": "9348573900",
    "dob": "2005-12-21",
    "district": "Nuapada",
    "regNoSuffix": "0612"
  },
  {
    "registrationNumber": "KOP/2026/08/0613",
    "docId": "KOP-2026-08-0613",
    "name": "SATYANARAYAN  HANS",
    "mobile": "9861853479",
    "dob": "2000-03-15",
    "district": "Balangir",
    "regNoSuffix": "0613"
  },
  {
    "registrationNumber": "KOP/2026/08/0614",
    "docId": "KOP-2026-08-0614",
    "name": "SANGEETA  PADHAN",
    "mobile": "7978520320",
    "dob": "1997-05-03",
    "district": "Balangir",
    "regNoSuffix": "0614"
  },
  {
    "registrationNumber": "KOP/2026/08/0615",
    "docId": "KOP-2026-08-0615",
    "name": "NALINI  HOTA",
    "mobile": "9937188323",
    "dob": "1986-06-03",
    "district": "Nuapada",
    "regNoSuffix": "0615"
  },
  {
    "registrationNumber": "KOP/2026/08/0616",
    "docId": "KOP-2026-08-0616",
    "name": "NAROTTAM  BEHERA",
    "mobile": "6370584706",
    "dob": "1989-06-14",
    "district": "Balangir",
    "regNoSuffix": "0616"
  },
  {
    "registrationNumber": "KOP/2026/08/0617",
    "docId": "KOP-2026-08-0617",
    "name": "SUSMITA  MAJHI",
    "mobile": "7608014762",
    "dob": "1994-02-02",
    "district": "Nuapada",
    "regNoSuffix": "0617"
  },
  {
    "registrationNumber": "KOP/2026/08/0618",
    "docId": "KOP-2026-08-0618",
    "name": "MADHUSMITA JENA",
    "mobile": "8763854296",
    "dob": "2001-10-08",
    "district": "Dhenkanal",
    "regNoSuffix": "0618"
  },
  {
    "registrationNumber": "KOP/2026/08/0619",
    "docId": "KOP-2026-08-0619",
    "name": "DHARMENDRA NAIK",
    "mobile": "8249825185",
    "dob": "1998-03-22",
    "district": "Kalahandi",
    "regNoSuffix": "0619"
  },
  {
    "registrationNumber": "KOP/2026/08/0620",
    "docId": "KOP-2026-08-0620",
    "name": "SOUDAMINI PADHAN",
    "mobile": "7077172383",
    "dob": "2003-02-02",
    "district": "Sonepur",
    "regNoSuffix": "0620"
  },
  {
    "registrationNumber": "KOP/2026/08/0621",
    "docId": "KOP-2026-08-0621",
    "name": "ANKITA GHIBELA",
    "mobile": "9861007950",
    "dob": "2003-02-02",
    "district": "Sonepur",
    "regNoSuffix": "0621"
  },
  {
    "registrationNumber": "KOP/2026/08/0622",
    "docId": "KOP-2026-08-0622",
    "name": "AMULLYA NAIK",
    "mobile": "8260898292",
    "dob": "2001-02-02",
    "district": "Sonepur",
    "regNoSuffix": "0622"
  },
  {
    "registrationNumber": "KOP/2026/08/0623",
    "docId": "KOP-2026-08-0623",
    "name": "SWARNALATA DAS",
    "mobile": "8917419114",
    "dob": "2002-03-27",
    "district": "Ganjam",
    "regNoSuffix": "0623"
  },
  {
    "registrationNumber": "KOP/2026/08/0624",
    "docId": "KOP-2026-08-0624",
    "name": "BHABESH SAHU",
    "mobile": "9178875440",
    "dob": "1996-10-13",
    "district": "Balangir",
    "regNoSuffix": "0624"
  },
  {
    "registrationNumber": "KOP/2026/08/0625",
    "docId": "KOP-2026-08-0625",
    "name": "ASTIK DANDASENA",
    "mobile": "7894611937",
    "dob": "1998-01-31",
    "district": "Nuapada",
    "regNoSuffix": "0625"
  },
  {
    "registrationNumber": "KOP/2026/08/0626",
    "docId": "KOP-2026-08-0626",
    "name": "AMAN PADHI",
    "mobile": "9337380453",
    "dob": "2001-04-13",
    "district": "Balangir",
    "regNoSuffix": "0626"
  },
  {
    "registrationNumber": "KOP/2026/08/0627",
    "docId": "KOP-2026-08-0627",
    "name": "PADMARAJ DANDSENA",
    "mobile": "6372272801",
    "dob": "1996-10-02",
    "district": "Nuapada",
    "regNoSuffix": "0627"
  },
  {
    "registrationNumber": "KOP/2026/08/0628",
    "docId": "KOP-2026-08-0628",
    "name": "NAGESWAR BEHERA",
    "mobile": "9178051509",
    "dob": "1998-05-13",
    "district": "Balangir",
    "regNoSuffix": "0628"
  },
  {
    "registrationNumber": "KOP/2026/08/0629",
    "docId": "KOP-2026-08-0629",
    "name": "AMIT KUMAR JUED",
    "mobile": "9337543451",
    "dob": "1993-06-06",
    "district": "Balangir",
    "regNoSuffix": "0629"
  },
  {
    "registrationNumber": "KOP/2026/08/0630",
    "docId": "KOP-2026-08-0630",
    "name": "MANASWINI NEGI",
    "mobile": "6371823837",
    "dob": "1991-07-05",
    "district": "Nuapada",
    "regNoSuffix": "0630"
  },
  {
    "registrationNumber": "KOP/2026/08/0631",
    "docId": "KOP-2026-08-0631",
    "name": "RASMIRANJAN PARIDA",
    "mobile": "6370546297",
    "dob": "1993-06-02",
    "district": "Jagatsinghpur",
    "regNoSuffix": "0631"
  },
  {
    "registrationNumber": "KOP/2026/08/0632",
    "docId": "KOP-2026-08-0632",
    "name": "NARAHARI PUTEL",
    "mobile": "8260317357",
    "dob": "2002-06-17",
    "district": "Balangir",
    "regNoSuffix": "0632"
  },
  {
    "registrationNumber": "KOP/2026/08/0633",
    "docId": "KOP-2026-08-0633",
    "name": "PRATYASHA MOHANTY",
    "mobile": "7873994987",
    "dob": "1993-03-04",
    "district": "Jagatsinghpur",
    "regNoSuffix": "0633"
  },
  {
    "registrationNumber": "KOP/2026/08/0634",
    "docId": "KOP-2026-08-0634",
    "name": "BISHAL SAHU",
    "mobile": "6370664133",
    "dob": "2002-04-18",
    "district": "Balangir",
    "regNoSuffix": "0634"
  },
  {
    "registrationNumber": "KOP/2026/08/0635",
    "docId": "KOP-2026-08-0635",
    "name": "RAJLAXMI MUDULI",
    "mobile": "9668692406",
    "dob": "1999-05-11",
    "district": "Jagatsinghpur",
    "regNoSuffix": "0635"
  },
  {
    "registrationNumber": "KOP/2026/08/0636",
    "docId": "KOP-2026-08-0636",
    "name": "RANJITA SARANGI",
    "mobile": "6371730261",
    "dob": "1994-12-28",
    "district": "Nuapada",
    "regNoSuffix": "0636"
  },
  {
    "registrationNumber": "KOP/2026/08/0637",
    "docId": "KOP-2026-08-0637",
    "name": "BHUPENDRA KUMAR NAIK",
    "mobile": "8249450037",
    "dob": "1987-11-24",
    "district": "Kalahandi",
    "regNoSuffix": "0637"
  },
  {
    "registrationNumber": "KOP/2026/08/0638",
    "docId": "KOP-2026-08-0638",
    "name": "PREMCHANDA MEHER",
    "mobile": "7749957946",
    "dob": "1997-07-12",
    "district": "Nuapada",
    "regNoSuffix": "0638"
  },
  {
    "registrationNumber": "KOP/2026/08/0639",
    "docId": "KOP-2026-08-0639",
    "name": "BANITA ROUT",
    "mobile": "7735788829",
    "dob": "2007-01-25",
    "district": "Nuapada",
    "regNoSuffix": "0639"
  },
  {
    "registrationNumber": "KOP/2026/08/0640",
    "docId": "KOP-2026-08-0640",
    "name": "GAYATRI SWAIN",
    "mobile": "8454966827",
    "dob": "1990-05-20",
    "district": "Ganjam",
    "regNoSuffix": "0640"
  },
  {
    "registrationNumber": "KOP/2026/08/0641",
    "docId": "KOP-2026-08-0641",
    "name": "LAXMIPRIYA BAG",
    "mobile": "9827708840",
    "dob": "1993-11-27",
    "district": "Nuapada",
    "regNoSuffix": "0641"
  },
  {
    "registrationNumber": "KOP/2026/08/0642",
    "docId": "KOP-2026-08-0642",
    "name": "SUMAN BEHERA",
    "mobile": "9407656011",
    "dob": "2000-04-05",
    "district": "Balangir",
    "regNoSuffix": "0642"
  },
  {
    "registrationNumber": "KOP/2026/08/0643",
    "docId": "KOP-2026-08-0643",
    "name": "TIKESWAR BEHERA",
    "mobile": "9078396291",
    "dob": "2001-11-11",
    "district": "Balangir",
    "regNoSuffix": "0643"
  },
  {
    "registrationNumber": "KOP/2026/08/0644",
    "docId": "KOP-2026-08-0644",
    "name": "NIHAR RANJAN MEHER",
    "mobile": "7077664145",
    "dob": "2000-01-03",
    "district": "Nuapada",
    "regNoSuffix": "0644"
  },
  {
    "registrationNumber": "KOP/2026/08/0645",
    "docId": "KOP-2026-08-0645",
    "name": "SIVA BISOYI",
    "mobile": "7504533298",
    "dob": "1995-05-12",
    "district": "Ganjam",
    "regNoSuffix": "0645"
  },
  {
    "registrationNumber": "KOP/2026/08/0646",
    "docId": "KOP-2026-08-0646",
    "name": "MANOJ KUMAR SAHU",
    "mobile": "8847845305",
    "dob": "2003-03-15",
    "district": "Nuapada",
    "regNoSuffix": "0646"
  },
  {
    "registrationNumber": "KOP/2026/08/0647",
    "docId": "KOP-2026-08-0647",
    "name": "TAPASWINI NAHAK",
    "mobile": "9668836244",
    "dob": "1994-03-25",
    "district": "Ganjam",
    "regNoSuffix": "0647"
  },
  {
    "registrationNumber": "KOP/2026/08/0648",
    "docId": "KOP-2026-08-0648",
    "name": "CHITRASEN PATEL",
    "mobile": "8114922667",
    "dob": "1993-06-17",
    "district": "Balangir",
    "regNoSuffix": "0648"
  },
  {
    "registrationNumber": "KOP/2026/08/0649",
    "docId": "KOP-2026-08-0649",
    "name": "PRANATI NIAL",
    "mobile": "8926303415",
    "dob": "1994-10-07",
    "district": "Nuapada",
    "regNoSuffix": "0649"
  },
  {
    "registrationNumber": "KOP/2026/08/0650",
    "docId": "KOP-2026-08-0650",
    "name": "SARITA NAHAK",
    "mobile": "7735223282",
    "dob": "1999-04-15",
    "district": "Ganjam",
    "regNoSuffix": "0650"
  },
  {
    "registrationNumber": "KOP/2026/08/0651",
    "docId": "KOP-2026-08-0651",
    "name": "RADHA KRISHNA BEHERA",
    "mobile": "9556865327",
    "dob": "1988-03-06",
    "district": "Balangir",
    "regNoSuffix": "0651"
  },
  {
    "registrationNumber": "KOP/2026/08/0652",
    "docId": "KOP-2026-08-0652",
    "name": "SIBAKANTA NAG",
    "mobile": "7077208586",
    "dob": "1996-07-01",
    "district": "Balangir",
    "regNoSuffix": "0652"
  },
  {
    "registrationNumber": "KOP/2026/08/0653",
    "docId": "KOP-2026-08-0653",
    "name": "YUVRAJ KARUAN",
    "mobile": "7854939746",
    "dob": "0007-06-12",
    "district": "Nuapada",
    "regNoSuffix": "0653"
  },
  {
    "registrationNumber": "KOP/2026/08/0654",
    "docId": "KOP-2026-08-0654",
    "name": "SABYASACHI SABAR",
    "mobile": "7682034490",
    "dob": "1999-01-11",
    "district": "Nuapada",
    "regNoSuffix": "0654"
  },
  {
    "registrationNumber": "KOP/2026/08/0655",
    "docId": "KOP-2026-08-0655",
    "name": "MAHENDRA SAHU",
    "mobile": "7681852273",
    "dob": "2000-05-29",
    "district": "Balangir",
    "regNoSuffix": "0655"
  },
  {
    "registrationNumber": "KOP/2026/08/0656",
    "docId": "KOP-2026-08-0656",
    "name": "ADITYA KUMAR MAJHI",
    "mobile": "7077472310",
    "dob": "2002-01-24",
    "district": "Nuapada",
    "regNoSuffix": "0656"
  },
  {
    "registrationNumber": "KOP/2026/08/0657",
    "docId": "KOP-2026-08-0657",
    "name": "RAHIMA PANDEY",
    "mobile": "8928261314",
    "dob": "1996-08-06",
    "district": "Nuapada",
    "regNoSuffix": "0657"
  },
  {
    "registrationNumber": "KOP/2026/08/0658",
    "docId": "KOP-2026-08-0658",
    "name": "PREMASILA PODH",
    "mobile": "8917564330",
    "dob": "1995-06-25",
    "district": "Nuapada",
    "regNoSuffix": "0658"
  },
  {
    "registrationNumber": "KOP/2026/08/0659",
    "docId": "KOP-2026-08-0659",
    "name": "MISHA DEB PUNJI",
    "mobile": "7735371805",
    "dob": "2002-08-29",
    "district": "Balangir",
    "regNoSuffix": "0659"
  },
  {
    "registrationNumber": "KOP/2026/08/0660",
    "docId": "KOP-2026-08-0660",
    "name": "BABLU PUTEL",
    "mobile": "8018310142",
    "dob": "2002-05-21",
    "district": "Balangir",
    "regNoSuffix": "0660"
  },
  {
    "registrationNumber": "KOP/2026/08/0661",
    "docId": "KOP-2026-08-0661",
    "name": "PINTU MAJHI",
    "mobile": "6372294615",
    "dob": "2006-10-21",
    "district": "Nuapada",
    "regNoSuffix": "0661"
  },
  {
    "registrationNumber": "KOP/2026/08/0662",
    "docId": "KOP-2026-08-0662",
    "name": "KARPURI  SAHU",
    "mobile": "7656986227",
    "dob": "2001-03-22",
    "district": "Nuapada",
    "regNoSuffix": "0662"
  },
  {
    "registrationNumber": "KOP/2026/08/0663",
    "docId": "KOP-2026-08-0663",
    "name": "RAJESH KU  SAHU",
    "mobile": "8249495357",
    "dob": "1991-06-15",
    "district": "Nuapada",
    "regNoSuffix": "0663"
  },
  {
    "registrationNumber": "KOP/2026/08/0664",
    "docId": "KOP-2026-08-0664",
    "name": "PRABIN KUMAR  SINGH DEO",
    "mobile": "7064037287",
    "dob": "1994-10-11",
    "district": "Nuapada",
    "regNoSuffix": "0664"
  },
  {
    "registrationNumber": "KOP/2026/08/0665",
    "docId": "KOP-2026-08-0665",
    "name": "SANJANA  ROUT",
    "mobile": "7735198365",
    "dob": "2006-09-06",
    "district": "Nuapada",
    "regNoSuffix": "0665"
  },
  {
    "registrationNumber": "KOP/2026/08/0666",
    "docId": "KOP-2026-08-0666",
    "name": "LAXMAN NAG",
    "mobile": "9777114267",
    "dob": "1997-05-03",
    "district": "Boudh",
    "regNoSuffix": "0666"
  },
  {
    "registrationNumber": "KOP/2026/08/0667",
    "docId": "KOP-2026-08-0667",
    "name": "MADHUSMITA  PANDA",
    "mobile": "9861107068",
    "dob": "2001-03-09",
    "district": "Nuapada",
    "regNoSuffix": "0667"
  },
  {
    "registrationNumber": "KOP/2026/08/0668",
    "docId": "KOP-2026-08-0668",
    "name": "RINKI MAHAKUD",
    "mobile": "9668212172",
    "dob": "2005-04-04",
    "district": "Boudh",
    "regNoSuffix": "0668"
  },
  {
    "registrationNumber": "KOP/2026/08/0669",
    "docId": "KOP-2026-08-0669",
    "name": "TULSE  MAJHI",
    "mobile": "8249859181",
    "dob": "1997-06-15",
    "district": "Balangir",
    "regNoSuffix": "0669"
  },
  {
    "registrationNumber": "KOP/2026/08/0670",
    "docId": "KOP-2026-08-0670",
    "name": "NITU SAHU",
    "mobile": "9861087563",
    "dob": "1999-05-11",
    "district": "Boudh",
    "regNoSuffix": "0670"
  },
  {
    "registrationNumber": "KOP/2026/08/0671",
    "docId": "KOP-2026-08-0671",
    "name": "SARITA  DASH",
    "mobile": "8984875989",
    "dob": "1997-05-22",
    "district": "Nuapada",
    "regNoSuffix": "0671"
  },
  {
    "registrationNumber": "KOP/2026/08/0672",
    "docId": "KOP-2026-08-0672",
    "name": "BHOLESWAR MEHER",
    "mobile": "8658939119",
    "dob": "2006-10-29",
    "district": "Balangir",
    "regNoSuffix": "0672"
  },
  {
    "registrationNumber": "KOP/2026/08/0673",
    "docId": "KOP-2026-08-0673",
    "name": "JAGJIBAN  NAG",
    "mobile": "9777623507",
    "dob": "1988-05-08",
    "district": "Balangir",
    "regNoSuffix": "0673"
  },
  {
    "registrationNumber": "KOP/2026/08/0674",
    "docId": "KOP-2026-08-0674",
    "name": "MALAYA RANJAN MAJHI",
    "mobile": "8144070752",
    "dob": "2006-01-20",
    "district": "Nuapada",
    "regNoSuffix": "0674"
  },
  {
    "registrationNumber": "KOP/2026/08/0675",
    "docId": "KOP-2026-08-0675",
    "name": "CHUDAMANI  KISHAN",
    "mobile": "9938636040",
    "dob": "1999-05-14",
    "district": "Balangir",
    "regNoSuffix": "0675"
  },
  {
    "registrationNumber": "KOP/2026/08/0676",
    "docId": "KOP-2026-08-0676",
    "name": "LALIT SAND",
    "mobile": "6372340624",
    "dob": "2001-10-05",
    "district": "Nuapada",
    "regNoSuffix": "0676"
  },
  {
    "registrationNumber": "KOP/2026/08/0677",
    "docId": "KOP-2026-08-0677",
    "name": "YUGAL KISHORE  RANA",
    "mobile": "7894395671",
    "dob": "2001-04-03",
    "district": "Nuapada",
    "regNoSuffix": "0677"
  },
  {
    "registrationNumber": "KOP/2026/08/0678",
    "docId": "KOP-2026-08-0678",
    "name": "SUNIL ROUT",
    "mobile": "8456979925",
    "dob": "2004-06-09",
    "district": "Nuapada",
    "regNoSuffix": "0678"
  },
  {
    "registrationNumber": "KOP/2026/08/0679",
    "docId": "KOP-2026-08-0679",
    "name": "SHIBESWARI AGNIHOTRI",
    "mobile": "7848904656",
    "dob": "2002-03-15",
    "district": "Nuapada",
    "regNoSuffix": "0679"
  },
  {
    "registrationNumber": "KOP/2026/08/0680",
    "docId": "KOP-2026-08-0680",
    "name": "BHAJAMANA  SAND",
    "mobile": "6303659378",
    "dob": "1998-01-07",
    "district": "Nuapada",
    "regNoSuffix": "0680"
  },
  {
    "registrationNumber": "KOP/2026/08/0681",
    "docId": "KOP-2026-08-0681",
    "name": "BIDHURI MAHANANDA",
    "mobile": "8249884300",
    "dob": "1996-08-04",
    "district": "Balangir",
    "regNoSuffix": "0681"
  },
  {
    "registrationNumber": "KOP/2026/08/0682",
    "docId": "KOP-2026-08-0682",
    "name": "TEJASWINI  ADA",
    "mobile": "8926175306",
    "dob": "2003-04-23",
    "district": "Balangir",
    "regNoSuffix": "0682"
  },
  {
    "registrationNumber": "KOP/2026/08/0683",
    "docId": "KOP-2026-08-0683",
    "name": "SIDHARTHA  BHATI",
    "mobile": "7750990191",
    "dob": "1996-06-30",
    "district": "Balangir",
    "regNoSuffix": "0683"
  },
  {
    "registrationNumber": "KOP/2026/08/0684",
    "docId": "KOP-2026-08-0684",
    "name": "PRIYANKA  SUNA",
    "mobile": "7328007999",
    "dob": "1997-08-03",
    "district": "Balangir",
    "regNoSuffix": "0684"
  },
  {
    "registrationNumber": "KOP/2026/08/0685",
    "docId": "KOP-2026-08-0685",
    "name": "LIKHERAM  BEHERA",
    "mobile": "8917699032",
    "dob": "1990-07-01",
    "district": "Balangir",
    "regNoSuffix": "0685"
  },
  {
    "registrationNumber": "KOP/2026/08/0686",
    "docId": "KOP-2026-08-0686",
    "name": "LAKSHYESWAR SAHU",
    "mobile": "8260717177",
    "dob": "2001-06-18",
    "district": "Balangir",
    "regNoSuffix": "0686"
  },
  {
    "registrationNumber": "KOP/2026/08/0687",
    "docId": "KOP-2026-08-0687",
    "name": "DOLY BAG",
    "mobile": "9337354437",
    "dob": "2004-06-20",
    "district": "Balangir",
    "regNoSuffix": "0687"
  },
  {
    "registrationNumber": "KOP/2026/08/0688",
    "docId": "KOP-2026-08-0688",
    "name": "RINKY SAHU",
    "mobile": "6371740068",
    "dob": "1999-03-18",
    "district": "Balangir",
    "regNoSuffix": "0688"
  },
  {
    "registrationNumber": "KOP/2026/08/0690",
    "docId": "KOP-2026-08-0690",
    "name": "NITU DANDASENA",
    "mobile": "9937076932",
    "dob": "1997-04-27",
    "district": "Balangir",
    "regNoSuffix": "0690"
  },
  {
    "registrationNumber": "KOP/2026/08/0691",
    "docId": "KOP-2026-08-0691",
    "name": "RASHMITA RAUT",
    "mobile": "9337534252",
    "dob": "2004-12-12",
    "district": "Nuapada",
    "regNoSuffix": "0691"
  },
  {
    "registrationNumber": "KOP/2026/08/0692",
    "docId": "KOP-2026-08-0692",
    "name": "NOUKESHI NAG",
    "mobile": "7855083345",
    "dob": "2002-03-11",
    "district": "Balangir",
    "regNoSuffix": "0692"
  },
  {
    "registrationNumber": "KOP/2026/08/0693",
    "docId": "KOP-2026-08-0693",
    "name": "CHUMKI PUTEL",
    "mobile": "9937421378",
    "dob": "2005-04-10",
    "district": "Balangir",
    "regNoSuffix": "0693"
  },
  {
    "registrationNumber": "KOP/2026/08/0694",
    "docId": "KOP-2026-08-0694",
    "name": "ALOK KUMAR BAG",
    "mobile": "8260270066",
    "dob": "2000-03-12",
    "district": "Balangir",
    "regNoSuffix": "0694"
  },
  {
    "registrationNumber": "KOP/2026/08/0695",
    "docId": "KOP-2026-08-0695",
    "name": "SHAMUKA BAG",
    "mobile": "9078767848",
    "dob": "1993-11-08",
    "district": "Balangir",
    "regNoSuffix": "0695"
  },
  {
    "registrationNumber": "KOP/2026/08/0696",
    "docId": "KOP-2026-08-0696",
    "name": "DHIROJ PUTEL",
    "mobile": "7854078566",
    "dob": "2005-11-04",
    "district": "Kalahandi",
    "regNoSuffix": "0696"
  },
  {
    "registrationNumber": "HD/KOP/2026/0697",
    "docId": "HD-KOP-2026-0697",
    "name": "NIBEDITA DAS",
    "mobile": "6372688329",
    "dob": "2000-01-01",
    "district": "N/A",
    "regNoSuffix": "0697"
  },
  {
    "registrationNumber": "HD/KOP/2026/0698",
    "docId": "HD-KOP-2026-0698",
    "name": "MAUSAM DAS",
    "mobile": "9556443052",
    "dob": "2000-01-01",
    "district": "N/A",
    "regNoSuffix": "0698"
  },
  {
    "registrationNumber": "HD/KOP/2026/0699",
    "docId": "HD-KOP-2026-0699",
    "name": "CHINMAYA KUMAR DAS",
    "mobile": "7008103588",
    "dob": "2000-01-01",
    "district": "N/A",
    "regNoSuffix": "0699"
  },
  {
    "registrationNumber": "HD/KOP/2026/0700",
    "docId": "HD-KOP-2026-0700",
    "name": "JITENDRA KUMAR DAS",
    "mobile": "9556939353",
    "dob": "2000-01-01",
    "district": "N/A",
    "regNoSuffix": "0700"
  },
  {
    "registrationNumber": "HD/KOP/2026/0701",
    "docId": "HD-KOP-2026-0701",
    "name": "PARTHARAJ GOPAL",
    "mobile": "7735042501",
    "dob": "2000-01-01",
    "district": "N/A",
    "regNoSuffix": "0701"
  },
  {
    "registrationNumber": "HD/KOP/2026/0702",
    "docId": "HD-KOP-2026-0702",
    "name": "MANIS DAS",
    "mobile": "6371270089",
    "dob": "2000-01-01",
    "district": "N/A",
    "regNoSuffix": "0702"
  },
  {
    "registrationNumber": "HD/KOP/2026/0703",
    "docId": "HD-KOP-2026-0703",
    "name": "RAKESH KUMAR DAS",
    "mobile": "9861562170",
    "dob": "2000-01-01",
    "district": "N/A",
    "regNoSuffix": "0703"
  },
  {
    "registrationNumber": "HD/KOP/2026/0704",
    "docId": "HD-KOP-2026-0704",
    "name": "SANGRAM KESHARI DAS",
    "mobile": "7974925018",
    "dob": "2000-01-01",
    "district": "N/A",
    "regNoSuffix": "0704"
  },
  {
    "registrationNumber": "HD/KOP/2026/0705",
    "docId": "HD-KOP-2026-0705",
    "name": "BAISALI DAS",
    "mobile": "9348255218",
    "dob": "2000-01-01",
    "district": "N/A",
    "regNoSuffix": "0705"
  },
  {
    "registrationNumber": "HD/KOP/2026/0706",
    "docId": "HD-KOP-2026-0706",
    "name": "SUSANTA CHANDI",
    "mobile": "7750887427",
    "dob": "2000-01-01",
    "district": "N/A",
    "regNoSuffix": "0706"
  },
  {
    "registrationNumber": "HD/KOP/2026/0707",
    "docId": "HD-KOP-2026-0707",
    "name": "CHAMPULAL DANDASENA",
    "mobile": "6371382046",
    "dob": "2000-01-01",
    "district": "N/A",
    "regNoSuffix": "0707"
  },
  {
    "registrationNumber": "HD/KOP/2026/0708",
    "docId": "HD-KOP-2026-0708",
    "name": "JAGNYESH KU. DANDASENA",
    "mobile": "7854819143",
    "dob": "2000-01-01",
    "district": "N/A",
    "regNoSuffix": "0708"
  },
  {
    "registrationNumber": "HD/KOP/2026/0709",
    "docId": "HD-KOP-2026-0709",
    "name": "BABI JAGAT",
    "mobile": "9827203237",
    "dob": "2000-01-01",
    "district": "N/A",
    "regNoSuffix": "0709"
  },
  {
    "registrationNumber": "HD/KOP/2026/0710",
    "docId": "HD-KOP-2026-0710",
    "name": "DIBYA SINGH SISI",
    "mobile": "7415997776",
    "dob": "2000-01-01",
    "district": "N/A",
    "regNoSuffix": "0710"
  },
  {
    "registrationNumber": "HD/KOP/2026/0711",
    "docId": "HD-KOP-2026-0711",
    "name": "SARADANANDA PANIGRAHI",
    "mobile": "7894018749",
    "dob": "2000-01-01",
    "district": "N/A",
    "regNoSuffix": "0711"
  },
  {
    "registrationNumber": "HD/KOP/2026/0712",
    "docId": "HD-KOP-2026-0712",
    "name": "DILAMANI KATA",
    "mobile": "8260041707",
    "dob": "2000-01-01",
    "district": "N/A",
    "regNoSuffix": "0712"
  },
  {
    "registrationNumber": "HD/KOP/2026/0713",
    "docId": "HD-KOP-2026-0713",
    "name": "HITESH JAGAT",
    "mobile": "7894555437",
    "dob": "2000-01-01",
    "district": "N/A",
    "regNoSuffix": "0713"
  },
  {
    "registrationNumber": "HD/KOP/2026/0714",
    "docId": "HD-KOP-2026-0714",
    "name": "MITA BARIK",
    "mobile": "9078009693",
    "dob": "2000-01-01",
    "district": "N/A",
    "regNoSuffix": "0714"
  },
  {
    "registrationNumber": "HD/KOP/2026/0715",
    "docId": "HD-KOP-2026-0715",
    "name": "BABI BEHERA",
    "mobile": "6372523351",
    "dob": "2000-01-01",
    "district": "N/A",
    "regNoSuffix": "0715"
  },
  {
    "registrationNumber": "HD/KOP/2026/0716",
    "docId": "HD-KOP-2026-0716",
    "name": "DHARMENDRA DAS",
    "mobile": "9937288473",
    "dob": "2000-01-01",
    "district": "N/A",
    "regNoSuffix": "0716"
  },
  {
    "registrationNumber": "HD/KOP/2026/0717",
    "docId": "HD-KOP-2026-0717",
    "name": "NIRUPAMA DASH",
    "mobile": "9348193269",
    "dob": "2000-01-01",
    "district": "N/A",
    "regNoSuffix": "0717"
  },
  {
    "registrationNumber": "HD/KOP/2026/0718",
    "docId": "HD-KOP-2026-0718",
    "name": "SATYABRATA DASH",
    "mobile": "6372993150",
    "dob": "2000-01-01",
    "district": "N/A",
    "regNoSuffix": "0718"
  },
  {
    "registrationNumber": "HD/KOP/2026/0719",
    "docId": "HD-KOP-2026-0719",
    "name": "YASOBANTA MEHER",
    "mobile": "7077212183",
    "dob": "2000-01-01",
    "district": "N/A",
    "regNoSuffix": "0719"
  },
  {
    "registrationNumber": "HD/KOP/2026/0720",
    "docId": "HD-KOP-2026-0720",
    "name": "SWATI DASH",
    "mobile": "6370878525",
    "dob": "2000-01-01",
    "district": "N/A",
    "regNoSuffix": "0720"
  },
  {
    "registrationNumber": "HD/KOP/2026/0721",
    "docId": "HD-KOP-2026-0721",
    "name": "PAPAN MEHER",
    "mobile": "8658869922",
    "dob": "2000-01-01",
    "district": "N/A",
    "regNoSuffix": "0721"
  },
  {
    "registrationNumber": "HD/KOP/2026/0722",
    "docId": "HD-KOP-2026-0722",
    "name": "JHUNU DAS",
    "mobile": "8458005996",
    "dob": "2000-01-01",
    "district": "N/A",
    "regNoSuffix": "0722"
  },
  {
    "registrationNumber": "HD/KOP/2026/0723",
    "docId": "HD-KOP-2026-0723",
    "name": "GYANA RANJAN DASH",
    "mobile": "9668899699",
    "dob": "2000-01-01",
    "district": "N/A",
    "regNoSuffix": "0723"
  },
  {
    "registrationNumber": "HD/KOP/2026/0724",
    "docId": "HD-KOP-2026-0724",
    "name": "JYOTI RANJAN DASH",
    "mobile": "9668822791",
    "dob": "2000-01-01",
    "district": "N/A",
    "regNoSuffix": "0724"
  },
  {
    "registrationNumber": "HD/KOP/2026/0725",
    "docId": "HD-KOP-2026-0725",
    "name": "PRATEBHA SAHU",
    "mobile": "7749022234",
    "dob": "2000-01-01",
    "district": "N/A",
    "regNoSuffix": "0725"
  },
  {
    "registrationNumber": "HD/KOP/2026/0726",
    "docId": "HD-KOP-2026-0726",
    "name": "ANJANA PATEL",
    "mobile": "9337294314",
    "dob": "2000-01-01",
    "district": "N/A",
    "regNoSuffix": "0726"
  },
  {
    "registrationNumber": "HD/KOP/2026/0727",
    "docId": "HD-KOP-2026-0727",
    "name": "PIYUSH RANJAN MISHRA",
    "mobile": "9337209262",
    "dob": "2000-01-01",
    "district": "N/A",
    "regNoSuffix": "0727"
  },
  {
    "registrationNumber": "HD/KOP/2026/0728",
    "docId": "HD-KOP-2026-0728",
    "name": "ASHIS KU. PATEL",
    "mobile": "9658855590",
    "dob": "2000-01-01",
    "district": "N/A",
    "regNoSuffix": "0728"
  },
  {
    "registrationNumber": "HD/KOP/2026/0729",
    "docId": "HD-KOP-2026-0729",
    "name": "BIKASH RANJAN PATEL",
    "mobile": "9178578205",
    "dob": "2000-01-01",
    "district": "N/A",
    "regNoSuffix": "0729"
  },
  {
    "registrationNumber": "HD/KOP/2026/0730",
    "docId": "HD-KOP-2026-0730",
    "name": "RANJAN PATEL",
    "mobile": "9777149689",
    "dob": "2000-01-01",
    "district": "N/A",
    "regNoSuffix": "0730"
  },
  {
    "registrationNumber": "HD/KOP/2026/0731",
    "docId": "HD-KOP-2026-0731",
    "name": "ANIL PATEL",
    "mobile": "8455897830",
    "dob": "2000-01-01",
    "district": "N/A",
    "regNoSuffix": "0731"
  },
  {
    "registrationNumber": "HD/KOP/2026/0732",
    "docId": "HD-KOP-2026-0732",
    "name": "DEPTIMAYEE PATEL",
    "mobile": "6371131933",
    "dob": "2000-01-01",
    "district": "N/A",
    "regNoSuffix": "0732"
  },
  {
    "registrationNumber": "HD/KOP/2026/0733",
    "docId": "HD-KOP-2026-0733",
    "name": "RANJAN KU. PATEL",
    "mobile": "9178981373",
    "dob": "2000-01-01",
    "district": "N/A",
    "regNoSuffix": "0733"
  },
  {
    "registrationNumber": "HD/KOP/2026/0734",
    "docId": "HD-KOP-2026-0734",
    "name": "PRITAM PATEL",
    "mobile": "6370767023",
    "dob": "2000-01-01",
    "district": "N/A",
    "regNoSuffix": "0734"
  },
  {
    "registrationNumber": "HD/KOP/2026/0735",
    "docId": "HD-KOP-2026-0735",
    "name": "ASHISH SAHU",
    "mobile": "7894755849",
    "dob": "2000-01-01",
    "district": "N/A",
    "regNoSuffix": "0735"
  },
  {
    "registrationNumber": "HD/KOP/2026/0736",
    "docId": "HD-KOP-2026-0736",
    "name": "SOURANGA SAHU",
    "mobile": "6370024050",
    "dob": "2000-01-01",
    "district": "N/A",
    "regNoSuffix": "0736"
  },
  {
    "registrationNumber": "HD/KOP/2026/0737",
    "docId": "HD-KOP-2026-0737",
    "name": "CHINMAYA GADTIA",
    "mobile": "7978029211",
    "dob": "2000-01-01",
    "district": "N/A",
    "regNoSuffix": "0737"
  },
  {
    "registrationNumber": "HD/KOP/2026/0738",
    "docId": "HD-KOP-2026-0738",
    "name": "BABITA DASH",
    "mobile": "9777468130",
    "dob": "2000-01-01",
    "district": "N/A",
    "regNoSuffix": "0738"
  },
  {
    "registrationNumber": "HD/KOP/2026/0739",
    "docId": "HD-KOP-2026-0739",
    "name": "JYOSHNA BHOI",
    "mobile": "9938111919",
    "dob": "2000-01-01",
    "district": "N/A",
    "regNoSuffix": "0739"
  },
  {
    "registrationNumber": "HD/KOP/2026/0740",
    "docId": "HD-KOP-2026-0740",
    "name": "JAGYANSINI BHOI",
    "mobile": "8144440631",
    "dob": "2000-01-01",
    "district": "N/A",
    "regNoSuffix": "0740"
  },
  {
    "registrationNumber": "HD/KOP/2026/0741",
    "docId": "HD-KOP-2026-0741",
    "name": "DOLAMANI KUANR",
    "mobile": "7750862589",
    "dob": "2000-01-01",
    "district": "N/A",
    "regNoSuffix": "0741"
  },
  {
    "registrationNumber": "HD/KOP/2026/0742",
    "docId": "HD-KOP-2026-0742",
    "name": "PRIYANKA MAHAPATRA",
    "mobile": "9938210119",
    "dob": "2000-01-01",
    "district": "N/A",
    "regNoSuffix": "0742"
  },
  {
    "registrationNumber": "HD/KOP/2026/0743",
    "docId": "HD-KOP-2026-0743",
    "name": "PRIYANKA NAYAK",
    "mobile": "7077637170",
    "dob": "2000-01-01",
    "district": "N/A",
    "regNoSuffix": "0743"
  },
  {
    "registrationNumber": "HD/KOP/2026/0744",
    "docId": "HD-KOP-2026-0744",
    "name": "SUDESHNA NAYAK",
    "mobile": "9078758389",
    "dob": "2000-01-01",
    "district": "N/A",
    "regNoSuffix": "0744"
  },
  {
    "registrationNumber": "HD/KOP/2026/0745",
    "docId": "HD-KOP-2026-0745",
    "name": "DEBASIS MAHAPATRA",
    "mobile": "9777400205",
    "dob": "2000-01-01",
    "district": "N/A",
    "regNoSuffix": "0745"
  },
  {
    "registrationNumber": "HD/KOP/2026/0746",
    "docId": "HD-KOP-2026-0746",
    "name": "JAGABANTI BARIHA",
    "mobile": "9556795389",
    "dob": "2000-01-01",
    "district": "N/A",
    "regNoSuffix": "0746"
  },
  {
    "registrationNumber": "HD/KOP/2026/0747",
    "docId": "HD-KOP-2026-0747",
    "name": "SIDDHARTHA DAS",
    "mobile": "9668041621",
    "dob": "2000-01-01",
    "district": "N/A",
    "regNoSuffix": "0747"
  },
  {
    "registrationNumber": "HD/KOP/2026/0748",
    "docId": "HD-KOP-2026-0748",
    "name": "ASIS PATEL",
    "mobile": "9178417787",
    "dob": "2000-01-01",
    "district": "N/A",
    "regNoSuffix": "0748"
  },
  {
    "registrationNumber": "HD/KOP/2026/0749",
    "docId": "HD-KOP-2026-0749",
    "name": "TEJASWAANI DASH",
    "mobile": "7847953820",
    "dob": "2000-01-01",
    "district": "N/A",
    "regNoSuffix": "0749"
  },
  {
    "registrationNumber": "HD/KOP/2026/0750",
    "docId": "HD-KOP-2026-0750",
    "name": "ARATI SAHU",
    "mobile": "8658046934",
    "dob": "2000-01-01",
    "district": "N/A",
    "regNoSuffix": "0750"
  },
  {
    "registrationNumber": "HD/KOP/2026/0751",
    "docId": "HD-KOP-2026-0751",
    "name": "JITENDRA PADHA",
    "mobile": "7894895498",
    "dob": "2000-01-01",
    "district": "N/A",
    "regNoSuffix": "0751"
  },
  {
    "registrationNumber": "HD/KOP/2026/0752",
    "docId": "HD-KOP-2026-0752",
    "name": "SARITA MAHAPATRA",
    "mobile": "7008337166",
    "dob": "2000-01-01",
    "district": "N/A",
    "regNoSuffix": "0752"
  },
  {
    "registrationNumber": "HD/KOP/2026/0753",
    "docId": "HD-KOP-2026-0753",
    "name": "DOLESWAR THAKUR",
    "mobile": "7848873767",
    "dob": "2000-01-01",
    "district": "N/A",
    "regNoSuffix": "0753"
  },
  {
    "registrationNumber": "HD/KOP/2026/0754",
    "docId": "HD-KOP-2026-0754",
    "name": "ARUNA BISWAL",
    "mobile": "9938519808",
    "dob": "2000-01-01",
    "district": "N/A",
    "regNoSuffix": "0754"
  },
  {
    "registrationNumber": "HD/KOP/2026/0755",
    "docId": "HD-KOP-2026-0755",
    "name": "ANANDA PRADHAN",
    "mobile": "8144963858",
    "dob": "2000-01-01",
    "district": "N/A",
    "regNoSuffix": "0755"
  },
  {
    "registrationNumber": "HD/KOP/2026/0756",
    "docId": "HD-KOP-2026-0756",
    "name": "SUBIR KUMAR PADHAN",
    "mobile": "7077211291",
    "dob": "2000-01-01",
    "district": "N/A",
    "regNoSuffix": "0756"
  },
  {
    "registrationNumber": "HD/KOP/2026/0757",
    "docId": "HD-KOP-2026-0757",
    "name": "DEBASISH PUROHIT",
    "mobile": "9827032286",
    "dob": "2000-01-01",
    "district": "N/A",
    "regNoSuffix": "0757"
  },
  {
    "registrationNumber": "HD/KOP/2026/0758",
    "docId": "HD-KOP-2026-0758",
    "name": "JITENDRA KUMAR BAL",
    "mobile": "9348448670",
    "dob": "2000-01-01",
    "district": "N/A",
    "regNoSuffix": "0758"
  },
  {
    "registrationNumber": "KOP/2026/09/0999",
    "docId": "KOP-2026-09-0999",
    "name": "Vishal Thakur",
    "mobile": "0000000000",
    "dob": "1900-01-01",
    "district": "Jajpur",
    "regNoSuffix": "0999"
  }
];

export const TOTAL_REGISTERED_STUDENTS_COUNT = 745;
